import * as e from "zod";
//#region src/generated/schemas.gen.ts
var t = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_404_not_found" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_404_not_found" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, n = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "User Error",
	type: "object",
	required: [
		"message",
		"request_id",
		"status_code",
		"errors"
	],
	additionalProperties: !1,
	properties: {
		message: { type: "string" },
		request_id: {
			type: "string",
			description: "Internal request ID, useful for debugging purposes."
		},
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error" },
		errors: {
			type: ["array", "object"],
			items: { $ref: "#/components/schemas/common_error_user" },
			additionalProperties: { $ref: "#/components/schemas/common_error_user" }
		}
	}
}, r = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Response Status Code - 4xx (Client Error)",
	description: "The request contains bad syntax or cannot be fulfilled",
	type: "integer",
	minimum: 400,
	maximum: 499
}, i = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error" },
		code: { $ref: "#/components/schemas/common_error_user_code" },
		title: { type: "string" },
		message: { type: "string" }
	}
}, a = {
	$schema: "http://json-schema.org/draft-04/schema#",
	anyOf: [{ $ref: "#/components/schemas/common_error_user_code_auth" }, { type: "integer" }]
}, o = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.error.user.code.Auth",
	description: "Authentication and Authorization related error codes",
	type: "integer",
	enum: [
		3e3,
		3001,
		3002,
		3003,
		3004,
		3005,
		3006,
		3007
	],
	oneOf: [
		{
			enum: [3e3],
			title: "AccessDenied",
			description: "Access Denied"
		},
		{
			enum: [3001],
			title: "PermissionDenied",
			description: "Permission Denied"
		},
		{
			enum: [3002],
			title: "SessionTokenNotFound",
			description: "Session Token Not Found"
		},
		{
			enum: [3003],
			title: "LastLoginAttemptFailed",
			description: "Last login attempt failed"
		},
		{
			enum: [3004],
			title: "MaxLoginAttemptsReached",
			description: "Max login attempts reached"
		},
		{
			enum: [3005],
			title: "SessionTokenInvalidated",
			description: "Session Token Invalidated"
		},
		{
			enum: [3006],
			title: "InvalidJwtToken",
			description: "Invalid JWT Token"
		},
		{
			enum: [3007],
			title: "UserNotFoundInAuthcontext",
			description: "User Not Found in Auth Context"
		}
	],
	"x-enum-varnames": [
		"AccessDenied",
		"PermissionDenied",
		"SessionTokenNotFound",
		"LastLoginAttemptFailed",
		"MaxLoginAttemptsReached",
		"SessionTokenInvalidated",
		"InvalidJwtToken",
		"UserNotFoundInAuthcontext"
	],
	"x-enum-descriptions": [
		"Access Denied",
		"Permission Denied",
		"Session Token Not Found",
		"Last login attempt failed",
		"Max login attempts reached",
		"Session Token Invalidated",
		"Invalid JWT Token",
		"User Not Found in Auth Context"
	]
}, s = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [404],
	title: "Not Found",
	description: "Did not find the requested target resource."
}, c = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: { shipments: {
			type: "array",
			description: "A list of Shipment Resources.",
			items: { $ref: "#/components/schemas/shipment_defs_shipment" }
		} }
	} }
}, l = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment resource",
	required: /* @__PURE__ */ "id.parent_id.account_id.shop_id.shipment_type.recipient.sender.status.options.general_settings.pickup.customs_declaration.physical_properties.reference_identifier.transaction_status.drop_off_point.hidden.price.barcode.region.external_provider.external_provider_id.payment_status.carrier_id.platform_id.origin.user_agent.secondary_shipments.collection_contact.multi_collo_main_shipment_id.external_identifier.delayed.delivered.contract_id.created.modified.created_by.modified_by".split("."),
	properties: {
		id: {
			type: "integer",
			format: "int64",
			title: "Shipment ID",
			description: "Unique ID of a Shipment."
		},
		parent_id: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }] },
		account_id: { $ref: "#/components/schemas/account_defs_account_properties_id" },
		shop_id: { $ref: "#/components/schemas/account_defs_shop_properties_id" },
		shipment_type: { $ref: "#/components/schemas/_ref_shipment_type" },
		recipient: {
			allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_recipient" }],
			required: [
				"cc",
				"city",
				"street",
				"person"
			]
		},
		sender: { $ref: "#/components/schemas/shipment_defs_shipment_sender" },
		status: { $ref: "#/components/schemas/shipment_defs_shipment_status" },
		options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
		general_settings: { $ref: "#/components/schemas/_ref_shipment_general_settings" },
		pickup: { $ref: "#/components/schemas/shipment_defs_shipment_pickup" },
		customs_declaration: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/_ref_shipment_customs_declaration" }] },
		physical_properties: { $ref: "#/components/schemas/shipment_defs_shipment_physical_properties" },
		reference_identifier: { $ref: "#/components/schemas/_ref_shipment_reference_identifier" },
		transaction_status: { $ref: "#/components/schemas/_ref_shipment_transaction_status" },
		drop_off_point: { $ref: "#/components/schemas/shipment_defs_shipment_drop_off_point" },
		hidden: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		price: { $ref: "#/components/schemas/_ref_types_money" },
		barcode: {
			type: "string",
			maxLength: 255
		},
		region: {
			type: "string",
			oneOf: [{ pattern: "^[A-Z]{2}$" }, { enum: ["Wereld"] }]
		},
		external_provider: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_display_name" }] },
		external_provider_id: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_id" }] },
		payment_status: { $ref: "#/components/schemas/shipment_defs_shipment_payment_status" },
		carrier_id: { $ref: "#/components/schemas/_ref_types_carrier" },
		platform_id: { $ref: "#/components/schemas/account_defs_platform_properties_id" },
		origin: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_origin_properties_origin" }] },
		user_agent: { $ref: "#/components/schemas/shipment_defs_shipment_origin_properties_user_agent" },
		secondary_shipments: {
			type: "array",
			items: {
				title: "Secondary Shipment resource",
				required: /* @__PURE__ */ "id.parent_id.account_id.shop_id.shipment_type.recipient.sender.status.options.general_settings.pickup.customs_declaration.physical_properties.reference_identifier.transaction_status.drop_off_point.hidden.price.barcode.region.external_provider.external_provider_id.payment_status.carrier_id.platform_id.origin.user_agent.collection_contact.multi_collo_main_shipment_id.external_identifier.delayed.delivered.contract_id.created.modified.created_by.modified_by".split("."),
				properties: {
					id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
					parent_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_parent_id" },
					account_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_account_id" },
					shop_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_shop_id" },
					shipment_type: { $ref: "#/components/schemas/shipment_defs_shipment_properties_shipment_type" },
					recipient: { $ref: "#/components/schemas/shipment_defs_shipment_properties_recipient" },
					sender: { $ref: "#/components/schemas/shipment_defs_shipment_properties_sender" },
					status: { $ref: "#/components/schemas/shipment_defs_shipment_properties_status" },
					options: { $ref: "#/components/schemas/shipment_defs_shipment_properties_options" },
					general_settings: { $ref: "#/components/schemas/shipment_defs_shipment_properties_general_settings" },
					pickup: { $ref: "#/components/schemas/shipment_defs_shipment_properties_pickup" },
					customs_declaration: { $ref: "#/components/schemas/shipment_defs_shipment_properties_customs_declaration" },
					physical_properties: { $ref: "#/components/schemas/shipment_defs_shipment_properties_physical_properties" },
					reference_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_properties_reference_identifier" },
					transaction_status: { $ref: "#/components/schemas/shipment_defs_shipment_properties_transaction_status" },
					drop_off_point: { $ref: "#/components/schemas/shipment_defs_shipment_properties_drop_off_point" },
					hidden: { $ref: "#/components/schemas/shipment_defs_shipment_properties_hidden" },
					price: { $ref: "#/components/schemas/shipment_defs_shipment_properties_price" },
					barcode: { $ref: "#/components/schemas/shipment_defs_shipment_properties_barcode" },
					region: { $ref: "#/components/schemas/shipment_defs_shipment_properties_region" },
					external_provider: { $ref: "#/components/schemas/shipment_defs_shipment_properties_external_provider" },
					external_provider_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_external_provider_id" },
					payment_status: { $ref: "#/components/schemas/shipment_defs_shipment_properties_payment_status" },
					carrier_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_carrier_id" },
					platform_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_platform_id" },
					origin: { $ref: "#/components/schemas/shipment_defs_shipment_properties_origin" },
					user_agent: { $ref: "#/components/schemas/shipment_defs_shipment_properties_user_agent" },
					secondary_shipments: {
						type: ["null", "array"],
						maxItems: 0
					},
					collection_contact: { $ref: "#/components/schemas/shipment_defs_shipment_properties_collection_contact" },
					multi_collo_main_shipment_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_multi_collo_main_shipment_id" },
					external_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_properties_external_identifier" },
					delayed: { $ref: "#/components/schemas/shipment_defs_shipment_properties_delayed" },
					delivered: { $ref: "#/components/schemas/shipment_defs_shipment_properties_delivered" },
					amount: { $ref: "#/components/schemas/shipment_defs_shipment_properties_amount" },
					currency: { $ref: "#/components/schemas/shipment_defs_shipment_properties_currency" },
					contract_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_contract_id" },
					link_consumer_portal: { $ref: "#/components/schemas/shipment_defs_shipment_properties_link_consumer_portal" },
					partner_tracktraces: { $ref: "#/components/schemas/shipment_defs_shipment_properties_partner_tracktraces" },
					pickup_request_number: { $ref: "#/components/schemas/shipment_defs_shipment_properties_pickup_request_number" },
					order_shipment_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_properties_order_shipment_identifier" },
					shipped_items: { $ref: "#/components/schemas/shipment_defs_shipment_properties_shipped_items" },
					created: { $ref: "#/components/schemas/shipment_defs_shipment_properties_created" },
					modified: { $ref: "#/components/schemas/shipment_defs_shipment_properties_modified" },
					created_by: { $ref: "#/components/schemas/shipment_defs_shipment_properties_created_by" },
					modified_by: { $ref: "#/components/schemas/shipment_defs_shipment_properties_modified_by" }
				},
				additionalProperties: !1
			}
		},
		collection_contact: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_contact" }] },
		multi_collo_main_shipment_id: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }] },
		external_identifier: { $ref: "#/components/schemas/shipment_defs_shipment_carrier_properties_external_identifier" },
		delayed: {
			type: "boolean",
			default: !1
		},
		delivered: {
			type: "boolean",
			default: !1
		},
		amount: {
			type: ["integer", "null"],
			format: "int32"
		},
		currency: { oneOf: [{ type: "null" }, { $ref: "#/components/schemas/billing_defs_currency" }] },
		contract_id: {
			type: ["integer", "null"],
			format: "int64"
		},
		link_consumer_portal: {
			type: ["null", "string"],
			oneOf: [{ format: "uri" }, { enum: [""] }]
		},
		partner_tracktraces: { $ref: "#/components/schemas/shipment_defs_shipment_partner_tracktraces" },
		pickup_request_number: { type: ["null", "string"] },
		order_shipment_identifier: {
			type: ["null", "string"],
			format: "uuid",
			maxLength: 36
		},
		shipped_items: {
			type: ["null", "array"],
			items: { $ref: "#/components/schemas/shipment_defs_shipment_shipped_item" }
		},
		created: { $ref: "#/components/schemas/common_defs_timestamps_properties_created" },
		modified: { $ref: "#/components/schemas/common_defs_timestamps_properties_modified" },
		created_by: { $ref: "#/components/schemas/common_defs_timestamps_properties_created_by" },
		modified_by: { $ref: "#/components/schemas/common_defs_timestamps_properties_modified_by" }
	},
	additionalProperties: !1
}, u = {
	type: "integer",
	format: "int64",
	title: "Shipment ID",
	description: "Unique ID of a Shipment.",
	$schema: "http://json-schema.org/draft-04/schema#"
}, ee = {
	title: "Account ID",
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, te = {
	title: "Shop ID",
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, d = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.Type",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8
	],
	oneOf: [
		{
			enum: [1],
			title: "Standard"
		},
		{
			enum: [2],
			title: "Return"
		},
		{
			enum: [3],
			title: "MultiCollo"
		},
		{
			enum: [4],
			title: "LabelPackage"
		},
		{
			enum: [5],
			title: "ReturnErs"
		},
		{
			enum: [6],
			title: "ReturnSpecial"
		},
		{
			enum: [7],
			title: "Express"
		},
		{
			enum: [8],
			title: "Fulfilment"
		}
	],
	"x-enum-varnames": [
		"Standard",
		"Return",
		"MultiCollo",
		"LabelPackage",
		"ReturnErs",
		"ReturnSpecial",
		"Express",
		"Fulfilment"
	]
}, ne = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Recipient",
	allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_sender" }],
	properties: {
		person: {
			maxLength: 50,
			minLength: 1
		},
		company: { maxLength: 50 },
		street: {
			maxLength: 40,
			minLength: 1,
			pattern: "\\D+"
		},
		street_additional_info: { maxLength: 50 },
		number: { maxLength: 8 },
		number_suffix: { maxLength: 6 },
		postal_code: { maxLength: 10 },
		city: {
			maxLength: 35,
			minLength: 1
		},
		state: { maxLength: 2 },
		area: { maxLength: 35 },
		phone: { maxLength: 25 }
	}
}, re = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Sender",
	type: "object",
	required: ["cc"],
	additionalProperties: !1,
	properties: {
		person: { type: "string" },
		company: { type: ["null", "string"] },
		street: { type: "string" },
		street_additional_info: { type: ["null", "string"] },
		number: { type: ["null", "string"] },
		number_suffix: { type: ["null", "string"] },
		postal_code: { type: "string" },
		city: { type: "string" },
		state: { type: "string" },
		cc: { $ref: "#/components/schemas/_ref_types_cc" },
		region: {
			type: ["null", "string"],
			maxLength: 35
		},
		area: { type: "string" },
		phone: { type: ["null", "string"] },
		email: {
			type: ["null", "string"],
			anyOf: [{ format: "email" }, { enum: [null, ""] }]
		},
		secondary_emails: {
			type: ["null", "array"],
			items: { $ref: "#/components/schemas/shipment_defs_shipment_sender_properties_email" }
		},
		box_number: {
			type: ["null", "string"],
			maxLength: 8
		},
		eori_number: { type: "string" },
		vat_number: { type: "string" },
		invalid: { type: "boolean" }
	}
}, ie = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "string",
	maxLength: 2,
	minLength: 2,
	pattern: "^[A-Za-z]{2}$"
}, ae = {
	type: ["null", "string"],
	anyOf: [{ format: "email" }, { enum: [null, ""] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, oe = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.shipment.Status",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19,
		98,
		99,
		100,
		101,
		30,
		31,
		32,
		33,
		34,
		35,
		36,
		37,
		38
	],
	oneOf: [
		{
			enum: [1],
			title: "PendingConcept",
			description: "Pending - Concept\n\nThe Shipment is a concept and not yet registered at the carrier.\n"
		},
		{
			enum: [2],
			title: "PendingRegistered",
			description: "Pending - Registered\n\nThe Shipment has been registered with the carrier, and has been assigned a Track & Trace code.\n"
		},
		{
			enum: [3],
			title: "EnrouteHandedToCarrier",
			description: "En Route - Handed to Carrier\n\nThe Shipment has been handed to the carrier for transport.\n"
		},
		{
			enum: [4],
			title: "EnrouteSorting",
			description: "En Route - Sorting\n\nThe Shipment is being sorted at the carrier's sorting facility.\n"
		},
		{
			enum: [5],
			title: "EnrouteDistribution",
			description: "En Route - Distribution\n\nThe Shipment is being distributed by the carrier to the recipient's address.\n"
		},
		{
			enum: [6],
			title: "DeliveredAtCustoms",
			description: "En Route - Customs\n\nThe Shipment is being processed by customs.\n"
		},
		{
			enum: [7],
			title: "Delivered",
			description: "Delivered - At Recipient\n\nThe Shipment has been delivered to the recipient.\n"
		},
		{
			enum: [8],
			title: "InPickupLocation",
			description: "Delivered - Ready for Pickup\n\nThe Shipment is ready for pickup at a pickup location.\n"
		},
		{
			enum: [9],
			title: "PickedUp",
			description: "Delivered - Picked Up\n\nThe Shipment has been picked up by the recipient at a pickup location.\n"
		},
		{
			enum: [10],
			title: "ReturnShipmentDelivered",
			description: "Delivered - Return Shipment Ready for Pickup\n\nThe Return Shipment is ready to be picked at a pickup location.\n"
		},
		{
			enum: [11],
			title: "ReturnShipmentInPickupLocation",
			description: "Delivered - Return Shipment Picked Up\n\nThe Return Shipment has been picked up by the recipient at a pickup location.\n"
		},
		{
			enum: [12],
			title: "PrintedUnpaidLabel",
			description: "Printed - Unpaid Label\n\nThe label has been printed without postage paid.\n"
		},
		{
			enum: [13],
			title: "Credit",
			description: "Credited\n\nThe Shipment has been credited.\n"
		},
		{
			enum: [14],
			title: "PrintedStamp",
			description: "Printed - Digital Stamp\n\nThe Shipment has been printed with a digital stamp.\n"
		},
		{
			enum: [15],
			title: "PrintedExternalShipment",
			description: "Printed - External Shipment\n\nThe Shipment has been printed with an External Shipment.\n"
		},
		{
			enum: [16],
			title: "Expired",
			description: "Expired\n\nThe Shipment has expired.\n"
		},
		{
			enum: [17],
			title: "Cancelled",
			description: "Cancelled\n\nThe Shipment has been cancelled.\n"
		},
		{
			enum: [18],
			title: "PrintedUntrackedShipment",
			description: "Printed - Untracked Shipment\n\nThe Shipment has been printed with an untracked Shipment.\n"
		},
		{
			enum: [19],
			title: "DeliveredAtAgreedLocation",
			description: "Delivered - At Agreed Location\n\nThe Shipment has been delivered at a privately agreed location.\n"
		},
		{
			enum: [98],
			title: "Inactive",
			description: "Inactive\n\nThe Shipment is inactive.\n"
		},
		{
			enum: [99],
			title: "Deleted",
			description: "Deleted\n\nThe Shipment has been deleted.\n"
		},
		{
			enum: [100],
			title: "CreditRejected",
			description: "Credit - Rejected\n\nThe credit request for the Shipment was rejected.\n"
		},
		{
			enum: [101],
			title: "CreditApproved",
			description: "Credit - Approved\n\nThe credit request for the Shipment was approved.\n"
		},
		{
			enum: [30],
			title: "LegacyPendingConcept",
			description: "(legacy) Pending - Concept"
		},
		{
			enum: [31],
			title: "LegacyPendingRegistered",
			description: "(legacy) Pending - Registered"
		},
		{
			enum: [32],
			title: "LegacyEnrouteHandedToCarrier",
			description: "(legacy) En Route - Handed to Carrier"
		},
		{
			enum: [33],
			title: "LegacyEnrouteSorting",
			description: "(legacy) En Route - Sorting"
		},
		{
			enum: [34],
			title: "LegacyEnrouteDistribution",
			description: "(legacy) En Route - Distribution"
		},
		{
			enum: [35],
			title: "LegacyDeliveredAtCustoms",
			description: "(legacy) En Route - Customs"
		},
		{
			enum: [36],
			title: "LegacyDelivered",
			description: "(legacy) Delivered - At Recipient"
		},
		{
			enum: [37],
			title: "LegacyInPickupLocation",
			description: "(legacy) Delivered - Ready for Pickup"
		},
		{
			enum: [38],
			title: "LegacyPickedUp",
			description: "(legacy) Delivered - Picked Up"
		}
	],
	"x-enum-varnames": /* @__PURE__ */ "PendingConcept.PendingRegistered.EnrouteHandedToCarrier.EnrouteSorting.EnrouteDistribution.DeliveredAtCustoms.Delivered.InPickupLocation.PickedUp.ReturnShipmentDelivered.ReturnShipmentInPickupLocation.PrintedUnpaidLabel.Credit.PrintedStamp.PrintedExternalShipment.Expired.Cancelled.PrintedUntrackedShipment.DeliveredAtAgreedLocation.Inactive.Deleted.CreditRejected.CreditApproved.LegacyPendingConcept.LegacyPendingRegistered.LegacyEnrouteHandedToCarrier.LegacyEnrouteSorting.LegacyEnrouteDistribution.LegacyDeliveredAtCustoms.LegacyDelivered.LegacyInPickupLocation.LegacyPickedUp".split("."),
	"x-enum-descriptions": [
		"The Shipment is a concept and not yet registered at the carrier.",
		"The Shipment has been registered with the carrier, and has been assigned a Track & Trace code.",
		"The Shipment has been handed to the carrier for transport.",
		"The Shipment is being sorted at the carrier's sorting facility.",
		"The Shipment is being distributed by the carrier to the recipient's address",
		"The Shipment is being processed by customs.",
		"The Shipment has been delivered to the recipient.",
		"The Shipment is ready for pickup at a pickup location.",
		"The Shipment has been picked up by the recipient at a pickup location.",
		"The Return Shipment is ready to be picked at a pickup location.",
		"The Return Shipment has been picked up by the recipient at a pickup location.",
		"The label has been printed without postage paid.",
		"The Shipment has been credited.",
		"The Shipment label has been printed as a digital stamp.",
		"A Shipment label has been printed for an External Shipment.",
		"The Shipment has expired.",
		"The Shipment has been canceled.",
		"The Shipment has been printed with an untracked Shipment.",
		"The Shipment has been delivered at a privately agreed location - e.g. in front of the door, under a bush, etc.",
		"The Shipment is inactive.",
		"The Shipment has been deleted.",
		"The credit request for the Shipment was rejected."
	]
}, se = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	allOf: [
		{ $ref: "#/components/schemas/_ref_shipment_options_insurance_max" },
		{ $ref: "#/components/schemas/_ref_shipment_options_options" },
		{ $ref: "#/components/schemas/_ref_shipment_options_package_type_all" },
		{ $ref: "#/components/schemas/_ref_shipment_options_delivery_type_all" },
		{ $ref: "#/components/schemas/_ref_shipment_options_delivery_type_delivery_date" },
		{ $ref: "#/components/schemas/_ref_shipment_options_label_description" }
	]
}, ce = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	allOf: [{ $ref: "#/components/schemas/_ref_shipment_options_insurance" }],
	properties: { insurance: { properties: { amount: { maximum: 25e5 } } } }
}, le = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { insurance: {
		$comment: "insurance currency must be EUR because shipment carriers expect this",
		$ref: "#/components/schemas/_ref_types_price_euro"
	} }
}, ue = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Price with EUR-currency and amount",
	type: "object",
	additionalProperties: !1,
	required: ["amount", "currency"],
	properties: {
		currency: {
			type: "string",
			enum: ["EUR"]
		},
		amount: {
			minimum: 0,
			type: "integer"
		}
	}
}, de = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		age_check: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		cash_on_delivery: { $ref: "#/components/schemas/_ref_types_money" },
		collect: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		cooled_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		extra_assurance: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		fresh_food: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		frozen: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		hide_sender: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		large_format: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		only_recipient: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		priority_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		receipt_code: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		return: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		same_day_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		saturday_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		signature: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		tracked: { $ref: "#/components/schemas/_ref_types_int_boolean" }
	}
}, fe = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.IntBoolean",
	type: "number",
	enum: [0, 1],
	"x-enum-varnames": ["False", "True"]
}, pe = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Money",
	description: "Money amount with currency",
	type: "object",
	required: ["currency", "amount"],
	additionalProperties: !1,
	properties: {
		currency: {
			description: "The currency as uppercase 3-letter ISO 4217 code.",
			type: "string",
			enum: ["", "EUR"]
		},
		amount: {
			description: "The amount in the lowest denomination of the currency, e.g. cents for EUR.",
			oneOf: [{
				type: "integer",
				minimum: 0
			}, {
				type: ["string"],
				pattern: "\\d*"
			}]
		}
	}
}, me = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { package_type: { $ref: "#/components/schemas/_ref_shipment_package_type" } }
}, he = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.PackageType",
	description: "Package Type.",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7
	],
	oneOf: [
		{
			enum: [1],
			title: "Package",
			description: "Regular package.\n"
		},
		{
			enum: [2],
			title: "Mailbox",
			description: "Shipment that fits through a mailbox slot.\n"
		},
		{
			enum: [3],
			title: "Unfranked",
			description: "The label is unpaid meaning that you will need to pay when dropping off the letter/package.\n"
		},
		{
			enum: [4],
			title: "DigitalStamp",
			description: "Digital Stamp\n"
		},
		{
			enum: [5],
			title: "Pallet",
			description: "Pallet\n"
		},
		{
			enum: [6],
			title: "SmallPackage",
			description: "Small Package\n"
		},
		{
			enum: [7],
			title: "Envelope",
			description: "Small and light shipment that fits through a mailbox slot.\n"
		}
	],
	"x-enum-varnames": [
		"Package",
		"Mailbox",
		"Unfranked",
		"DigitalStamp",
		"Pallet",
		"SmallPackage",
		"Envelope"
	],
	"x-enum-descriptions": [
		"Regular package.",
		"Shipment that fits through a mailbox slot.",
		"The label is unpaid meaning that you will need to pay when dropping off the letter/package.",
		"Digital Stamp",
		"Pallet",
		"Small Package",
		"Small and light shipment that fits through a mailbox slot."
	]
}, ge = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { delivery_type: {
		type: ["integer", "null"],
		enum: [
			1,
			2,
			3,
			4,
			5,
			6,
			7,
			8,
			null
		]
	} }
}, _e = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { delivery_date: {
		type: ["string", "null"],
		pattern: "([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})"
	} }
}, ve = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { label_description: {
		type: "string",
		maxLength: 45
	} }
}, ye = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: ["object", "null"],
	properties: {
		save_recipient_address: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		delivery_notification: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		delivery_notification_email: {
			type: "array",
			items: {
				type: "string",
				format: "email"
			}
		},
		disable_auto_detect_pickup: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		printer_identifier: { type: "string" },
		tracktrace: {
			type: "object",
			properties: {
				bcc: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				bcc_email: { $ref: "#/components/schemas/account_defs_contact_properties_email" },
				carrier_email_basic_notification: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				delivery_notification: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				delivery_notification_email: {
					type: "array",
					items: { type: "string" }
				},
				disable_auto_detect_pickup: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				email_on_handed_to_courier: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				from_address_company: { type: "string" },
				from_address_email: {
					type: "string",
					format: "email"
				},
				printer_identifier: { type: "string" },
				save_recipient_address: { $ref: "#/components/schemas/_ref_types_int_boolean" },
				send_track_trace_emails: { $ref: "#/components/schemas/_ref_types_int_boolean" }
			}
		}
	},
	additionalProperties: !1
}, be = {
	type: ["null", "string"],
	maxLength: 255,
	anyOf: [{ enum: [null, ""] }, { format: "email" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, xe = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Pickup Location",
	type: ["null", "object"],
	additionalProperties: !1,
	properties: {
		location_code: { type: "string" },
		location_name: { type: "string" },
		street: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["null", "string"] },
		postal_code: { type: "string" },
		city: { type: "string" },
		cc: {
			type: "string",
			maxLength: 2,
			minLength: 2,
			pattern: "^[A-Z]{2}"
		},
		retail_network_id: { type: "string" }
	}
}, Se = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.CustomsDeclaration",
	type: ["object"],
	required: [
		"contents",
		"weight",
		"items"
	],
	properties: {
		contents: { $ref: "#/components/schemas/shipment_defs_customs_shipment_type" },
		invoice: {
			type: ["string", "null"],
			maxLength: 150
		},
		eori_number: { type: ["string", "null"] },
		vat_number: { type: ["string", "null"] },
		vat_number_uk: { type: ["string", "null"] },
		voec_number: { type: ["string", "null"] },
		weight: {
			type: "integer",
			minimum: 0,
			maximum: 999999999
		},
		items: {
			type: "array",
			minItems: 1,
			maxItems: 100,
			items: { $ref: "#/components/schemas/_ref_shipment_customs_declaration_item" }
		}
	},
	additionalProperties: !1
}, Ce = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.CustomsShipmentType",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5
	],
	oneOf: [
		{
			enum: [1],
			title: "CommercialGoods"
		},
		{
			enum: [2],
			title: "CommercialSample"
		},
		{
			enum: [3],
			title: "Documents"
		},
		{
			enum: [4],
			title: "Gift"
		},
		{
			enum: [5],
			title: "ReturnedGoods"
		}
	],
	"x-enum-varnames": [
		"CommercialGoods",
		"CommercialSample",
		"Documents",
		"Gift",
		"ReturnedGoods"
	]
}, we = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: [
		"description",
		"amount",
		"weight",
		"item_value",
		"classification"
	],
	properties: {
		description: {
			type: "string",
			maxLength: 50
		},
		amount: {
			type: "integer",
			minimum: 1,
			maximum: 99999
		},
		weight: {
			type: "integer",
			minimum: 0,
			maximum: 999999999
		},
		item_value: { $ref: "#/components/schemas/_ref_types_money" },
		classification: { type: "string" },
		country: {
			type: "string",
			oneOf: [{ pattern: "^[A-Z]{2}$" }, { enum: [""] }]
		}
	},
	additionalProperties: !1
}, Te = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Physical Properties",
	type: ["null", "object"],
	properties: {
		weight: { $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_weight" },
		height: { $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_height" },
		width: { $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_width" },
		length: { $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_length" },
		volume: { $ref: "#/components/schemas/_ref_shipment_physical_properties_properties_volume" },
		carrier_weight: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_weight" }, { type: "null" }] },
		carrier_height: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_height" }, { type: "null" }] },
		carrier_width: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_width" }, { type: "null" }] },
		carrier_length: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_length" }, { type: "null" }] },
		carrier_volume: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_physical_properties_properties_volume" }, { type: "null" }] }
	},
	additionalProperties: !1
}, Ee = {
	type: "integer",
	format: "int32",
	minimum: 0,
	maximum: 999999999,
	$schema: "http://json-schema.org/draft-04/schema#"
}, De = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Oe = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, ke = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ae = {
	type: "integer",
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, je = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_physical_properties_properties_weight"
}, Me = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_physical_properties_properties_height"
}, Ne = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_physical_properties_properties_width"
}, Pe = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_physical_properties_properties_length"
}, Fe = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_physical_properties_properties_volume"
}, Ie = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Reference Identifier",
	description: "Arbitrary reference identifier that can be used to identify a shipment.",
	type: [
		"null",
		"integer",
		"string"
	],
	maxLength: 255,
	pattern: "^[^=\\?]*$"
}, Le = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: ["null", "string"],
	enum: [
		null,
		"pending",
		"unpaid",
		"paid"
	]
}, Re = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Drop-Off Point",
	allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_pickup" }],
	required: [
		"location_code",
		"location_name",
		"street",
		"number",
		"postal_code",
		"city"
	]
}, ze = {
	title: "External Provider Display Name",
	type: "string",
	enum: [
		"Facebook",
		"Google",
		"Flespakket.nl",
		"Amazon",
		"Bol.com",
		"MyParcel.nl",
		"Wix",
		"Ecwid",
		"Exact Online DE",
		"Exact Online NL",
		"Etsy"
	],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Be = {
	title: "External Provider ID",
	type: "integer",
	format: "int64",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ve = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Payment Status",
	type: ["null", "string"],
	enum: [
		null,
		"pending",
		"unpaid",
		"paid"
	]
}, He = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.Carrier",
	description: "This enumeration represents the Carriers. The value is the Carrier id.",
	type: "integer",
	format: "int32",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7,
		8,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: [1]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: [2]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: [3]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: [4]
		},
		{
			description: "Instabox",
			title: "Instabox",
			enum: [5]
		},
		{
			description: "DHL",
			title: "DhlCheapCargo",
			enum: [6]
		},
		{
			description: "Bol.com",
			title: "Bol",
			enum: [7]
		},
		{
			description: "UPS",
			title: "Ups",
			enum: [8]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: [9]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: [10]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: [11]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: [12]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: [13]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: [14]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: [15]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: [16]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: [17]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: [18]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: [19]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"Instabox",
		"DhlCheapCargo",
		"Bol",
		"Ups",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"Instabox",
		"DHL",
		"Bol.com",
		"UPS",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring"
	]
}, Ue = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_platform_id"
}, We = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.defs.PlatformId",
	type: "integer",
	format: "int32",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6
	],
	oneOf: [
		{
			enum: [1],
			title: "myparcel"
		},
		{
			enum: [2],
			title: "flespakket"
		},
		{
			enum: [3],
			title: "belgie"
		},
		{
			enum: [4],
			title: "delivery_dutch"
		},
		{
			enum: [5],
			title: "postnl_customer"
		},
		{
			enum: [6],
			title: "italy"
		}
	],
	"x-enum-varnames": [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	]
}, Ge = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ke = {
	type: ["null", "string"],
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, qe = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Je = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_account_properties_id"
}, Ye = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_shop_properties_id"
}, Xe = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_type"
}, Ze = {
	allOf: [{ $ref: "#/components/schemas/shipment_defs_shipment_recipient" }],
	required: [
		"cc",
		"city",
		"street",
		"person"
	],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Qe = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_sender"
}, $e = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_status"
}, et = {
	allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, tt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_general_settings"
}, nt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_pickup"
}, rt = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/_ref_shipment_customs_declaration" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, it = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_physical_properties"
}, at = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_reference_identifier"
}, ot = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_shipment_transaction_status"
}, st = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_drop_off_point"
}, ct = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_types_int_boolean"
}, lt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_types_money"
}, ut = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, dt = {
	type: "string",
	oneOf: [{ pattern: "^[A-Z]{2}$" }, { enum: ["Wereld"] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, ft = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_display_name" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, pt = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_external_provider_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, mt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_payment_status"
}, ht = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/_ref_types_carrier"
}, gt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/account_defs_platform_properties_id"
}, _t = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_origin_properties_origin" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, vt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_origin_properties_user_agent"
}, yt = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_contact" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, bt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Contact",
	type: "object",
	required: [
		"last_name",
		"email",
		"phone",
		"company",
		"street",
		"number",
		"postal_code",
		"city",
		"cc"
	],
	additionalProperties: !1,
	properties: {
		id: {
			type: ["integer"],
			format: "int32"
		},
		gender: {
			type: ["null", "string"],
			maxLength: 3
		},
		first_name: {
			type: ["null", "string"],
			maxLength: 255
		},
		last_name: {
			type: ["null", "string"],
			maxLength: 255
		},
		email: {
			type: ["null", "string"],
			maxLength: 255,
			anyOf: [{ enum: [null, ""] }, { format: "email" }]
		},
		phone: {
			type: ["null", "string"],
			maxLength: 100
		},
		company: {
			type: ["null", "string"],
			maxLength: 255
		},
		street: { $ref: "#/components/schemas/account_defs_location_properties_street" },
		street_additional_info: { $ref: "#/components/schemas/account_defs_location_properties_street_additional_info" },
		number: { $ref: "#/components/schemas/account_defs_location_properties_number" },
		number_suffix: { $ref: "#/components/schemas/account_defs_location_properties_number_suffix" },
		postal_code: { $ref: "#/components/schemas/account_defs_location_properties_postal_code" },
		city: { $ref: "#/components/schemas/account_defs_location_properties_city" },
		cc: { $ref: "#/components/schemas/account_defs_location_properties_cc" },
		region: { $ref: "#/components/schemas/account_defs_location_properties_region" },
		box_number: { $ref: "#/components/schemas/account_defs_location_properties_box_number" }
	}
}, xt = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, St = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ct = {
	type: ["string", "integer"],
	pattern: "\\d+",
	$schema: "http://json-schema.org/draft-04/schema#"
}, wt = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Tt = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Et = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Dt = {
	type: "string",
	pattern: "^[A-Z][A-Z]$",
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ot = {
	type: "string",
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, kt = {
	type: ["null", "string"],
	maxLength: 8,
	$schema: "http://json-schema.org/draft-04/schema#"
}, At = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, jt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_carrier_properties_external_identifier"
}, Mt = {
	title: "Shipment Carrier External Identifier",
	type: ["null", "string"],
	maxLength: 255,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Nt = {
	type: "boolean",
	default: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Pt = {
	type: "boolean",
	default: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ft = {
	type: ["integer", "null"],
	format: "int32",
	$schema: "http://json-schema.org/draft-04/schema#"
}, It = {
	oneOf: [{ type: "null" }, { $ref: "#/components/schemas/billing_defs_currency" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Lt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Currency",
	type: "string",
	maxLength: 3,
	enum: ["", "EUR"]
}, Rt = {
	type: ["integer", "null"],
	format: "int64",
	$schema: "http://json-schema.org/draft-04/schema#"
}, zt = {
	type: ["null", "string"],
	oneOf: [{ format: "uri" }, { enum: [""] }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Bt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/shipment_defs_shipment_partner_tracktraces"
}, Vt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipment Partner Track & Traces",
	type: "array",
	items: {
		type: "object",
		required: ["uri", "barcode"],
		properties: {
			uri: {
				type: "string",
				anyOf: [{ enum: [""] }, { format: "uri" }]
			},
			barcode: { type: "string" }
		}
	}
}, Ht = {
	type: ["null", "string"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Ut = {
	type: ["null", "string"],
	format: "uuid",
	maxLength: 36,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Wt = {
	type: ["null", "array"],
	items: { $ref: "#/components/schemas/shipment_defs_shipment_shipped_item" },
	$schema: "http://json-schema.org/draft-04/schema#"
}, Gt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipped Item",
	type: ["null", "object"],
	properties: {
		quantity: { $ref: "#/components/schemas/order_defs_shipped_item_properties_quantity" },
		order_line_identifier: { $ref: "#/components/schemas/order_defs_shipped_item_properties_order_line_identifier" },
		order_line: { $ref: "#/components/schemas/order_defs_shipped_item_properties_order_line" },
		picklist_identifier: { $ref: "#/components/schemas/order_defs_shipped_item_properties_picklist_identifier" },
		order_identifier: { type: ["null", "string"] }
	},
	additionalProperties: !1
}, Kt = {
	type: ["null", "integer"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, qt = {
	type: ["null", "string"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Jt = {
	type: ["null", "object"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Yt = {
	type: ["null", "string"],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Xt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_created"
}, Zt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_date_and_time"
}, Qt = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.DateAndTime",
	description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n",
	type: "string",
	pattern: "\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\\d|3[0-1]) ([0-1]\\d|2[0-4]):[0-5]\\d(:([0-5]\\d|60)(.\\d+)?)?"
}, $t = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_modified"
}, en = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_date_and_time"
}, tn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_created_by"
}, nn = {
	anyOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_user_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, rn = {
	title: "User ID",
	type: "integer",
	format: "int64",
	$schema: "http://json-schema.org/draft-04/schema#"
}, an = {
	$schema: "http://json-schema.org/draft-04/schema#",
	$ref: "#/components/schemas/common_defs_timestamps_properties_modified_by"
}, on = {
	anyOf: [{ type: "null" }, { $ref: "#/components/schemas/account_defs_user_properties_id" }],
	$schema: "http://json-schema.org/draft-04/schema#"
}, sn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	format: "binary",
	anyOf: [{ contentMediaType: "application/pdf" }, { contentMediaType: "application/vnd.zpl" }]
}, cn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Download URL",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		oneOf: [
			{
				additionalProperties: !1,
				properties: { pdfs: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			},
			{
				additionalProperties: !1,
				properties: { csvs: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			},
			{
				additionalProperties: !1,
				properties: { zpls: { $ref: "#/components/schemas/common_responses_download_link_definitions_url" } }
			}
		]
	} },
	definitions: { url: {
		type: "object",
		additionalProperties: !1,
		properties: { url: {
			type: "string",
			format: "uri"
		} }
	} }
}, ln = {
	type: "object",
	additionalProperties: !1,
	properties: { url: {
		type: "string",
		format: "uri"
	} },
	$schema: "http://json-schema.org/draft-04/schema#"
}, un = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: { shipments: {
			type: "object",
			required: ["unpaid_shipments", "blocked_shipments"],
			additionalProperties: !1,
			properties: {
				unpaid_shipments: { $ref: "#/components/schemas/billing_defs_shipment_data" },
				blocked_shipments: { $ref: "#/components/schemas/billing_defs_shipment_data" }
			}
		} }
	} }
}, dn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "array",
	items: {
		type: "object",
		required: [
			"shipment_id",
			"price",
			"price_after_vat"
		],
		additionalProperties: !1,
		properties: {
			shipment_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
			price: { $ref: "#/components/schemas/_ref_types_money" },
			price_after_vat: { $ref: "#/components/schemas/_ref_types_money" }
		}
	}
}, fn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Payment Instructions",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["payment_instructions"],
		properties: { payment_instructions: {
			type: "array",
			items: { $ref: "#/components/schemas/billing_defs_payment_data" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, pn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Payment Data",
	type: "object",
	required: [
		"id",
		"hash",
		"type",
		"notification_hash",
		"original_notification_hash",
		"paid",
		"price",
		"payment_url",
		"invoices"
	],
	properties: {
		id: { type: "string" },
		hash: { type: "string" },
		type: { type: "integer" },
		notification_hash: { type: "string" },
		original_notification_hash: { type: "string" },
		paid: {
			type: "integer",
			enum: [0, 1]
		},
		price: { $ref: "#/components/schemas/common_defs_price" },
		payment_url: {
			type: ["string", "null"],
			format: "uri"
		},
		invoices: {
			type: "object",
			required: [
				"id",
				"number",
				"status"
			],
			properties: {
				id: { type: "integer" },
				number: { type: "string" },
				status: { type: "integer" }
			},
			additionalProperties: !1
		}
	},
	additionalProperties: !1
}, mn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Price",
	description: "Price amount in a specific currency",
	type: "object",
	required: ["amount", "currency"],
	properties: {
		amount: {
			description: "The amount in the lowest denomination of the currency, e.g. cents for EUR.",
			type: ["integer", "null"]
		},
		currency: {
			description: "The currency as uppercase 3-letter ISO 4217 code.",
			type: "string",
			enum: ["", "EUR"]
		}
	},
	additionalProperties: !1
}, hn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Bad Request",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_400_bad_request" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_400_bad_request" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, gn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [400],
	title: "Bad Request",
	description: "The server will not process the request due to a client error."
}, _n = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DeliveryOptionsV2",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["deliveries"],
		properties: { deliveries: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_option-v2" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, vn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_option.DeliveryOptionV2",
	type: "object",
	required: ["date", "possibilities"],
	properties: {
		date: { $ref: "#/components/schemas/common_defs_date_time" },
		possibilities: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_possibility" }
		}
	},
	additionalProperties: !1
}, yn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.DateTime",
	type: "object",
	required: [
		"date",
		"timezone",
		"timezone_type"
	],
	properties: {
		date: { $ref: "#/components/schemas/common_defs_date_and_time" },
		timezone: { type: "string" },
		timezone_type: { $ref: "#/components/schemas/common_defs_time_zone_type" }
	}
}, bn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.TimeZoneType",
	type: "integer",
	enum: [
		0,
		1,
		2,
		3
	],
	oneOf: [
		{
			enum: [0],
			title: "None"
		},
		{
			enum: [1],
			title: "Offset",
			description: "A UTC offset, such as `+01:00`\n"
		},
		{
			enum: [2],
			title: "Abbreviation",
			description: "A timezone abbreviation, such as `CET`\n"
		},
		{
			enum: [3],
			title: "Identifier",
			description: "A timezone identifier, such as `Europe/Amsterdam`\n"
		}
	],
	"x-enum-varnames": [
		"None",
		"Offset",
		"Abbreviation",
		"Identifier"
	],
	"x-enum-descriptions": [
		"None",
		"A UTC offset, such as `+01:00`",
		"A timezone abbreviation, such as `CET`",
		"A timezone identifier, such as `Europe/Amsterdam`"
	]
}, xn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryPossibility",
	type: "object",
	required: [
		"type",
		"package_type",
		"delivery_time_frames",
		"shipment_options"
	],
	properties: {
		type: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_delivery_options_delivery_name-v2" }, { type: "null" }] },
		package_type: { $ref: "#/components/schemas/shipment_responses_delivery_options_package_type-v2" },
		delivery_time_frames: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_delivery_options_delivery_time_frame" }
		},
		shipment_options: {
			type: "array",
			items: {
				type: "object",
				required: ["name", "schema"],
				properties: {
					name: { type: "string" },
					schema: {
						type: "object",
						required: ["type", "enum"],
						properties: {
							type: { enum: ["boolean"] },
							enum: {
								type: "array",
								items: { type: "boolean" }
							}
						},
						additionalProperties: !1
					}
				},
				additionalProperties: !1
			}
		},
		price: { $ref: "#/components/schemas/common_defs_price" },
		identifier: { type: "string" },
		transporter: { type: "string" },
		label_type: { type: "string" }
	},
	additionalProperties: !1
}, Sn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryNameV2",
	type: "string",
	enum: [
		"morning",
		"standard",
		"evening",
		"same_day",
		"express",
		"early_morning"
	],
	oneOf: [
		{
			title: "Morning",
			enum: ["morning"]
		},
		{
			title: "Standard",
			enum: ["standard"]
		},
		{
			title: "Evening",
			enum: ["evening"]
		},
		{
			title: "SameDay",
			enum: ["same_day"]
		},
		{
			title: "Express",
			enum: ["express"]
		},
		{
			title: "EarlyMorning",
			enum: ["early_morning"]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, Cn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.delivery_options.PackageTypeV2",
	description: "Package Type.",
	type: "string",
	enum: [
		"package",
		"mailbox",
		"unfranked",
		"digital_stamp",
		"pallet",
		"small_package",
		"envelope"
	],
	oneOf: [
		{
			enum: ["package"],
			title: "Package",
			description: "Regular package.\n"
		},
		{
			enum: ["mailbox"],
			title: "Mailbox",
			description: "Shipment that fits through a mailbox slot.\n"
		},
		{
			enum: ["unfranked"],
			title: "Unfranked",
			description: "The label is unpaid meaning that you will need to pay when dropping off the letter/package.\n"
		},
		{
			enum: ["digital_stamp"],
			title: "DigitalStamp",
			description: "Digital Stamp\n"
		},
		{
			enum: ["pallet"],
			title: "Pallet",
			description: "Pallet\n"
		},
		{
			enum: ["small_package"],
			title: "SmallPackage",
			description: "Small Package\n"
		},
		{
			enum: ["envelope"],
			title: "Envelope",
			description: "Small and light shipment that fits through a mailbox slot.\n"
		}
	],
	"x-enum-varnames": [
		"Package",
		"Mailbox",
		"Unfranked",
		"DigitalStamp",
		"Pallet",
		"SmallPackage",
		"Envelope"
	],
	"x-enum-descriptions": [
		"Regular package.",
		"Shipment that fits through a mailbox slot.",
		"The label is unpaid meaning that you will need to pay when dropping off the letter/package.",
		"Digital Stamp",
		"Pallet",
		"Small Package",
		"Small and light shipment that fits through a mailbox slot."
	]
}, wn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryTimeFrame",
	type: "object",
	required: ["type", "date_time"],
	properties: {
		type: { enum: ["start", "end"] },
		date_time: { $ref: "#/components/schemas/common_defs_date_time" }
	},
	additionalProperties: !1
}, Tn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DeliveryOptionsV1",
	type: "object",
	required: ["data"],
	properties: {
		data: {
			type: "object",
			required: ["delivery", "pickup"],
			properties: {
				delivery: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_option-v1" }
				},
				pickup: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_defs_delivery_options_pickup" }
				},
				message: { type: "string" }
			},
			additionalProperties: !1
		},
		errors: {
			type: "array",
			items: { anyOf: [{ $ref: "#/components/schemas/error" }, {
				type: "object",
				required: ["code", "message"],
				properties: {
					code: { type: "integer" },
					message: { type: "string" },
					human: { type: "string" }
				},
				additionalProperties: !1
			}] }
		}
	},
	additionalProperties: !1
}, En = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryOptionV1",
	type: "object",
	required: ["date", "time"],
	properties: {
		date: { $ref: "#/components/schemas/common_defs_date" },
		time: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_delivery_options_delivery_time" }
		}
	},
	additionalProperties: !1
}, Dn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Date",
	description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n",
	type: "string",
	format: "date",
	pattern: "\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\\d|3[0-1])"
}, On = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.DeliveryTime",
	type: "object",
	required: [
		"start",
		"end",
		"price",
		"price_comment",
		"comment",
		"type"
	],
	properties: {
		start: { $ref: "#/components/schemas/common_defs_time" },
		end: { $ref: "#/components/schemas/common_defs_time" },
		price: { $ref: "#/components/schemas/common_defs_price" },
		price_comment: { type: "string" },
		comment: { type: "string" },
		type: { type: "integer" },
		collect_date: { $ref: "#/components/schemas/common_defs_date_time" },
		identifier: { type: "string" },
		transporter: { type: "string" },
		label_type: { type: "string" }
	},
	additionalProperties: !1
}, kn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Time",
	description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n",
	type: "string",
	format: "time",
	pattern: "([0-1]\\d|2[0-4]):[0-5]\\d(:([0-5]\\d|60)(.\\d+)?)?"
}, An = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.Pickup",
	type: "object",
	properties: {
		date: { anyOf: [{ $ref: "#/components/schemas/common_defs_date" }, { type: "null" }] },
		time: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_delivery_options_pickup_time" }
		},
		location: { type: "string" },
		street: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["string", "null"] },
		postal_code: { type: "string" },
		city: { type: "string" },
		cc: { type: "string" },
		start_time: { anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }] },
		price: { type: "integer" },
		price_comment: {
			type: "string",
			enum: ["retail", "retailexpress"]
		},
		comment: { type: "string" },
		phone_number: { type: "string" },
		opening_hours: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours" },
		distance: { type: "string" },
		latitude: { $ref: "#/components/schemas/common_defs_latitude" },
		longitude: { $ref: "#/components/schemas/common_defs_longitude" },
		location_code: { type: "string" },
		retail_network_id: { type: ["string", "null"] },
		holiday: {
			type: "object",
			properties: {
				from: { type: ["string", "null"] },
				to: { type: ["string", "null"] }
			},
			additionalProperties: !1
		}
	},
	additionalProperties: !1
}, jn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.PickupTime",
	type: "object",
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }] },
		type: { $ref: "#/components/schemas/_ref_types_delivery_type" },
		price: { $ref: "#/components/schemas/common_defs_price" }
	}
}, Mn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.DeliveryType",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		6,
		7,
		8
	],
	oneOf: [
		{
			title: "Morning",
			enum: [1]
		},
		{
			title: "Standard",
			enum: [2]
		},
		{
			title: "Evening",
			enum: [3]
		},
		{
			title: "Pickup",
			enum: [4]
		},
		{
			title: "SameDay",
			enum: [6]
		},
		{
			title: "Express",
			enum: [7]
		},
		{
			title: "EarlyMorning",
			enum: [8]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"Pickup",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, Nn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.delivery_options.OpeningHours",
	type: "object",
	required: [
		"monday",
		"tuesday",
		"wednesday",
		"thursday",
		"friday",
		"saturday",
		"sunday"
	],
	properties: {
		monday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		tuesday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		wednesday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		thursday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		friday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		saturday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" },
		sunday: { $ref: "#/components/schemas/shipment_defs_delivery_options_opening_hours_definitions_opening_hours" }
	},
	additionalProperties: !1,
	definitions: { opening_hours: {
		description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n",
		type: "array",
		items: { type: "string" }
	} }
}, Pn = {
	description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n",
	type: "array",
	items: { type: "string" },
	$schema: "http://json-schema.org/draft-04/schema#"
}, Fn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Latitude",
	type: ["number", "string"],
	minimum: -90,
	maximum: 90,
	pattern: "^[-+]?(90|[0-8]?\\d)(\\.\\d+)?$"
}, In = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.Longitude",
	type: ["number", "string"],
	minimum: -180,
	maximum: 180,
	pattern: "^[-+]?(180|(0?\\d{0,2}|1[0-7]\\d)(\\.\\d+)?)$"
}, Ln = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["code", "message"],
	properties: {
		status: { $ref: "#/components/schemas/common_http_status_code_error" },
		code: { $ref: "#/components/schemas/common_error_user_code" },
		title: { type: "string" },
		message: { type: "string" }
	}
}, Rn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Response Status Code: Error",
	type: "integer",
	anyOf: [{ $ref: "#/components/schemas/common_http_status_code_4xx_client_error" }, { $ref: "#/components/schemas/common_http_status_code_5xx_server_error" }]
}, zn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Response Status Code - 5xx (Server Error)",
	description: "The server failed to fulfill an apparently valid request",
	type: "integer",
	minimum: 500,
	maximum: 599
}, Bn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_406_not_acceptable" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_406_not_acceptable" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, Vn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [406],
	title: "Not Acceptable",
	description: "The target resource doesn't have an acceptable representation for the user agent."
}, Hn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Download URL",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["download_url"],
		properties: { download_url: { $ref: "#/components/schemas/common_defs_download_url" } },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Un = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "DownloadUrl",
	description: "DownloadUrl Object Definition",
	required: ["link"],
	properties: { link: {
		type: "string",
		format: "uri"
	} },
	additionalProperties: !1
}, Wn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DropOffPoints",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["drop_off_points"],
		properties: { drop_off_points: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_drop_off_point" }
		} },
		additionalProperties: !1
	} }
}, Gn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.DropOffPoint",
	type: "object",
	properties: {
		location_code: { type: "string" },
		location_name: { type: ["string", "null"] },
		cc: { type: "string" },
		state: { type: ["string", "null"] },
		city: { type: "string" },
		postal_code: { type: "string" },
		street: { type: "string" },
		number: { type: [
			"string",
			"integer",
			"null"
		] },
		number_suffix: { type: ["string", "null"] },
		phone: { type: ["string", "null"] },
		reference: { type: ["string", "null"] },
		longitude: { anyOf: [{ $ref: "#/components/schemas/common_defs_longitude" }, { type: "null" }] },
		latitude: { anyOf: [{ $ref: "#/components/schemas/common_defs_latitude" }, { type: "null" }] },
		available_days: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_available_days" },
		cut_off_time: { type: ["string", "null"] },
		carrier_id: { $ref: "#/components/schemas/_ref_types_carrier" },
		distance: { type: ["number", "null"] },
		occupancy: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_occupancy" }, { type: "null" }] },
		occupancy_today: { type: ["number", "null"] },
		default_drop_off_point: { type: ["boolean", "null"] },
		type: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_carrier_location_type" }, { type: "null" }] },
		opening_hours: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_opening_hours" }
	},
	definitions: {
		available_days: {
			type: ["array", "null"],
			items: { anyOf: [{ $ref: "#/components/schemas/common_defs_day_of_week" }, { $ref: "#/components/schemas/common_defs_iso_day_of_week" }] }
		},
		opening_hours: {
			type: ["object", "null"],
			properties: {
				monday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				tuesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				wednesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				thursday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				friday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				saturday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
				sunday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" }
			},
			additionalProperties: !1
		},
		timeframes: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframe" }
		},
		timeframe: {
			type: "object",
			required: ["start", "end"],
			properties: {
				start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
				end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
			},
			additionalProperties: !1
		}
	}
}, Kn = {
	type: ["array", "null"],
	items: { anyOf: [{ $ref: "#/components/schemas/common_defs_day_of_week" }, { $ref: "#/components/schemas/common_defs_iso_day_of_week" }] },
	$schema: "http://json-schema.org/draft-04/schema#"
}, qn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "commopn.defs.DayOfWeek",
	type: "integer",
	enum: [
		0,
		1,
		2,
		3,
		4,
		5,
		6
	],
	oneOf: [
		{
			enum: [0],
			title: "Sunday"
		},
		{
			enum: [1],
			title: "Monday"
		},
		{
			enum: [2],
			title: "Tuesday"
		},
		{
			enum: [3],
			title: "Wednesday"
		},
		{
			enum: [4],
			title: "Thursday"
		},
		{
			enum: [5],
			title: "Friday"
		},
		{
			enum: [6],
			title: "Saturday"
		}
	],
	"x-enum-varnames": [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	]
}, Jn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "commopn.defs.IsoDayOfWeek",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4,
		5,
		6,
		7
	],
	oneOf: [
		{
			enum: [1],
			title: "Monday"
		},
		{
			enum: [2],
			title: "Tuesday"
		},
		{
			enum: [3],
			title: "Wednesday"
		},
		{
			enum: [4],
			title: "Thursday"
		},
		{
			enum: [5],
			title: "Friday"
		},
		{
			enum: [6],
			title: "Saturday"
		},
		{
			enum: [7],
			title: "Sunday"
		}
	],
	"x-enum-varnames": [
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday",
		"Sunday"
	]
}, Yn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.Occupancy",
	type: "object",
	properties: {
		monday: { type: ["number", "null"] },
		tuesday: { type: ["number", "null"] },
		wednesday: { type: ["number", "null"] },
		thursday: { type: ["number", "null"] },
		friday: { type: ["number", "null"] },
		saturday: { type: ["number", "null"] },
		sunday: { type: ["number", "null"] }
	}
}, Xn = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.carrier.LocationType",
	type: "string",
	enum: ["retail", "locker"],
	oneOf: [{
		title: "Retail",
		enum: ["retail"]
	}, {
		title: "Locker",
		enum: ["locker"]
	}],
	"x-enum-varnames": ["Retail", "Locker"]
}, Zn = {
	type: ["object", "null"],
	properties: {
		monday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		tuesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		wednesday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		thursday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		friday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		saturday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" },
		sunday: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframes" }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Qn = {
	type: "array",
	items: { $ref: "#/components/schemas/shipment_responses_drop_off_point_definitions_timeframe" },
	$schema: "http://json-schema.org/draft-04/schema#"
}, $n = {
	type: "object",
	required: ["start", "end"],
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
		end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, er = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_415_unsupported_media_type" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_415_unsupported_media_type" },
					code: { enum: [3100] }
				}
			}
		}
	} }]
}, tr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [415],
	title: "Unsupported Media Type",
	description: "Content is in a format not supported by this method on the target resource."
}, nr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Invalid Content Type",
	allOf: [{ $ref: "#/components/schemas/common_responses_user_error" }, { properties: {
		status_code: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_401_unauthorized" },
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					status: { $ref: "#/components/schemas/common_http_status_code_4xx_client_error_401_unauthorized" },
					code: { type: "integer" }
				}
			}
		}
	} }]
}, rr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [401],
	title: "Unauthorized",
	description: "The request lacks valid authentication credentials for the target resource."
}, ir = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.PickupLocations",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["pickup_locations"],
		properties: { pickup_locations: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_pickup_location" }
		} },
		additionalProperties: !1
	} },
	definitions: {
		pickup_location: {
			type: "object",
			required: [
				"address",
				"possibilities",
				"location"
			],
			properties: {
				address: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_address" },
				possibilities: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_possibilities" },
				location: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_location" }
			},
			additionalProperties: !1
		},
		address: {
			type: "object",
			required: [
				"cc",
				"city",
				"street",
				"postal_code",
				"number"
			],
			properties: {
				cc: { type: "string" },
				city: { type: "string" },
				street: { type: "string" },
				postal_code: { type: "string" },
				number: { type: "string" },
				number_suffix: { type: ["string", "null"] }
			},
			additionalProperties: !1
		},
		possibilities: {
			type: "array",
			items: {
				type: "object",
				required: [
					"delivery_type_id",
					"delivery_type_name",
					"price",
					"moment"
				],
				properties: {
					delivery_type_id: { type: "integer" },
					delivery_type_name: { type: "string" },
					price: { type: "integer" },
					moment: {
						type: "object",
						properties: { start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] } }
					}
				},
				additionalProperties: !1
			}
		},
		location: {
			type: "object",
			required: [
				"location_name",
				"retail_network_id",
				"distance",
				"latitude",
				"longitude",
				"location_code",
				"phone_number",
				"type",
				"opening_hours"
			],
			properties: {
				location_name: { type: "string" },
				retail_network_id: { type: ["string", "null"] },
				distance: { type: "string" },
				latitude: { type: "string" },
				longitude: { type: "string" },
				location_code: { type: "string" },
				phone_number: { type: ["string", "null"] },
				type: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_carrier_location_type" }, { type: "null" }] },
				opening_hours: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_opening_hours" }
			},
			additionalProperties: !1
		},
		opening_hours: {
			type: "object",
			required: [
				"monday",
				"tuesday",
				"wednesday",
				"thursday",
				"friday",
				"saturday",
				"sunday"
			],
			properties: {
				monday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				tuesday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				wednesday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				thursday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				friday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				saturday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				},
				sunday: {
					type: "array",
					items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
				}
			},
			additionalProperties: !1
		},
		timeframe: {
			type: "object",
			required: ["start", "end"],
			properties: {
				start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
				end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
			},
			additionalProperties: !1
		}
	}
}, ar = {
	type: "object",
	required: [
		"address",
		"possibilities",
		"location"
	],
	properties: {
		address: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_address" },
		possibilities: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_possibilities" },
		location: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_location" }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, or = {
	type: "object",
	required: [
		"cc",
		"city",
		"street",
		"postal_code",
		"number"
	],
	properties: {
		cc: { type: "string" },
		city: { type: "string" },
		street: { type: "string" },
		postal_code: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["string", "null"] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, sr = {
	type: "array",
	items: {
		type: "object",
		required: [
			"delivery_type_id",
			"delivery_type_name",
			"price",
			"moment"
		],
		properties: {
			delivery_type_id: { type: "integer" },
			delivery_type_name: { type: "string" },
			price: { type: "integer" },
			moment: {
				type: "object",
				properties: { start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] } }
			}
		},
		additionalProperties: !1
	},
	$schema: "http://json-schema.org/draft-04/schema#"
}, cr = {
	type: "object",
	required: [
		"location_name",
		"retail_network_id",
		"distance",
		"latitude",
		"longitude",
		"location_code",
		"phone_number",
		"type",
		"opening_hours"
	],
	properties: {
		location_name: { type: "string" },
		retail_network_id: { type: ["string", "null"] },
		distance: { type: "string" },
		latitude: { type: "string" },
		longitude: { type: "string" },
		location_code: { type: "string" },
		phone_number: { type: ["string", "null"] },
		type: { anyOf: [{ $ref: "#/components/schemas/shipment_defs_carrier_location_type" }, { type: "null" }] },
		opening_hours: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_opening_hours" }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, lr = {
	type: "object",
	required: [
		"monday",
		"tuesday",
		"wednesday",
		"thursday",
		"friday",
		"saturday",
		"sunday"
	],
	properties: {
		monday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		tuesday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		wednesday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		thursday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		friday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		saturday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		},
		sunday: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_responses_pickup_locations_definitions_timeframe" }
		}
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, ur = {
	type: "object",
	required: ["start", "end"],
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
		end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, dr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: {
			shipments: {
				type: "array",
				description: "A list of Shipment Resources.",
				items: { $ref: "#/components/schemas/shipment_defs_shipment" }
			},
			pdf: {
				type: "object",
				required: ["url"],
				additionalProperties: !1,
				properties: { url: {
					type: "string",
					format: "uri-reference",
					pattern: "^/pdfs/.*"
				} }
			},
			zpl: {
				type: "object",
				required: ["url"],
				additionalProperties: !1,
				properties: { url: {
					type: "string",
					format: "uri-reference",
					pattern: "^/zpls/.*"
				} }
			}
		}
	} }
}, fr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["ids"],
		additionalProperties: !1,
		properties: { ids: {
			type: "array",
			description: "A list of Shipment IDs.",
			items: {
				type: "object",
				required: ["id", "reference_identifier"],
				additionalProperties: !1,
				properties: {
					id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
					reference_identifier: { $ref: "#/components/schemas/_ref_shipment_reference_identifier" }
				}
			}
		} }
	} }
}, pr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		oneOf: [{
			required: ["ids", "pdf"],
			additionalProperties: !1,
			properties: {
				ids: { $ref: "#/components/schemas/shipment_responses_shipment_ids_properties_data_properties_ids" },
				pdf: {
					type: "object",
					required: ["url"],
					additionalProperties: !1,
					properties: { url: {
						type: "string",
						format: "uri-reference",
						pattern: "^/pdfs/.*"
					} }
				}
			}
		}, {
			required: ["ids", "zpl"],
			additionalProperties: !1,
			properties: {
				ids: { $ref: "#/components/schemas/shipment_responses_shipment_ids_properties_data_properties_ids" },
				zpl: {
					type: "object",
					required: ["url"],
					additionalProperties: !1,
					properties: { url: {
						type: "string",
						format: "uri-reference",
						pattern: "^/zpls/.*"
					} }
				}
			}
		}]
	} }
}, mr = {
	type: "array",
	description: "A list of Shipment IDs.",
	items: {
		type: "object",
		required: ["id", "reference_identifier"],
		additionalProperties: !1,
		properties: {
			id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
			reference_identifier: { $ref: "#/components/schemas/_ref_shipment_reference_identifier" }
		}
	},
	$schema: "http://json-schema.org/draft-04/schema#"
}, hr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "System Error",
	type: "object",
	properties: {
		message: {
			type: "string",
			description: "A human-readable description of the error."
		},
		request_id: {
			type: "string",
			description: "Internal request ID, useful for debugging purposes."
		},
		status_code: { $ref: "#/components/schemas/common_http_status_code_5xx_server_error" },
		errors: {
			type: "array",
			items: { $ref: "#/components/schemas/common_error_system" }
		}
	}
}, gr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		status: { $ref: "#/components/schemas/common_http_status_code_5xx_server_error" },
		code: { type: "integer" },
		title: { type: "string" },
		message: { type: "string" }
	}
}, _r = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["shipments", "results"],
		properties: {
			shipments: {
				type: "array",
				description: "A list of Shipment Resources.",
				items: { $ref: "#/components/schemas/shipment_defs_shipment" }
			},
			results: {
				type: "integer",
				description: "The number of results."
			}
		},
		additionalProperties: !1
	} },
	additionalProperties: !1
}, vr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.responses.TrackTraces",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["tracktraces"],
		properties: { tracktraces: {
			type: "array",
			description: "A list of Track & Trace Resources.",
			items: { $ref: "#/components/schemas/shipment_defs_track_trace" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, yr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.TrackTrace",
	description: "A Track & Trace resource.",
	type: "object",
	required: [
		"shipment_id",
		"carrier",
		"code",
		"description",
		"time",
		"link_consumer_portal",
		"link_tracktrace",
		"partner_tracktraces",
		"recipient",
		"sender",
		"options",
		"pickup",
		"delayed",
		"location",
		"status",
		"history"
	],
	properties: {
		shipment_id: { $ref: "#/components/schemas/shipment_defs_shipment_properties_id" },
		carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
		code: { type: "string" },
		description: { type: "string" },
		time: { $ref: "#/components/schemas/common_defs_date_and_time" },
		link_consumer_portal: {
			type: ["string", "null"],
			format: "uri"
		},
		link_tracktrace: {
			type: ["string", "null"],
			format: "uri"
		},
		partner_tracktraces: {
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_external_track_trace_link" }
		},
		recipient: { $ref: "#/components/schemas/shipment_defs_shipment_recipient" },
		sender: { $ref: "#/components/schemas/shipment_defs_shipment_sender" },
		options: { $ref: "#/components/schemas/_ref_shipment_shipment_options" },
		pickup: { $ref: "#/components/schemas/shipment_defs_shipment_pickup" },
		delayed: { type: "boolean" },
		location: { $ref: "#/components/schemas/shipment_defs_tracking_location" },
		status: {
			type: "object",
			required: [
				"current",
				"main",
				"final"
			],
			properties: {
				current: { $ref: "#/components/schemas/shipment_defs_shipment_status" },
				main: { $ref: "#/components/schemas/shipment_defs_main_status" },
				final: { type: "boolean" }
			},
			additionalProperties: !1
		},
		history: { $ref: "#/components/schemas/shipment_defs_carrier_track_trace_history" },
		delivery_moment_type: { $ref: "#/components/schemas/shipment_defs_delivery_moment_properties_type" },
		delivery_moment: { $ref: "#/components/schemas/shipment_defs_delivery_moment_properties_time_frame" },
		signature: { $ref: "#/components/schemas/shipment_defs_track_trace_proof_of_delivery" },
		returnable: { type: "boolean" }
	},
	additionalProperties: !1
}, br = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.ExternalTrackTraceLink",
	type: "object",
	required: ["uri", "barcode"],
	properties: {
		uri: {
			type: "string",
			format: "uri"
		},
		barcode: { type: "string" }
	},
	additionalProperties: !1
}, xr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.TrackingLocation",
	required: [
		"name",
		"cc",
		"city",
		"postal_code",
		"street",
		"number",
		"number_suffix",
		"longitude",
		"latitude"
	],
	properties: {
		name: { type: ["string"] },
		cc: { type: ["string", "null"] },
		city: { type: ["string", "null"] },
		postal_code: { type: ["string", "null"] },
		street: { type: ["string", "null"] },
		number: { type: ["string", "null"] },
		number_suffix: { type: ["string", "null"] },
		longitude: { type: ["number", "null"] },
		latitude: { type: ["number", "null"] }
	},
	additionalProperties: !1
}, Sr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.MainStatus",
	type: ["string", "null"],
	enum: [
		"registered",
		"handed_to_carrier",
		"sorting",
		"distribution",
		"delivered",
		null
	]
}, Cr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.CarrierTrackTraceHistory",
	type: "array",
	items: { $ref: "#/components/schemas/shipment_defs_carrier_track_trace_event" }
}, wr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.CarrierTrackTraceEvent",
	type: "object",
	required: [
		"code",
		"status",
		"main",
		"description",
		"time",
		"delayed",
		"location"
	],
	properties: {
		code: { type: "string" },
		status: { $ref: "#/components/schemas/shipment_defs_shipment_status" },
		main: { $ref: "#/components/schemas/shipment_defs_main_status" },
		description: { type: "string" },
		time: { $ref: "#/components/schemas/common_defs_date_and_time" },
		delayed: { type: "boolean" },
		location: { $ref: "#/components/schemas/shipment_defs_tracking_location" }
	},
	additionalProperties: !1
}, Tr = {
	type: ["string", "null"],
	enum: [
		"estimated",
		"expected",
		null
	],
	$schema: "http://json-schema.org/draft-04/schema#"
}, Er = {
	type: ["object", "null"],
	required: ["start", "end"],
	properties: {
		start: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] },
		end: { anyOf: [{ $ref: "#/components/schemas/common_defs_date_time" }, { type: "null" }] }
	},
	additionalProperties: !1,
	$schema: "http://json-schema.org/draft-04/schema#"
}, Dr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.defs.TrackTraceProofOfDelivery",
	anyOf: [
		{ type: "null" },
		{
			type: "string",
			format: "base64"
		},
		{
			type: "object",
			required: ["content", "content_type"],
			properties: {
				content: { type: "string" },
				content_type: { type: "string" }
			},
			additionalProperties: !1
		}
	]
}, Or = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["results"],
	properties: { results: {
		type: "array",
		description: "A list of V2 Capabilities for a given Shipment configuration.",
		items: { $ref: "#/components/schemas/_ref_capabilities_response_capability-v2" }
	} },
	additionalProperties: !1
}, kr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Capability response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier",
		"collo",
		"deliveryTypes",
		"packageTypes",
		"physicalProperties",
		"options",
		"transactionTypes"
	],
	additionalProperties: !1,
	properties: {
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		contract: { $ref: "#/components/schemas/_ref_capabilities_shared_contract-v2" },
		packageTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_response_options_options-v2" },
		physicalProperties: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_properties" },
		deliveryTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type-v2" }
		},
		transactionTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, Ar = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "ref.capabilities.shared.CarrierV2",
	description: "Carrier string definition for capabilities endpoints (v2)",
	type: "string",
	enum: [
		"BPOST",
		"BRT",
		"CHEAP_CARGO",
		"DHL_EUROPLUS",
		"DHL_FOR_YOU",
		"DHL_PARCEL_CONNECT",
		"DPD",
		"GLS",
		"INPOST",
		"POSTE_ITALIANE",
		"POSTNL",
		"SPRING",
		"TRUNKRS",
		"UPS_EXPRESS_SAVER",
		"UPS_STANDARD"
	],
	oneOf: [
		{
			description: "bpost",
			title: "Bpost",
			enum: ["BPOST"]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: ["BRT"]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: ["CHEAP_CARGO"]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: ["DHL_EUROPLUS"]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: ["DHL_FOR_YOU"]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: ["DHL_PARCEL_CONNECT"]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: ["DPD"]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: ["GLS"]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: ["INPOST"]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: ["POSTE_ITALIANE"]
		},
		{
			description: "PostNL",
			title: "Postnl",
			enum: ["POSTNL"]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: ["SPRING"]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: ["TRUNKRS"]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: ["UPS_EXPRESS_SAVER"]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: ["UPS_STANDARD"]
		}
	],
	"x-enum-varnames": [
		"Bpost",
		"Brt",
		"CheapCargo",
		"DhlEuroplus",
		"DhlForYou",
		"DhlParcelConnect",
		"Dpd",
		"Gls",
		"Inpost",
		"PosteItaliane",
		"Postnl",
		"Spring",
		"Trunkrs",
		"UpsExpressSaver",
		"UpsStandard"
	],
	"x-enum-descriptions": [
		"bpost",
		"BRT",
		"Cheap Cargo",
		"DHL Europlus",
		"DHL For You",
		"DHL Parcel Connect",
		"DPD",
		"GLS",
		"InPost",
		"PosteItaliane",
		"PostNL",
		"Spring",
		"Trunkrs",
		"UPS Express Saver",
		"UPS Standard"
	]
}, jr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "Contract definition for capabilities endpoints (v2)",
	type: "object",
	required: ["id", "type"],
	additionalProperties: !1,
	properties: {
		id: {
			type: "integer",
			format: "int32",
			description: "The contract ID."
		},
		type: {
			type: "string",
			enum: ["MAIN", "CUSTOM"],
			description: "The type of contract."
		}
	}
}, Mr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.PackageTypeV2",
	description: "Package Type.",
	type: "string",
	enum: [
		"PACKAGE",
		"MAILBOX",
		"UNFRANKED",
		"DIGITAL_STAMP",
		"PALLET",
		"SMALL_PACKAGE",
		"ENVELOPE"
	],
	oneOf: [
		{
			enum: ["PACKAGE"],
			title: "Package",
			description: "Regular package.\n"
		},
		{
			enum: ["MAILBOX"],
			title: "Mailbox",
			description: "Shipment that fits through a mailbox slot.\n"
		},
		{
			enum: ["UNFRANKED"],
			title: "Unfranked",
			description: "The label is unpaid meaning that you will need to pay when dropping off the letter/package.\n"
		},
		{
			enum: ["DIGITAL_STAMP"],
			title: "DigitalStamp",
			description: "Digital Stamp\n"
		},
		{
			enum: ["PALLET"],
			title: "Pallet",
			description: "Pallet\n"
		},
		{
			enum: ["SMALL_PACKAGE"],
			title: "SmallPackage",
			description: "Small Package\n"
		},
		{
			enum: ["ENVELOPE"],
			title: "Envelope",
			description: "Small and light shipment that fits through a mailbox slot.\n"
		}
	],
	"x-enum-varnames": [
		"Package",
		"Mailbox",
		"Unfranked",
		"DigitalStamp",
		"Pallet",
		"SmallPackage",
		"Envelope"
	],
	"x-enum-descriptions": [
		"Regular package.",
		"Shipment that fits through a mailbox slot.",
		"The label is unpaid meaning that you will need to pay when dropping off the letter/package.",
		"Digital Stamp",
		"Pallet",
		"Small Package",
		"Small and light shipment that fits through a mailbox slot."
	]
}, Nr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v2" }, {
		type: "object",
		properties: {
			additionalInsurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			cooledDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			customLabelText: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			deliverAtPostalPoint: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			deliveryDate: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			freshFood: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			frozen: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			hideSender: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_insurance_option-v2" },
			noTracking: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			oversizedPackage: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			priorityDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			printReturnLabelAtDropOff: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			recipientOnlyDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresAgeVerification: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresCashOnDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresReceiptCode: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			requiresSignature: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			returnContributionFee: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			returnOnFirstFailedDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			sameDayDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			saturdayDelivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			scheduledCollection: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" }
		}
	}]
}, Pr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		additionalInsurance: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		cooledDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		customLabelText: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		deliverAtPostalPoint: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		deliveryDate: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		freshFood: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		frozen: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		hideSender: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		noTracking: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		oversizedPackage: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		priorityDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		printReturnLabelAtDropOff: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		recipientOnlyDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresAgeVerification: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresCashOnDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresReceiptCode: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		requiresSignature: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		returnContributionFee: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		returnOnFirstFailedDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		sameDayDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		saturdayDelivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		scheduledCollection: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" },
		tracked: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" }
	}
}, Fr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["isSelectedByDefault", "isRequired"],
	properties: {
		isSelectedByDefault: { type: "boolean" },
		isRequired: { type: "boolean" }
	}
}, Ir = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" }, {
		type: "object",
		required: ["requires", "excludes"],
		properties: {
			requires: {
				type: "array",
				items: { type: "string" },
				description: "camelCase shipment option keys that are required"
			},
			excludes: {
				type: "array",
				items: { type: "string" },
				description: "camelCase shipment option keys that are excluded"
			}
		}
	}]
}, Lr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_response_options_option-v2" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v2" }]
}, Rr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { insuredAmount: {
		type: "object",
		required: [
			"default",
			"min",
			"max"
		],
		additionalProperties: !1,
		properties: {
			default: { $ref: "#/components/schemas/_ref_types_money" },
			min: { $ref: "#/components/schemas/_ref_types_money" },
			max: { $ref: "#/components/schemas/_ref_types_money" }
		}
	} }
}, zr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		weight: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		width: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		length: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		height: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		girth: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		volumetric_weight: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		volume: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" },
		length_width_height_sum: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_property" }
	}
}, Br = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: [
		"min",
		"max",
		"calculation"
	],
	additionalProperties: !1,
	properties: {
		min: { $ref: "#/components/schemas/_ref_types_value_with_unit" },
		max: { $ref: "#/components/schemas/_ref_types_value_with_unit" },
		calculation: { type: "string" }
	}
}, Vr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["value", "unit"],
	additionalProperties: !1,
	properties: {
		value: {
			type: "number",
			description: "The numeric value"
		},
		unit: {
			type: "string",
			enum: [
				"g",
				"kg",
				"cm",
				"mm",
				"mm3",
				"cm3",
				"dm3",
				"m3"
			],
			description: "The unit of measurement in SI units"
		}
	}
}, Hr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.types.DeliveryTypeV2",
	type: "string",
	enum: [
		"MORNING_DELIVERY",
		"STANDARD_DELIVERY",
		"EVENING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY"
	],
	oneOf: [
		{
			title: "Morning",
			enum: ["MORNING_DELIVERY"]
		},
		{
			title: "Standard",
			enum: ["STANDARD_DELIVERY"]
		},
		{
			title: "Evening",
			enum: ["EVENING_DELIVERY"]
		},
		{
			title: "Pickup",
			enum: ["PICKUP_DELIVERY"]
		},
		{
			title: "SameDay",
			enum: ["SAME_DAY_DELIVERY"]
		},
		{
			title: "Express",
			enum: ["EXPRESS_DELIVERY"]
		},
		{
			title: "EarlyMorning",
			enum: ["EARLY_MORNING_DELIVERY"]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"Pickup",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, Ur = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "string",
	enum: ["B2B", "B2C"]
}, Wr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["max"],
	additionalProperties: !1,
	properties: { max: { type: "integer" } }
}, Gr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["capabilities"],
		properties: { capabilities: {
			type: "array",
			description: "A list of V1 Capabilities for a given Shipment configuration.",
			items: { $ref: "#/components/schemas/_ref_capabilities_response_capability-v1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Kr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Capability response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier_id",
		"collo",
		"delivery_types",
		"package_types",
		"physical_properties",
		"options",
		"transaction_types"
	],
	additionalProperties: !1,
	properties: {
		carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
		contract: { $ref: "#/components/schemas/_ref_capabilities_shared_contract-v1" },
		package_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_response_options_options-v1" },
		physical_properties: { $ref: "#/components/schemas/_ref_capabilities_response_physical_properties_physical_properties" },
		delivery_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type" }
		},
		transaction_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, qr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "ref.capabilities.shared.Carrier",
	description: "Carrier ID definition for capabilities endpoints (v1)",
	type: "integer",
	format: "int32",
	enum: [
		1,
		2,
		3,
		4,
		9,
		10,
		11,
		12,
		13,
		14,
		15,
		16,
		17,
		18,
		19
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: [1]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: [2]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: [3]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: [4]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: [9]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: [10]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: [11]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: [12]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: [13]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: [14]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: [15]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: [16]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: [17]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: [18]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: [19]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring"
	]
}, Jr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "Contract definition for capabilities endpoints (v1)",
	type: "object",
	required: ["id", "type"],
	additionalProperties: !1,
	properties: {
		id: {
			type: "integer",
			format: "int32",
			description: "The contract ID."
		},
		type: {
			type: "string",
			enum: ["main", "custom"],
			description: "The type of contract."
		}
	}
}, Yr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v1" }, {
		type: "object",
		properties: {
			age_check: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			cash_on_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			collect: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			contribution: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			cooled_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			delivery_date: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			extra_assurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			fresh_food: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			frozen: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			hide_sender: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_response_options_insurance_option-v1" },
			label_description: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			large_format: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			no_tracking: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			only_recipient: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			printerless_return: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			priority_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			receipt_code: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			return: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			same_day_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			saturday_delivery: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			signature: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" }
		}
	}]
}, Xr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		age_check: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		cash_on_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		collect: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		contribution: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		cooled_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		delivery_date: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		extra_assurance: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		fresh_food: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		frozen: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		hide_sender: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		label_description: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		large_format: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		no_tracking: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		only_recipient: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		printerless_return: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		priority_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		receipt_code: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		return: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		same_day_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		saturday_delivery: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		signature: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" },
		tracked: { $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" }
	}
}, Zr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["is_selected_by_default", "is_required"],
	properties: {
		is_selected_by_default: { type: "boolean" },
		is_required: { type: "boolean" }
	}
}, Qr = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" }, {
		type: "object",
		required: ["requires", "excludes"],
		properties: {
			requires: {
				type: "array",
				items: { type: "string" },
				description: "snake_case shipment option keys that are required"
			},
			excludes: {
				type: "array",
				items: { type: "string" },
				description: "snake_case shipment option keys that are excluded"
			}
		}
	}]
}, $r = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_response_options_option-v1" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v1" }]
}, ei = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { insured_amount: {
		type: "object",
		required: [
			"default",
			"min",
			"max"
		],
		additionalProperties: !1,
		properties: {
			default: { $ref: "#/components/schemas/_ref_types_money" },
			min: { $ref: "#/components/schemas/_ref_types_money" },
			max: { $ref: "#/components/schemas/_ref_types_money" }
		}
	} }
}, ti = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["items"],
	properties: { items: {
		type: "array",
		description: "A superset of V2 Capabilities for the contracts within a user's account.",
		items: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_contract-definitions-v2" }
	} },
	additionalProperties: !1
}, ni = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Capability response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier",
		"collo",
		"deliveryTypes",
		"packageTypes",
		"options",
		"transactionTypes"
	],
	additionalProperties: !1,
	properties: {
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		packageTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_options-v2" },
		deliveryTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type-v2" }
		},
		transactionTypes: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, ri = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v2" }, {
		type: "object",
		properties: {
			additionalInsurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			cooledDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			customLabelText: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			deliverAtPostalPoint: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			deliveryDate: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			hideSender: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_insurance_option-v2" },
			noTracking: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			oversizedPackage: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			priorityDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			printReturnLabelAtDropOff: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			recipientOnlyDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresAgeVerification: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresCashOnDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresReceiptCode: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			requiresSignature: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			returnContributionFee: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			returnOnFirstFailedDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			sameDayDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			saturdayDelivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			scheduledCollection: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" }
		}
	}]
}, ii = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v2" }, {
		type: "object",
		additionalProperties: !1
	}]
}, ai = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v2" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v2" }]
}, oi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["items"],
		properties: { capabilities: {
			type: "array",
			description: "A superset of V1 Capabilities for the contracts within a user's account.",
			items: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_contract-definitions-v1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, si = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Capability contract definitions response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier_id",
		"collo",
		"delivery_types",
		"package_types",
		"options",
		"transaction_types"
	],
	additionalProperties: !1,
	properties: {
		carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
		package_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type" }
		},
		options: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_options-v1" },
		delivery_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_delivery_type" }
		},
		transaction_types: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_types_transaction_types" }
		},
		collo: { $ref: "#/components/schemas/_ref_capabilities_response_collo" }
	}
}, ci = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-options-v1" }, {
		type: "object",
		properties: {
			age_check: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			cash_on_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			collect: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			contribution: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			cooled_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			delivery_date: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			extra_assurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			hide_sender: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			insurance: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_insurance_option-v1" },
			label_description: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			large_format: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			no_tracking: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			only_recipient: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			printerless_return: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			priority_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			receipt_code: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			return: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			same_day_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			saturday_delivery: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			signature: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" },
			tracked: { $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" }
		}
	}]
}, li = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_shared_options_base-option-v1" }, {
		type: "object",
		additionalProperties: !1
	}]
}, ui = {
	$schema: "http://json-schema.org/draft-04/schema#",
	allOf: [{ $ref: "#/components/schemas/_ref_capabilities_contract-definitions_response_options_option-v1" }, { $ref: "#/components/schemas/_ref_capabilities_shared_options_insurance_base-insurance-v1" }]
}, di = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Rate response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier",
		"packageType",
		"deliveryType",
		"priceComposition"
	],
	properties: {
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		contract: { $ref: "#/components/schemas/_ref_rates_response_contract-v2" },
		packageType: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" },
		deliveryType: { $ref: "#/components/schemas/_ref_types_delivery_type-v2" },
		priceComposition: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price_composition-v2" }
	},
	additionalProperties: !1
}, fi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The contract object.",
	type: "object",
	required: ["id", "type"],
	properties: {
		id: {
			type: "integer",
			description: "The id of the contract."
		},
		type: {
			type: "string",
			enum: ["MAIN", "CUSTOM"],
			description: "The type of contract."
		}
	},
	additionalProperties: !1
}, pi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The V2 price composition object, containing the base, options, charges, discounts and total prices.",
	type: "object",
	required: [
		"base",
		"charges",
		"discounts",
		"options",
		"other",
		"total"
	],
	properties: {
		base: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" },
		charges: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		discounts: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		options: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		other: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
		},
		total: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v2" }
	},
	additionalProperties: !1
}, mi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V2 Price object.",
	type: "object",
	required: [
		"name",
		"key",
		"price",
		"vat",
		"priceWithVat"
	],
	properties: {
		name: { type: "string" },
		key: { type: "string" },
		price: { $ref: "#/components/schemas/_ref_types_money" },
		vat: { $ref: "#/components/schemas/_ref_types_money" },
		priceWithVat: { $ref: "#/components/schemas/_ref_types_money" }
	},
	additionalProperties: !1
}, hi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["rates"],
		properties: { rates: {
			type: "array",
			description: "A list of V1 Rates for a given Shipment configuration.",
			items: { $ref: "#/components/schemas/_ref_rates_response_rate-v1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, gi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Rate response item for a given Shipment configuration.",
	type: "object",
	required: [
		"carrier_id",
		"package_type",
		"delivery_type",
		"price_composition"
	],
	properties: {
		carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
		contract: { $ref: "#/components/schemas/_ref_rates_response_contract" },
		package_type: { $ref: "#/components/schemas/_ref_shipment_package_type" },
		delivery_type: { $ref: "#/components/schemas/_ref_types_delivery_type" },
		price_composition: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price_composition-v1" }
	},
	additionalProperties: !1
}, _i = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The contract object.",
	type: "object",
	required: ["id", "type"],
	properties: {
		id: {
			type: "integer",
			description: "The id of the contract."
		},
		type: {
			type: "string",
			enum: ["main", "custom"],
			description: "The type of contract."
		}
	},
	additionalProperties: !1
}, vi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The price composition object, containing the base, options, charges, discounts and total prices.",
	type: "object",
	required: [
		"base",
		"charges",
		"discounts",
		"options",
		"other",
		"total"
	],
	properties: {
		base: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" },
		charges: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		discounts: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		options: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		other: {
			type: "array",
			items: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
		},
		total: { $ref: "#/components/schemas/_ref_rates_response_price_composition_price-v1" }
	},
	additionalProperties: !1
}, yi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A V1 Price object.",
	type: "object",
	required: [
		"name",
		"key",
		"price",
		"vat",
		"price_with_vat"
	],
	properties: {
		name: { type: "string" },
		key: { type: "string" },
		price: { $ref: "#/components/schemas/_ref_types_money" },
		vat: { $ref: "#/components/schemas/_ref_types_money" },
		price_with_vat: { $ref: "#/components/schemas/_ref_types_money" }
	},
	additionalProperties: !1
}, bi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["results"],
	properties: { results: {
		type: "array",
		items: { $ref: "#/components/schemas/_ref_notification_response_notification_group" }
	} },
	additionalProperties: !1
}, xi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Notification Group response item",
	type: "object",
	required: [
		"id",
		"shopId",
		"packageType",
		"countryCode",
		"shipmentDirection",
		"fallback"
	],
	additionalProperties: !1,
	properties: {
		id: { type: "integer" },
		shopId: { type: "integer" },
		packageType: {
			type: ["string", "null"],
			enum: [
				"DIGITAL_STAMP",
				"ENVELOPE",
				"UNFRANKED",
				"MAILBOX",
				"PACKAGE",
				"PALLET",
				"SMALL_PACKAGE",
				null
			]
		},
		countryCode: {
			type: ["string", "null"],
			minLength: 2,
			maxLength: 2,
			pattern: "^[A-Z]{2}$",
			description: "ISO 3166-1 alpha-2 country code"
		},
		shipmentDirection: {
			type: "string",
			enum: ["OUTBOUND", "INBOUND"]
		},
		fallback: { type: "boolean" }
	}
}, Si = {
	$schema: "http://json-schema.org/draft-07/schema#",
	type: "object",
	required: ["results"],
	properties: { results: {
		type: "array",
		items: { $ref: "#/components/schemas/_ref_notification_response_notification_template" }
	} }
}, Ci = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Notification Template response item",
	type: "object",
	required: [
		"id",
		"notificationGroupId",
		"type",
		"subject",
		"body",
		"active"
	],
	additionalProperties: !1,
	properties: {
		id: { type: "integer" },
		notificationGroupId: { type: "integer" },
		type: { $ref: "#/components/schemas/_ref_notification_notification_template_type" },
		subject: { type: "string" },
		body: { type: "string" },
		active: { type: "boolean" }
	}
}, wi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "The notification template type.",
	type: "string",
	enum: [
		"LABEL_DOWNLOAD",
		"FIRST_SCAN",
		"RETURN"
	]
}, Ti = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["webhook_subscriptions"],
		properties: { webhook_subscriptions: {
			type: "array",
			items: { $ref: "#/components/schemas/webhooks_responses_webhook-v1.1" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Ei = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Webhook Subscription response item",
	type: "object",
	required: [
		"id",
		"account_id",
		"shop_id",
		"hook",
		"url"
	],
	additionalProperties: !1,
	properties: {
		id: { type: "integer" },
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" },
		payload: { type: ["string", "null"] }
	}
}, Di = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	properties: { data: {
		type: "object",
		required: ["webhook_subscriptions"],
		properties: { webhook_subscriptions: {
			type: "array",
			items: { $ref: "#/components/schemas/webhooks_responses_webhook-v1.0" }
		} },
		additionalProperties: !1
	} },
	additionalProperties: !1
}, Oi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	description: "A Webhook Subscription response item",
	type: "object",
	required: [
		"id",
		"account_id",
		"shop_id",
		"hook",
		"url"
	],
	properties: {
		id: { type: "integer" },
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" }
	}
}, ki = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["ids"],
		additionalProperties: !1,
		properties: { ids: {
			type: "array",
			description: "A list of created webhook subscription IDs.",
			items: {
				type: "object",
				required: ["id"],
				additionalProperties: !1,
				properties: { id: { type: "integer" } }
			}
		} }
	} }
}, Ai = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.Barcode",
	type: "string",
	minLength: 6,
	maxLength: 24,
	pattern: "^[a-zA-Z0-9\\-\\s]+$"
}, ji = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CarrierIdentifier",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/shipment_parameters_carrier_id" }, { $ref: "#/components/schemas/shipment_parameters_carrier_name" }]
}, Mi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CarrierId",
	description: "This enumeration represents the Carriers. The value is the Carrier id.",
	type: ["string", "null"],
	enum: [
		"1",
		"2",
		"3",
		"4",
		"5",
		"6",
		"7",
		"8",
		"9",
		"10",
		"11",
		"12",
		"13",
		"14",
		"15",
		"16",
		"17",
		"18",
		"19"
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: ["1"]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: ["2"]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: ["3"]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: ["4"]
		},
		{
			description: "Instabox",
			title: "Instabox",
			enum: ["5"]
		},
		{
			description: "DHL",
			title: "DhlCheapCargo",
			enum: ["6"]
		},
		{
			description: "Bol.com",
			title: "Bol",
			enum: ["7"]
		},
		{
			description: "UPS",
			title: "Ups",
			enum: ["8"]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: ["9"]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: ["10"]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: ["11"]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: ["12"]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: ["13"]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: ["14"]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: ["15"]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: ["16"]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: ["17"]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: ["18"]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: ["19"]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"Instabox",
		"DhlCheapCargo",
		"Bol",
		"Ups",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"Instabox",
		"DHL",
		"Bol.com",
		"UPS",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring"
	]
}, Ni = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CarrierName",
	description: "This enumeration represents the Carriers. The value is the Carrier id.",
	type: "string",
	enum: [
		"postnl",
		"bpost",
		"cheapcargo",
		"dpd",
		"instabox",
		"dhl",
		"bol.com",
		"ups",
		"dhlforyou",
		"dhlparcelconnect",
		"dhleuroplus",
		"upsstandard",
		"upsexpresssaver",
		"gls",
		"brt",
		"trunkrs",
		"inpost",
		"posteitaliane",
		"spring"
	],
	oneOf: [
		{
			description: "PostNL",
			title: "Postnl",
			enum: ["postnl"]
		},
		{
			description: "bpost",
			title: "Bpost",
			enum: ["bpost"]
		},
		{
			description: "Cheap Cargo",
			title: "CheapCargo",
			enum: ["cheapcargo"]
		},
		{
			description: "DPD",
			title: "Dpd",
			enum: ["dpd"]
		},
		{
			description: "Instabox",
			title: "Instabox",
			enum: ["instabox"]
		},
		{
			description: "DHL",
			title: "DhlCheapCargo",
			enum: ["dhl"]
		},
		{
			description: "Bol.com",
			title: "Bol",
			enum: ["bol.com"]
		},
		{
			description: "UPS",
			title: "Ups",
			enum: ["ups"]
		},
		{
			description: "DHL For You",
			title: "DhlForYou",
			enum: ["dhlforyou"]
		},
		{
			description: "DHL Parcel Connect",
			title: "DhlParcelConnect",
			enum: ["dhlparcelconnect"]
		},
		{
			description: "DHL Europlus",
			title: "DhlEuroplus",
			enum: ["dhleuroplus"]
		},
		{
			description: "UPS Standard",
			title: "UpsStandard",
			enum: ["upsstandard"]
		},
		{
			description: "UPS Express Saver",
			title: "UpsExpressSaver",
			enum: ["upsexpresssaver"]
		},
		{
			description: "GLS",
			title: "Gls",
			enum: ["gls"]
		},
		{
			description: "BRT",
			title: "Brt",
			enum: ["brt"]
		},
		{
			description: "Trunkrs",
			title: "Trunkrs",
			enum: ["trunkrs"]
		},
		{
			description: "InPost",
			title: "Inpost",
			enum: ["inpost"]
		},
		{
			description: "PosteItaliane",
			title: "PosteItaliane",
			enum: ["posteitaliane"]
		},
		{
			description: "Spring",
			title: "Spring",
			enum: ["spring"]
		}
	],
	"x-enum-varnames": [
		"Postnl",
		"Bpost",
		"CheapCargo",
		"Dpd",
		"Instabox",
		"DhlCheapCargo",
		"Bol",
		"Ups",
		"DhlForYou",
		"DhlParcelConnect",
		"DhlEuroplus",
		"UpsStandard",
		"UpsExpressSaver",
		"Gls",
		"Brt",
		"Trunkrs",
		"Inpost",
		"PosteItaliane",
		"Spring"
	],
	"x-enum-descriptions": [
		"PostNL",
		"bpost",
		"Cheap Cargo",
		"DPD",
		"Instabox",
		"DHL",
		"Bol.com",
		"UPS",
		"DHL For You",
		"DHL Parcel Connect",
		"DHL Europlus",
		"UPS Standard",
		"UPS Express Saver",
		"GLS",
		"BRT",
		"Trunkrs",
		"InPost",
		"PosteItaliane",
		"Spring"
	]
}, Pi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "collect_date",
	type: ["string", "null"],
	format: "date",
	pattern: "\\d{4}-\\d{2}-\\d{2}"
}, Fi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.CountryCode",
	description: "ISO 3166-1 alpha-2 country code",
	type: "string",
	maxLength: 2,
	minLength: 2,
	pattern: "^[A-Za-z]{2}$"
}, Ii = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.CutoffTime",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }]
}, Li = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.Boolean",
	anyOf: [
		{ type: "boolean" },
		{
			type: "integer",
			minimum: 0,
			maximum: 1
		},
		{
			type: "number",
			anyOf: [{
				minimum: 0,
				maximum: 0
			}, {
				minimum: 1,
				maximum: 1
			}]
		},
		{
			type: "string",
			enum: [
				"0",
				"1",
				"false",
				"true"
			]
		}
	]
}, Ri = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.FilterValidateBool",
	type: [
		"boolean",
		"integer",
		"string",
		"null"
	],
	enum: [
		!1,
		!0,
		0,
		1,
		"0",
		"1",
		"false",
		"true",
		"off",
		"on",
		"no",
		"yes",
		"",
		null
	]
}, zi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryDate",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/common_defs_date" }, { type: "null" }]
}, Bi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryTime",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/common_defs_time" }, { type: "null" }]
}, Vi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "delivery_options_identifier",
	type: ["string", "null"]
}, Hi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.defs.WeekdayDigit",
	description: "A semi-colon delimited list of weekday digits between 0 and 6 (0 = Sunday).\n",
	type: ["string", "null"],
	pattern: "^([0-6](;[0-6])*)?$"
}, Ui = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryTypes",
	type: "string",
	anyOf: [{ $ref: "#/components/schemas/shipment_parameters_delivery_type" }, { pattern: "^([1-8];[1-8]+)?$" }]
}, Wi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.DeliveryType",
	type: "string",
	enum: [
		"1",
		"2",
		"3",
		"4",
		"6",
		"7",
		"8"
	],
	oneOf: [
		{
			title: "Morning",
			enum: ["1"]
		},
		{
			title: "Standard",
			enum: ["2"]
		},
		{
			title: "Evening",
			enum: ["3"]
		},
		{
			title: "Pickup",
			enum: ["4"]
		},
		{
			title: "SameDay",
			enum: ["6"]
		},
		{
			title: "Express",
			enum: ["7"]
		},
		{
			title: "EarlyMorning",
			enum: ["8"]
		}
	],
	"x-enum-varnames": [
		"Morning",
		"Standard",
		"Evening",
		"Pickup",
		"SameDay",
		"Express",
		"EarlyMorning"
	]
}, Gi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "paper_size",
	description: "The size of a paper as specified in ISO216.",
	type: "string",
	enum: ["A4", "A6"]
}, Ki = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.Latitude",
	type: [
		"number",
		"string",
		"null"
	],
	anyOf: [{ $ref: "#/components/schemas/common_defs_latitude" }, { type: "null" }]
}, qi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.Longitude",
	type: [
		"number",
		"string",
		"null"
	],
	anyOf: [{ $ref: "#/components/schemas/common_defs_longitude" }, { type: "null" }]
}, Ji = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "order",
	description: "Specify whether the results should be sorted in ascending or descending order.",
	type: "string",
	enum: ["ASC", "DESC"],
	oneOf: [{
		enum: ["ASC"],
		title: "Ascending",
		description: "Results are ordered from lesser to greater values, e.g. from A to Z."
	}, {
		enum: ["DESC"],
		title: "Descending",
		description: "Results are ordered from greater to lesser values, e.g. from Z to A."
	}]
}, Yi = {
	$schema: "https://json-schema.org/draft-04/schema#",
	title: "Shipment Package Type",
	anyOf: [
		{ $ref: "#/components/schemas/_ref_shipment_package_type" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_package_type" }
		},
		{
			type: "string",
			pattern: "^[1-7](;[1-7]){0,5}$"
		}
	]
}, Xi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "page",
	description: "Request a specific page of the results, used for paginated results.",
	type: "integer",
	minimum: 1,
	maximum: 1e3
}, Zi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.parameters.PlatformIdentifier",
	type: ["string", "null"],
	anyOf: [{ $ref: "#/components/schemas/account_defs_platform_name" }, { $ref: "#/components/schemas/account_parameters_platform_id" }]
}, Qi = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.defs.PlatformName",
	type: "string",
	enum: [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	],
	oneOf: [
		{
			title: "myparcel",
			enum: ["myparcel"]
		},
		{
			title: "flespakket",
			enum: ["flespakket"]
		},
		{
			title: "belgie",
			enum: ["belgie"]
		},
		{
			title: "delivery_dutch",
			enum: ["delivery_dutch"]
		},
		{
			title: "postnl_customer",
			enum: ["postnl_customer"]
		},
		{
			title: "italy",
			enum: ["italy"]
		}
	],
	"x-enum-varnames": [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	]
}, $i = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "account.parameters.PlatformId",
	type: "string",
	enum: [
		"1",
		"2",
		"3",
		"4",
		"5",
		"6"
	],
	oneOf: [
		{
			title: "myparcel",
			enum: ["1"]
		},
		{
			title: "flespakket",
			enum: ["2"]
		},
		{
			title: "belgie",
			enum: ["3"]
		},
		{
			title: "delivery_dutch",
			enum: ["4"]
		},
		{
			title: "postnl_customer",
			enum: ["5"]
		},
		{
			title: "italy",
			enum: ["6"]
		}
	],
	"x-enum-varnames": [
		"myparcel",
		"flespakket",
		"belgie",
		"delivery_dutch",
		"postnl_customer",
		"italy"
	]
}, ea = {
	$schema: "https://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.LabelPosition",
	description: "The position of the label on the paper.",
	anyOf: [{ $ref: "#/components/schemas/_ref_shipment_label_printing_position" }, {
		type: "string",
		pattern: "^[1-4](;[1-4]){0,3}$"
	}]
}, ta = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.label.PrintingPosition",
	description: "The position of the label on the paper.",
	type: "integer",
	enum: [
		1,
		2,
		3,
		4
	],
	oneOf: [
		{
			enum: [1],
			title: "TopLeftQuadrant",
			description: "Top-Left Quadrant"
		},
		{
			enum: [2],
			title: "TopRightQuadrant",
			description: "Top-Right Quadrant"
		},
		{
			enum: [3],
			title: "BottomLeftQuadrant",
			description: "Bottom-Left Quadrant"
		},
		{
			enum: [4],
			title: "BottomRightQuadrant",
			description: "Bottom-Right Quadrant"
		}
	],
	"x-enum-varnames": [
		"TopLeftQuadrant",
		"TopRightQuadrant",
		"BottomLeftQuadrant",
		"BottomRightQuadrant"
	],
	"x-enum-descriptions": [
		"Top-Left Quadrant",
		"Top-Right Quadrant",
		"Bottom-Left Quadrant",
		"Bottom-Right Quadrant"
	]
}, na = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "shipment.parameters.PostalCode",
	type: ["string", "null"],
	minLength: 2,
	maxLength: 12,
	pattern: "^[a-zA-Z0-9\\-\\s]{2,12}$",
	format: "postal-code"
}, ra = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.BigIds",
	type: ["integer", "string"],
	anyOf: [{ $ref: "#/components/schemas/common_parameters_bigid" }, {
		type: "string",
		pattern: "^;*[1-9][0-9]{0,18}(;([1-9][0-9]{0,18}|[a-zA-Z]+)?)*$"
	}]
}, ia = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "common.parameters.BigId",
	type: "integer",
	format: "int64",
	minimum: 1,
	maximum: 0x8000000000000000
}, aa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	anyOf: [
		{ $ref: "#/components/schemas/_ref_shipment_type" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/_ref_shipment_type" }
		},
		{
			type: "string",
			pattern: "^[1-8](;[1-8]){0,7}$"
		}
	]
}, oa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "ids",
	anyOf: [
		{ $ref: "#/components/schemas/common_parameters_id" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/common_parameters_id" }
		},
		{
			type: "string",
			pattern: "^[1-9][0-9]{0,9}(;[1-9][0-9]{0,9})*$"
		}
	]
}, sa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "id",
	type: "integer",
	format: "int32",
	minimum: 1,
	maximum: 2147483647
}, ca = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "size",
	description: "Specify the number of resources returned per page, used for paginated results.",
	type: "integer",
	minimum: 1,
	maximum: 1e4
}, la = {
	$schema: "http://package-json.org/draft-04/schema#",
	type: "string",
	enum: [
		"amount",
		"created",
		"created_by",
		"currency",
		"drop_off_point",
		"hidden",
		"id",
		"mark_delivered",
		"modified",
		"modified_by",
		"order_shipment_identifier",
		"parent_id",
		"recipient",
		"reference_identifier",
		"sender",
		"shipment_type",
		"shop_id",
		"status",
		"transaction_status"
	]
}, ua = {
	$schema: "http://json-schema.org/draft-04/schema#",
	oneOf: [
		{ $ref: "#/components/schemas/shipment_defs_shipment_status" },
		{
			type: "array",
			items: { $ref: "#/components/schemas/shipment_defs_shipment_status" }
		},
		{
			type: "string",
			pattern: "^(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101)(;(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101))*$"
		}
	]
}, da = {
	$schema: "http://package-json.org/draft-04/schema#",
	title: "extra_info",
	type: "string",
	pattern: "^(?:;*(delivery_moment|returnable|signature)(?=;|$)(?!.*;\\1(?:;|$)))+;*$"
}, fa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["shipments"],
		additionalProperties: !1,
		properties: {
			user_agent: {
				type: "string",
				maxLength: 255
			},
			shipments: {
				type: "array",
				minItems: 1,
				maxItems: 100,
				items: {
					type: "object",
					required: ["options", "carrier"],
					additionalProperties: !1,
					properties: {
						account_id: { type: "integer" },
						shop_id: { type: "integer" },
						contract_id: { type: "integer" },
						reference_identifier: {
							type: ["integer", "string"],
							maxLength: 255,
							pattern: "^[^=\\?]*$"
						},
						recipient: {
							type: "object",
							required: [
								"cc",
								"postal_code",
								"city",
								"street",
								"person"
							],
							additionalProperties: !1,
							properties: {
								cc: {
									type: "string",
									minLength: 2,
									maxLength: 2
								},
								region: {
									type: "string",
									maxLength: 35
								},
								state: {
									type: "string",
									maxLength: 2
								},
								postal_code: {
									type: "string",
									maxLength: 10
								},
								city: {
									type: "string",
									maxLength: 35,
									minLength: 1
								},
								street: {
									type: "string",
									maxLength: 40,
									minLength: 1,
									pattern: "\\D+"
								},
								street_additional_info: {
									type: "string",
									maxLength: 50
								},
								number: {
									type: "string",
									maxLength: 8
								},
								number_suffix: {
									type: "string",
									maxLength: 6
								},
								box_number: {
									type: "string",
									maxLength: 8
								},
								area: {
									type: "string",
									maxLength: 35
								},
								person: {
									type: "string",
									maxLength: 50,
									minLength: 1
								},
								company: {
									type: "string",
									maxLength: 50
								},
								email: { anyOf: [{
									type: "string",
									format: "email"
								}, {
									type: "string",
									maxLength: 0
								}] },
								secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
								phone: {
									type: "string",
									maxLength: 25
								},
								eori_number: { type: ["string", "null"] },
								vat_number: { type: ["string", "null"] }
							}
						},
						sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
						recipients: {
							type: "array",
							minItems: 1,
							items: { type: "number" }
						},
						physical_properties: {
							type: "object",
							required: ["weight"],
							additionalProperties: !1,
							properties: {
								weight: {
									type: "integer",
									minimum: 0,
									maximum: 999999999
								},
								height: { type: "integer" },
								width: { type: "integer" },
								length: { type: "integer" },
								volume: { type: "integer" }
							}
						},
						options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
						customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
						carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
						pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
						drop_off_point: {
							type: ["object", "null"],
							required: [
								"location_code",
								"postal_code",
								"location_name",
								"city",
								"street",
								"number"
							],
							additionalProperties: !1,
							properties: {
								postal_code: { type: "string" },
								location_name: { type: "string" },
								city: { type: "string" },
								street: { type: "string" },
								number: { type: "string" },
								number_suffix: { type: "string" },
								box_number: { type: "string" },
								region: { type: "string" },
								state: { type: "string" },
								cc: { type: "string" },
								location_code: { type: "string" },
								retail_network_id: { type: "string" }
							}
						},
						note: { type: "string" },
						status: {
							type: "integer",
							enum: [
								1,
								2,
								3,
								4,
								5,
								6,
								7,
								8
							]
						},
						delivered: {
							type: "integer",
							enum: [0]
						},
						general_settings: {
							type: "object",
							additionalProperties: !1,
							properties: {
								save_recipient_address: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification_email: {
									type: "array",
									items: { type: "string" }
								},
								disable_auto_detect_pickup: {
									type: "integer",
									enum: [0, 1]
								},
								printer_identifier: { type: "string" }
							}
						},
						secondary_shipments: {
							type: "array",
							minItems: 1,
							items: {
								type: "object",
								additionalProperties: !1,
								properties: {
									account_id: { type: "integer" },
									shop_id: { type: "integer" },
									reference_identifier: {
										type: ["integer", "string"],
										maxLength: 255,
										pattern: "^[^=\\?]*$"
									},
									recipient: {
										type: "object",
										additionalProperties: !1,
										properties: {
											cc: {
												type: "string",
												minLength: 2,
												maxLength: 2
											},
											region: {
												type: "string",
												maxLength: 35
											},
											state: {
												type: "string",
												maxLength: 2
											},
											postal_code: {
												type: "string",
												maxLength: 10
											},
											city: {
												type: "string",
												maxLength: 35,
												minLength: 1
											},
											street: {
												type: "string",
												maxLength: 40,
												minLength: 1
											},
											street_additional_info: {
												type: "string",
												maxLength: 50
											},
											number: {
												type: "string",
												maxLength: 8
											},
											number_suffix: {
												type: "string",
												maxLength: 6
											},
											box_number: {
												type: "string",
												maxLength: 8
											},
											area: {
												type: "string",
												maxLength: 35
											},
											person: {
												type: "string",
												maxLength: 50,
												minLength: 1
											},
											company: {
												type: "string",
												maxLength: 50
											},
											email: { anyOf: [{
												type: "string",
												format: "email"
											}, {
												type: "string",
												maxLength: 0
											}] },
											secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
											phone: {
												type: "string",
												maxLength: 25
											},
											eori_number: { type: ["string", "null"] },
											vat_number: { type: ["string", "null"] }
										}
									},
									recipients: {
										type: "array",
										minItems: 1,
										items: { type: "number" }
									},
									physical_properties: {
										type: "object",
										required: ["weight"],
										additionalProperties: !1,
										properties: {
											weight: {
												type: "integer",
												minimum: 0,
												maximum: 999999999
											},
											height: { type: "integer" },
											width: { type: "integer" },
											length: { type: "integer" },
											volume: { type: "integer" }
										}
									},
									options: { $ref: "#/components/schemas/_ref_shipment_shipment_options" },
									customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
									carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
									pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
									drop_off_point: {
										type: ["object", "null"],
										required: [
											"location_code",
											"postal_code",
											"location_name",
											"city",
											"street",
											"number"
										],
										additionalProperties: !1,
										properties: {
											postal_code: { type: "string" },
											location_name: { type: "string" },
											city: { type: "string" },
											street: { type: "string" },
											number: { type: "string" },
											number_suffix: { type: "string" },
											box_number: { type: "string" },
											region: { type: "string" },
											state: { type: "string" },
											cc: { type: "string" },
											location_code: { type: "string" },
											retail_network_id: { type: "string" }
										}
									},
									note: { type: "string" },
									status: {
										type: "integer",
										enum: [
											1,
											2,
											3,
											4,
											5,
											6,
											7,
											8
										]
									},
									delivered: {
										type: "integer",
										enum: [0]
									},
									general_settings: {
										type: "object",
										additionalProperties: !1,
										properties: { save_recipient_address: {
											type: "integer",
											enum: [0, 1]
										} }
									},
									hidden: {
										type: "integer",
										enum: [0, 1]
									},
									shipped_items: {
										type: "array",
										minItems: 0,
										items: {
											type: "object",
											required: ["order_line_identifier", "quantity"],
											properties: {
												order_line_identifier: { type: "string" },
												quantity: {
													type: "integer",
													minimum: 1
												}
											}
										}
									}
								}
							}
						},
						collection_contact: {
							required: [
								"cc",
								"city",
								"company",
								"email",
								"last_name",
								"number",
								"phone",
								"postal_code",
								"street"
							],
							properties: {
								cc: {
									type: "string",
									minLength: 2,
									maxLength: 2
								},
								city: {
									type: "string",
									maxLength: 255,
									minLength: 1
								},
								company: { type: ["string"] },
								email: {
									type: "string",
									format: "email"
								},
								first_name: { type: "string" },
								gender: {
									type: "string",
									enum: ["mr", "mrs"]
								},
								last_name: { type: "string" },
								number: {
									type: ["string", "integer"],
									minLength: 1
								},
								number_suffix: { type: ["string", "null"] },
								phone: {
									type: "string",
									minLength: 8
								},
								postal_code: {
									type: "string",
									minLength: 1
								},
								street: {
									type: "string",
									minLength: 1
								},
								street_additional_info: { type: ["string", "null"] }
							},
							type: "object"
						},
						hidden: {
							type: "integer",
							enum: [0, 1]
						},
						shipped_items: {
							type: "array",
							minItems: 0,
							items: {
								type: "object",
								required: ["order_line_identifier", "quantity"],
								properties: {
									order_line_identifier: { type: "string" },
									quantity: {
										type: "integer",
										minimum: 1
									}
								}
							}
						}
					}
				}
			}
		}
	} }
}, pa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "array",
	maxItems: 4,
	items: { anyOf: [{
		type: "string",
		format: "email"
	}, {
		type: "string",
		maxLength: 0
	}] }
}, ma = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: [
		"cc",
		"postal_code",
		"city",
		"street",
		"person"
	],
	properties: {
		cc: {
			type: "string",
			minLength: 2,
			maxLength: 2
		},
		postal_code: { type: "string" },
		city: { type: "string" },
		street: { type: "string" },
		street_additional_info: { type: ["null", "string"] },
		number: { type: "string" },
		number_suffix: { type: "string" },
		box_number: {
			type: "string",
			maxLength: 8
		},
		region: {
			type: "string",
			maxLength: 35
		},
		person: { type: "string" },
		company: { type: "string" },
		phone: { type: "string" },
		email: { anyOf: [
			{
				type: "string",
				format: "email"
			},
			{
				type: "string",
				maxLength: 0
			},
			{ type: "null" }
		] }
	},
	additionalProperties: !1
}, ha = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: ["object", "null"],
	properties: {
		postal_code: { type: "string" },
		location_name: { type: "string" },
		city: { type: "string" },
		street: { type: "string" },
		number: { type: "string" },
		number_suffix: { type: ["string", "null"] },
		box_number: {
			type: "string",
			maxLength: 8
		},
		region: {
			type: "string",
			maxLength: 35
		},
		state: {
			type: "string",
			maxLength: 2
		},
		cc: {
			type: "string",
			maxLength: 2,
			minLength: 2,
			pattern: "^[A-Z]{2}"
		},
		location_code: { type: "string" },
		location_type: { $ref: "#/components/schemas/_ref_shipment_bpost_bpost_pugo_type" },
		retail_network_id: { type: "string" }
	},
	additionalProperties: !1
}, ga = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "_ref.shipment.bpost.BpostPugoType",
	type: "integer",
	enum: [
		0,
		1,
		2,
		4,
		8,
		16
	],
	oneOf: [
		{
			enum: [0],
			title: "Unknown"
		},
		{
			enum: [1],
			title: "PostOffice"
		},
		{
			enum: [2],
			title: "PostPoint"
		},
		{
			enum: [4],
			title: "ParcelLocker"
		},
		{
			enum: [8],
			title: "ClickCollect"
		},
		{
			enum: [16],
			title: "ParcelPoint"
		}
	],
	"x-enum-varnames": [
		"Unknown",
		"PostOffice",
		"PostPoint",
		"ParcelLocker",
		"ClickCollect",
		"ParcelPoint"
	]
}, _a = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		required: ["shipments"],
		properties: {
			user_agent: {
				type: "string",
				maxLength: 255
			},
			shipments: {
				type: "array",
				minItems: 1,
				maxItems: 100,
				items: {
					type: "object",
					required: [
						"carrier",
						"recipient",
						"options"
					],
					additionalProperties: !1,
					properties: {
						account_id: { type: "integer" },
						shop_id: { type: "integer" },
						reference_identifier: {
							type: ["integer", "string"],
							maxLength: 255,
							pattern: "^[^=\\?]*$"
						},
						recipient: {
							type: "object",
							required: [
								"cc",
								"city",
								"street",
								"person"
							],
							additionalProperties: !1,
							properties: {
								cc: {
									type: "string",
									minLength: 2,
									maxLength: 2
								},
								region: {
									type: "string",
									maxLength: 35
								},
								state: {
									type: "string",
									maxLength: 2
								},
								postal_code: {
									type: "string",
									maxLength: 10
								},
								city: {
									type: "string",
									maxLength: 35,
									minLength: 1
								},
								street: {
									type: "string",
									maxLength: 40,
									minLength: 1,
									pattern: "\\D+"
								},
								street_additional_info: {
									type: "string",
									maxLength: 50
								},
								number: {
									type: "string",
									maxLength: 8
								},
								number_suffix: {
									type: "string",
									maxLength: 6
								},
								box_number: {
									type: "string",
									maxLength: 8
								},
								area: {
									type: "string",
									maxLength: 35
								},
								person: {
									type: "string",
									maxLength: 50,
									minLength: 1
								},
								company: {
									type: "string",
									maxLength: 50
								},
								email: { anyOf: [{
									type: "string",
									format: "email"
								}, {
									type: "string",
									maxLength: 0
								}] },
								secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
								phone: {
									type: "string",
									maxLength: 25
								}
							}
						},
						sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
						recipients: {
							type: "array",
							minItems: 1,
							items: { type: "number" }
						},
						physical_properties: {
							type: "object",
							required: ["weight"],
							additionalProperties: !1,
							properties: {
								weight: {
									type: "integer",
									minimum: 0,
									maximum: 999999999
								},
								height: { type: "integer" },
								width: { type: "integer" },
								length: { type: "integer" },
								volume: { type: "integer" }
							}
						},
						options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
						customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
						carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
						pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
						"multi-colli": {
							type: ["object", "null"],
							required: ["amount"],
							additionalProperties: !1,
							properties: { amount: { type: "integer" } }
						},
						note: { type: "string" },
						status: {
							type: "integer",
							enum: [
								1,
								2,
								3,
								4,
								5,
								6,
								7,
								8
							]
						},
						delivered: {
							type: "integer",
							enum: [0]
						},
						general_settings: {
							type: "object",
							additionalProperties: !1,
							properties: {
								save_recipient_address: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification: {
									type: "integer",
									enum: [0, 1]
								},
								delivery_notification_email: {
									type: "array",
									items: { type: "string" }
								},
								disable_auto_detect_pickup: {
									type: "integer",
									enum: [0, 1]
								},
								printer_identifier: { type: "string" }
							}
						},
						hidden: {
							type: "integer",
							enum: [0, 1]
						}
					}
				}
			}
		}
	} }
}, va = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Return Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { return_shipments: {
			type: "array",
			minItems: 1,
			items: {
				type: "object",
				required: [
					"parent",
					"carrier",
					"email",
					"name"
				],
				allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options_returns" }],
				properties: {
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					contract_id: { type: "integer" },
					parent: { type: "integer" },
					reference_identifier: {
						type: ["integer", "string"],
						maxLength: 255,
						pattern: "^[^=\\?]*$"
					},
					carrier: { $ref: "#/components/schemas/_ref_types_carrier_returns" },
					email: { type: "string" },
					name: { type: "string" },
					sender: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							postal_code: { type: "string" },
							city: { type: "string" },
							street: { type: "string" },
							street_additional_info: { type: "string" },
							number: { type: "string" },
							number_suffix: { type: "string" },
							box_number: {
								type: "string",
								maxLength: 8
							},
							region: {
								type: "string",
								maxLength: 35
							},
							person: { type: "string" },
							company: { type: "string" },
							email: { anyOf: [
								{
									type: "string",
									format: "email"
								},
								{
									type: "string",
									maxLength: 0
								},
								{ type: "null" }
							] },
							phone: { type: "string" }
						}
					},
					physical_properties: {
						type: "object",
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					general_settings: {
						type: "object",
						properties: { save_recipient_address: {
							type: "integer",
							enum: [0, 1]
						} }
					}
				}
			}
		} }
	} }
}, ya = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { options: {
		type: "object",
		allOf: [
			{ $ref: "#/components/schemas/_ref_shipment_options_package_type_returns" },
			{ $ref: "#/components/schemas/_ref_shipment_options_insurance_max" },
			{ $ref: "#/components/schemas/_ref_shipment_options_options_returns" },
			{ $ref: "#/components/schemas/_ref_shipment_options_label_description" }
		],
		properties: {
			contribution: {
				allOf: [{ $ref: "#/components/schemas/_ref_types_money" }],
				properties: { amount: { maximum: 1e5 } }
			},
			printerless_return: { $ref: "#/components/schemas/_ref_types_int_boolean" }
		}
	} }
}, ba = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: { package_type: {
		type: "integer",
		enum: [
			1,
			2,
			6
		],
		anyOf: [
			{ $ref: "#/components/schemas/_ref_shipment_package_type_1_package" },
			{ $ref: "#/components/schemas/_ref_shipment_package_type_2_mailbox" },
			{ $ref: "#/components/schemas/_ref_shipment_package_type_6_small_package" }
		]
	} }
}, xa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [1],
	title: "Package",
	description: "Regular package."
}, Sa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [2],
	title: "Mailbox",
	description: "Shipment that fits through a mailbox slot."
}, Ca = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [6],
	title: "Small Package"
}, wa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		age_check: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		cooled_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		drop_off_at_postal_point: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		extra_assurance: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		hide_sender: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		large_format: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		only_recipient: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		receipt_code: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		return: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		same_day_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		saturday_delivery: { $ref: "#/components/schemas/_ref_types_int_boolean" },
		signature: { $ref: "#/components/schemas/_ref_types_int_boolean" }
	}
}, Ta = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "integer",
	enum: [
		1,
		2,
		4,
		9,
		10,
		11,
		14,
		15,
		18
	]
}, Ea = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Return Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { return_shipments: {
			type: "array",
			minItems: 1,
			items: {
				type: "object",
				required: ["carrier"],
				allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options_returns" }],
				properties: {
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					carrier: { $ref: "#/components/schemas/_ref_types_carrier_returns" },
					email: { type: "string" },
					name: { type: "string" },
					cc: { type: "string" },
					sender: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							postal_code: { type: "string" },
							city: { type: "string" },
							street: { type: "string" },
							street_additional_info: { type: "string" },
							number: { type: "string" },
							number_suffix: { type: "string" },
							box_number: {
								type: "string",
								maxLength: 8
							},
							region: {
								type: "string",
								maxLength: 35
							},
							person: { type: "string" },
							company: { type: "string" },
							email: { anyOf: [
								{
									type: "string",
									format: "email"
								},
								{
									type: "string",
									maxLength: 0
								},
								{ type: "null" }
							] },
							phone: { type: "string" }
						}
					},
					physical_properties: {
						type: "object",
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					general_settings: {
						type: "object",
						properties: { save_recipient_address: {
							type: "integer",
							enum: [0, 1]
						} }
					}
				}
			}
		} }
	} }
}, Da = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { shipments: {
			type: "array",
			minItems: 1,
			maxItems: 100,
			items: {
				type: "object",
				required: [
					"id",
					"carrier",
					"options"
				],
				additionalProperties: !1,
				properties: {
					id: { type: "integer" },
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					contract_id: { type: "integer" },
					reference_identifier: {
						type: ["integer", "string"],
						maxLength: 255,
						pattern: "^[^=\\?]*$"
					},
					carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
					status: { type: "integer" },
					delivered: {
						type: "integer",
						enum: [0, 1]
					},
					recipient: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							region: {
								type: "string",
								maxLength: 32
							},
							state: {
								type: "string",
								maxLength: 2
							},
							postal_code: {
								type: "string",
								maxLength: 10
							},
							city: {
								type: "string",
								maxLength: 35
							},
							street: {
								type: "string",
								maxLength: 40
							},
							street_additional_info: {
								type: "string",
								maxLength: 50
							},
							number: {
								type: ["string", "null"],
								maxLength: 8
							},
							number_suffix: {
								type: ["string", "null"],
								maxLength: 6
							},
							box_number: {
								type: "string",
								maxLength: 8
							},
							person: {
								type: "string",
								maxLength: 50
							},
							company: {
								type: "string",
								maxLength: 50
							},
							email: { anyOf: [{
								type: "string",
								format: "email"
							}, {
								type: "string",
								maxLength: 0
							}] },
							secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
							phone: {
								type: "string",
								maxLength: 25
							},
							eori_number: { type: ["string", "null"] },
							vat_number: { type: ["string", "null"] }
						}
					},
					sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
					options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					physical_properties: {
						type: "object",
						required: ["weight"],
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					pickup: {
						required: [
							"postal_code",
							"location_name",
							"city",
							"street"
						],
						$ref: "#/components/schemas/_ref_shipment_pickup"
					},
					drop_off_point: {
						type: ["object", "null"],
						required: [
							"location_code",
							"postal_code",
							"location_name",
							"city",
							"street",
							"number"
						],
						additionalProperties: !1,
						properties: {
							postal_code: { type: "string" },
							location_name: { type: "string" },
							city: { type: "string" },
							street: { type: "string" },
							number: { type: "string" },
							number_suffix: { type: "string" },
							box_number: { type: "string" },
							region: { type: "string" },
							state: { type: "string" },
							cc: { type: "string" },
							location_code: { type: "string" },
							retail_network_id: { type: "string" }
						}
					},
					note: { type: "string" },
					general_settings: {
						type: "object",
						additionalProperties: !1,
						properties: {
							save_recipient_address: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification_email: {
								type: "array",
								items: { type: "string" }
							},
							disable_auto_detect_pickup: {
								type: "integer",
								enum: [0, 1]
							},
							printer_identifier: { type: "string" }
						}
					},
					multi_collo_main_shipment_id: { type: ["integer", "null"] },
					secondary_shipments: {
						type: "array",
						minItems: 1,
						items: {
							type: "object",
							additionalProperties: !1,
							properties: {
								id: { type: "integer" },
								account_id: { type: "integer" },
								shop_id: { type: "integer" },
								reference_identifier: {
									type: ["integer", "string"],
									maxLength: 255,
									pattern: "^[^=\\?]*$"
								},
								recipient: {
									type: "object",
									additionalProperties: !1,
									properties: {
										cc: {
											type: "string",
											minLength: 2,
											maxLength: 2
										},
										region: {
											type: "string",
											maxLength: 35
										},
										state: {
											type: "string",
											maxLength: 2
										},
										postal_code: {
											type: "string",
											maxLength: 10
										},
										city: {
											type: "string",
											maxLength: 35,
											minLength: 1
										},
										street: {
											type: "string",
											maxLength: 40,
											minLength: 1
										},
										street_additional_info: {
											type: "string",
											maxLength: 50
										},
										number: {
											type: ["string", "null"],
											maxLength: 8
										},
										number_suffix: {
											type: ["string", "null"],
											maxLength: 6
										},
										box_number: {
											type: "string",
											maxLength: 8
										},
										area: {
											type: "string",
											maxLength: 35
										},
										person: {
											type: "string",
											maxLength: 50,
											minLength: 1
										},
										company: {
											type: "string",
											maxLength: 50
										},
										email: { anyOf: [{
											type: "string",
											format: "email"
										}, {
											type: "string",
											maxLength: 0
										}] },
										secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
										phone: {
											type: "string",
											maxLength: 25
										},
										eori_number: { type: ["string", "null"] },
										vat_number: { type: ["string", "null"] }
									}
								},
								recipients: {
									type: "array",
									minItems: 1,
									items: { type: "number" }
								},
								physical_properties: {
									type: "object",
									required: ["weight"],
									additionalProperties: !1,
									properties: {
										weight: {
											type: "integer",
											minimum: 0,
											maximum: 999999999
										},
										height: { type: "integer" },
										width: { type: "integer" },
										length: { type: "integer" },
										volume: { type: "integer" }
									}
								},
								options: { $ref: "#/components/schemas/_ref_shipment_shipment_options" },
								customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
								carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
								pickup: { $ref: "#/components/schemas/_ref_shipment_pickup" },
								drop_off_point: {
									type: ["object", "null"],
									required: [
										"location_code",
										"postal_code",
										"location_name",
										"city",
										"street",
										"number"
									],
									additionalProperties: !1,
									properties: {
										postal_code: { type: "string" },
										location_name: { type: "string" },
										city: { type: "string" },
										street: { type: "string" },
										number: { type: "string" },
										number_suffix: { type: "string" },
										box_number: { type: "string" },
										region: { type: "string" },
										state: { type: "string" },
										cc: { type: "string" },
										location_code: { type: "string" },
										retail_network_id: { type: "string" }
									}
								},
								note: { type: "string" },
								status: {
									type: "integer",
									enum: [
										1,
										2,
										3,
										4,
										5,
										6,
										7,
										8
									]
								},
								delivered: {
									type: "integer",
									enum: [0, 1]
								},
								general_settings: {
									type: "object",
									additionalProperties: !1,
									properties: { save_recipient_address: {
										type: "integer",
										enum: [0, 1]
									} }
								},
								multi_collo_main_shipment_id: { type: ["integer", "null"] },
								hidden: {
									type: "integer",
									enum: [0, 1]
								},
								shipped_items: {
									type: "array",
									minItems: 0,
									items: {
										type: "object",
										required: ["order_line_identifier", "quantity"],
										properties: {
											order_line_identifier: { type: "string" },
											quantity: {
												type: "integer",
												minimum: 1
											}
										}
									}
								}
							}
						}
					},
					collection_contact: {
						required: [
							"cc",
							"city",
							"number",
							"phone",
							"postal_code",
							"street"
						],
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							city: {
								type: "string",
								maxLength: 255,
								minLength: 1
							},
							company: { type: ["string", "null"] },
							email: {
								type: "string",
								format: "email"
							},
							first_name: { type: "string" },
							gender: {
								type: "string",
								enum: ["mr", "mrs"]
							},
							last_name: { type: "string" },
							number: {
								type: ["string", "integer"],
								minLength: 1
							},
							number_suffix: { type: ["string", "null"] },
							phone: {
								type: "string",
								minLength: 8
							},
							postal_code: {
								type: "string",
								minLength: 1
							},
							street: {
								type: "string",
								minLength: 1
							},
							street_additional_info: { type: ["string", "null"] }
						},
						type: "object"
					},
					hidden: {
						type: "integer",
						enum: [0, 1]
					},
					shipped_items: {
						type: "array",
						minItems: 0,
						items: {
							type: "object",
							required: ["order_line_identifier", "quantity"],
							properties: {
								order_line_identifier: { type: "string" },
								quantity: {
									type: "integer",
									minimum: 1
								}
							}
						}
					}
				}
			}
		} }
	} }
}, Oa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Shipments Set",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { shipments: {
			type: "array",
			minItems: 1,
			maxItems: 100,
			items: {
				type: "object",
				required: [
					"id",
					"carrier",
					"options"
				],
				additionalProperties: !1,
				properties: {
					id: { type: "integer" },
					account_id: { type: "integer" },
					shop_id: { type: "integer" },
					reference_identifier: {
						type: ["integer", "string"],
						maxLength: 255,
						pattern: "^[^=\\?]*$"
					},
					carrier: { $ref: "#/components/schemas/_ref_types_carrier" },
					status: { type: "integer" },
					delivered: {
						type: "integer",
						enum: [0, 1]
					},
					recipient: {
						type: "object",
						required: [
							"cc",
							"city",
							"street",
							"person"
						],
						additionalProperties: !1,
						properties: {
							cc: {
								type: "string",
								minLength: 2,
								maxLength: 2
							},
							region: {
								type: "string",
								maxLength: 32
							},
							state: {
								type: "string",
								maxLength: 2
							},
							postal_code: {
								type: "string",
								maxLength: 10
							},
							city: {
								type: "string",
								maxLength: 35
							},
							street: {
								type: "string",
								maxLength: 40
							},
							street_additional_info: {
								type: "string",
								maxLength: 50
							},
							number: {
								type: ["string", "null"],
								maxLength: 8
							},
							number_suffix: {
								type: ["string", "null"],
								maxLength: 6
							},
							box_number: {
								type: "string",
								maxLength: 8
							},
							person: {
								type: "string",
								maxLength: 50
							},
							company: {
								type: "string",
								maxLength: 50
							},
							email: { anyOf: [{
								type: "string",
								format: "email"
							}, {
								type: "string",
								maxLength: 0
							}] },
							secondary_emails: { $ref: "#/components/schemas/_ref_shipment_recipient_secondary_emails" },
							phone: {
								type: "string",
								maxLength: 25
							}
						}
					},
					sender: { $ref: "#/components/schemas/_ref_shipment_sender" },
					options: { allOf: [{ $ref: "#/components/schemas/_ref_shipment_shipment_options" }, { required: ["package_type"] }] },
					customs_declaration: { $ref: "#/components/schemas/_ref_shipment_customs_declaration" },
					physical_properties: {
						type: "object",
						required: ["weight"],
						additionalProperties: !1,
						properties: {
							weight: {
								type: "integer",
								minimum: 0,
								maximum: 999999999
							},
							height: { type: "integer" },
							width: { type: "integer" },
							length: { type: "integer" },
							volume: { type: "integer" }
						}
					},
					pickup: {
						required: [
							"postal_code",
							"location_name",
							"city",
							"street"
						],
						$ref: "#/components/schemas/_ref_shipment_pickup"
					},
					note: { type: "string" },
					general_settings: {
						type: "object",
						additionalProperties: !1,
						properties: {
							save_recipient_address: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification: {
								type: "integer",
								enum: [0, 1]
							},
							delivery_notification_email: {
								type: "array",
								items: { type: "string" }
							},
							disable_auto_detect_pickup: {
								type: "integer",
								enum: [0, 1]
							},
							printer_identifier: { type: "string" }
						}
					},
					hidden: {
						type: "integer",
						enum: [0, 1]
					}
				}
			}
		} }
	} }
}, ka = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine capabilities V2",
	type: "object",
	required: ["recipient"],
	additionalProperties: !1,
	properties: {
		shopId: {
			type: "integer",
			description: "The ID of the shop for which the capabilities are requested."
		},
		contractId: {
			type: "integer",
			description: "The ID of the contract for which the capabilities are requested."
		},
		recipient: {
			type: "object",
			description: "Recipient data.",
			required: ["countryCode"],
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the recipient.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the recipient.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					default: !0,
					description: "Whether this is a business address."
				}
			}
		},
		sender: {
			type: "object",
			description: "Sender data.",
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the sender.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the sender.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					default: !0,
					description: "Whether this is a business address."
				}
			}
		},
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		packageType: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" },
		physicalProperties: {
			type: "object",
			description: "Physical properties of the package.",
			additionalProperties: !1,
			properties: {
				height: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							maximum: 1e4,
							description: "The height value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The height of the package"
				},
				width: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							maximum: 1e4,
							description: "The width value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The width of the package"
				},
				length: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							maximum: 1e4,
							description: "The length value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The length of the package"
				},
				weight: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The weight value"
						},
						unit: {
							type: "string",
							enum: ["g", "kg"],
							description: "The unit of measurement in SI units (e.g., g, kg)"
						}
					},
					description: "The weight of the package"
				}
			}
		},
		options: {
			type: "object",
			additionalProperties: !1,
			properties: {
				additionalInsurance: {
					type: "object",
					additionalProperties: !1,
					description: "Additional insurance option"
				},
				deliverAtPostalPoint: {
					type: "object",
					additionalProperties: !1,
					description: "Deliver at postal point option"
				},
				hideSender: {
					type: "object",
					additionalProperties: !1,
					description: "Hide sender option"
				},
				insurance: {
					type: "object",
					additionalProperties: !1,
					description: "Insurance option"
				},
				noTracking: {
					type: "object",
					additionalProperties: !1,
					description: "No tracking option (inverse of tracked)"
				},
				oversizedPackage: {
					type: "object",
					additionalProperties: !1,
					description: "Oversized package option"
				},
				printReturnLabelAtDropOff: {
					type: "object",
					additionalProperties: !1,
					description: "Print return label at drop off package option"
				},
				priorityDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Priority delivery package option"
				},
				recipientOnlyDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Recipient only delivery option"
				},
				returnOnFirstFailedDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Return on first failed delivery option"
				},
				requiresAgeVerification: {
					type: "object",
					additionalProperties: !1,
					description: "Requires age verification option"
				},
				requiresCashOnDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Cash on delivery option"
				},
				requiresReceiptCode: {
					type: "object",
					additionalProperties: !1,
					description: "Requires receipt code option"
				},
				requiresSignature: {
					type: "object",
					additionalProperties: !1,
					description: "Requires signature option"
				},
				sameDayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Same day delivery option"
				},
				saturdayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Saturday delivery option"
				},
				scheduledCollection: {
					type: "object",
					additionalProperties: !1,
					description: "Scheduled collection option"
				}
			},
			description: "Shipment options object. Empty objects indicate the option is requested/enabled."
		},
		deliveryType: {
			type: "string",
			enum: [
				"EVENING_DELIVERY",
				"EXPRESS_DELIVERY",
				"EARLY_MORNING_DELIVERY",
				"MORNING_DELIVERY",
				"PICKUP_DELIVERY",
				"SAME_DAY_DELIVERY",
				"STANDARD_DELIVERY"
			]
		},
		direction: {
			type: "string",
			enum: ["INBOUND", "OUTBOUND"],
			description: "The shipment direction for which the capabilities are requested."
		},
		pickup: {
			type: "object",
			description: "Pickup location criteria for filtering capabilities.",
			additionalProperties: !1,
			properties: { location: {
				type: "object",
				description: "Pickup location details.",
				additionalProperties: !1,
				properties: { type: {
					type: "string",
					enum: ["RETAIL", "LOCKER"],
					description: "Type of pickup location. RETAIL for shops/postal points, LOCKER for automated parcel lockers."
				} }
			} }
		}
	}
}, Aa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine capabilities",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["capabilities"],
		additionalProperties: !1,
		properties: { capabilities: {
			type: "array",
			items: {
				type: "object",
				required: ["recipient"],
				additionalProperties: !1,
				properties: {
					shop_id: {
						type: "integer",
						description: "The ID of the shop for which the capabilities are requested."
					},
					contract_id: {
						type: "integer",
						description: "The ID of the contract for which the capabilities are requested."
					},
					recipient: {
						type: "object",
						description: "Recipient data.",
						additionalProperties: !1,
						required: ["cc"],
						properties: {
							cc: {
								description: "Alpha-2 Country code of the recipient.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the recipient.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								default: !0,
								description: "Whether this is a business address."
							}
						}
					},
					sender: {
						type: "object",
						description: "Sender data.",
						additionalProperties: !1,
						properties: {
							cc: {
								description: "Alpha-2 Country code of the sender.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the sender.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								default: !0,
								description: "Whether this is a business address."
							}
						}
					},
					carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
					package_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6
						]
					},
					physical_properties: {
						type: "object",
						description: "Physical properties of the package.",
						additionalProperties: !1,
						properties: {
							height: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										maximum: 1e4,
										description: "The height value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The height of the package"
							},
							width: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										maximum: 1e4,
										description: "The width value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The width of the package"
							},
							length: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										maximum: 1e4,
										description: "The length value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The length of the package"
							},
							weight: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "integer",
										minimum: 0,
										description: "The weight value"
									},
									unit: {
										type: "string",
										enum: ["g", "kg"],
										description: "The unit of measurement in SI units (e.g., g, kg)"
									}
								},
								description: "The weight of the package"
							}
						}
					},
					options: {
						type: "object",
						additionalProperties: !1,
						description: "Shipment options object. Empty objects indicate the option is requested/enabled.",
						properties: {
							age_check: {
								type: "object",
								additionalProperties: !1,
								description: "Requires age verification option"
							},
							cash_on_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Cash on delivery option"
							},
							collect: {
								type: "object",
								additionalProperties: !1,
								description: "Scheduled collection option"
							},
							cooled_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Cooled delivery option"
							},
							drop_off_at_postal_point: {
								type: "object",
								additionalProperties: !1,
								description: "Deliver at postal point option"
							},
							extra_assurance: {
								type: "object",
								additionalProperties: !1,
								description: "Additional insurance option"
							},
							hide_sender: {
								type: "object",
								additionalProperties: !1,
								description: "Hide sender option"
							},
							large_format: {
								type: "object",
								additionalProperties: !1,
								description: "Oversized package option"
							},
							only_recipient: {
								type: "object",
								additionalProperties: !1,
								description: "Recipient only delivery option"
							},
							priority_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Priority delivery option"
							},
							printerless_return: {
								type: "object",
								additionalProperties: !1,
								description: "Printerless return delivery option"
							},
							receipt_code: {
								type: "object",
								additionalProperties: !1,
								description: "Requires receipt code option"
							},
							return: {
								type: "object",
								additionalProperties: !1,
								description: "Return on first failed delivery option"
							},
							same_day_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Same day delivery option"
							},
							saturday_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Saturday delivery option"
							},
							signature: {
								type: "object",
								additionalProperties: !1,
								description: "Requires signature option"
							},
							tracked: {
								type: "object",
								additionalProperties: !1,
								description: "Tracking option"
							},
							insurance: {
								type: "object",
								additionalProperties: !1,
								description: "Insurance option"
							}
						}
					},
					delivery_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					shipment_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					direction: {
						type: "string",
						enum: ["INBOUND", "OUTBOUND"],
						description: "The shipment direction for which the capabilities are requested."
					},
					pickup: {
						type: "object",
						description: "Pickup location criteria for filtering capabilities.",
						additionalProperties: !1,
						properties: { location_type: {
							type: "string",
							enum: ["retail", "locker"],
							description: "Type of pickup location. retail for shops/postal points, locker for automated parcel lockers."
						} }
					}
				}
			}
		} }
	} }
}, ja = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine the superset of contract definitions and carriers available for a given account, v2 format",
	type: "object",
	additionalProperties: !1,
	properties: { carrier: {
		type: "string",
		enum: [
			"BRT",
			"DHL_EUROPLUS",
			"DHL_PARCEL_CONNECT",
			"DPD",
			"DHL_FOR_YOU",
			"INPOST",
			"POSTNL"
		]
	} }
}, Ma = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine the superset of contract definitions and carriers available for a given account",
	type: "object",
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { carrier_id: {
			type: "integer",
			format: "int32",
			enum: [
				1,
				4,
				9,
				10,
				11,
				15,
				17
			]
		} }
	} }
}, Na = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine rates V2",
	type: "object",
	required: [
		"carrier",
		"packageType",
		"recipient"
	],
	additionalProperties: !1,
	properties: {
		shopId: {
			type: "integer",
			description: "The ID of the shop for which the rates are requested."
		},
		contractId: {
			type: "integer",
			description: "The ID of the contract for which the rates are requested."
		},
		recipient: {
			type: "object",
			description: "Recipient data.",
			required: ["countryCode"],
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the recipient.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the recipient.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					default: !0,
					description: "Whether this is a business address."
				}
			}
		},
		sender: {
			type: "object",
			description: "Sender data.",
			additionalProperties: !1,
			properties: {
				countryCode: {
					description: "Alpha-2 Country code of the sender.",
					type: "string",
					minLength: 2,
					maxLength: 2,
					pattern: "^[A-Z]{2}$"
				},
				postalCode: {
					description: "Postal code of the sender.",
					type: "string",
					minLength: 1,
					maxLength: 15
				},
				isBusiness: {
					type: "boolean",
					default: !0,
					description: "Whether this is a business address."
				}
			}
		},
		pickup: { $ref: "#/components/schemas/_ref_shipment_pickup-v2" },
		carrier: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier-v2" },
		packageType: { $ref: "#/components/schemas/_ref_shipment_package_type-v2" },
		physicalProperties: {
			type: "object",
			description: "Physical properties of the package.",
			additionalProperties: !1,
			properties: {
				height: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The height value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The height of the package"
				},
				width: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The width value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The width of the package"
				},
				length: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The length value"
						},
						unit: {
							type: "string",
							enum: ["cm", "mm"],
							description: "The unit of measurement in SI units (e.g., mm, cm)"
						}
					},
					description: "The length of the package"
				},
				weight: {
					type: "object",
					required: ["value", "unit"],
					additionalProperties: !1,
					properties: {
						value: {
							type: "number",
							minimum: 0,
							description: "The weight value"
						},
						unit: {
							type: "string",
							enum: ["g", "kg"],
							description: "The unit of measurement in SI units (e.g., g, kg)"
						}
					},
					description: "The weight of the package"
				}
			}
		},
		options: {
			type: "object",
			additionalProperties: !1,
			properties: {
				additionalInsurance: {
					type: "object",
					additionalProperties: !1,
					description: "Additional insurance option"
				},
				deliverAtPostalPoint: {
					type: "object",
					additionalProperties: !1,
					description: "Deliver at postal point option"
				},
				hideSender: {
					type: "object",
					additionalProperties: !1,
					description: "Hide sender option"
				},
				insurance: {
					type: "object",
					required: ["insuredAmount"],
					properties: { insuredAmount: { $ref: "#/components/schemas/_ref_types_money" } },
					additionalProperties: !1,
					description: "Insurance option"
				},
				noTracking: {
					type: "object",
					additionalProperties: !1,
					description: "No tracking option (inverse of tracked)"
				},
				oversizedPackage: {
					type: "object",
					additionalProperties: !1,
					description: "Oversized package option"
				},
				priorityDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Priority delivery package option"
				},
				recipientOnlyDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Recipient only delivery option"
				},
				returnOnFirstFailedDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Return on first failed delivery option"
				},
				requiresAgeVerification: {
					type: "object",
					additionalProperties: !1,
					description: "Requires age verification option"
				},
				requiresCashOnDelivery: {
					type: "object",
					required: ["dueAmount"],
					properties: { dueAmount: { $ref: "#/components/schemas/_ref_types_money" } },
					additionalProperties: !1,
					description: "Cash on delivery option"
				},
				requiresReceiptCode: {
					type: "object",
					additionalProperties: !1,
					description: "Requires receipt code option"
				},
				requiresSignature: {
					type: "object",
					additionalProperties: !1,
					description: "Requires signature option"
				},
				sameDayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Same day delivery option"
				},
				saturdayDelivery: {
					type: "object",
					additionalProperties: !1,
					description: "Saturday delivery option"
				},
				scheduledCollection: {
					type: "object",
					additionalProperties: !1,
					description: "Scheduled collection option"
				}
			},
			description: "Shipment options object. Empty objects indicate the option is requested/enabled."
		},
		deliveryType: {
			type: "string",
			enum: [
				"EARLY_MORNING_DELIVERY",
				"EVENING_DELIVERY",
				"EXPRESS_DELIVERY",
				"MORNING_DELIVERY",
				"PICKUP_DELIVERY",
				"SAME_DAY_DELIVERY",
				"STANDARD_DELIVERY"
			]
		},
		direction: {
			type: "string",
			enum: ["INBOUND", "OUTBOUND"],
			description: "The shipment direction for which the rates are requested."
		},
		collo: {
			type: "integer",
			minimum: 1,
			description: "The number of collo for which the rates are requested."
		}
	}
}, Pa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	description: "Pickup location data.",
	properties: {
		address: { $ref: "#/components/schemas/_ref_shipment_address-v2" },
		location: { $ref: "#/components/schemas/_ref_shipment_location-v2" },
		retailNetworkId: {
			type: "string",
			enum: ["PNPNL-01", "PNPBE-01"],
			description: "PostNL Retail network ID."
		}
	},
	additionalProperties: !1
}, Fa = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		city: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The city of the address."
		},
		countryCode: {
			type: "string",
			minLength: 2,
			maxLength: 2,
			pattern: "[A-Z]{2}",
			description: "The country code (ISO 3166-1 alpha-2) of the address."
		},
		street: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The street of the address."
		},
		additionalInformation: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "Additional information about the address."
		},
		boxNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The box number of the address. Only applicable for `countryCode`=`BE`."
		},
		houseNumber: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number of the address."
		},
		houseNumberSuffix: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number suffix of the address."
		},
		postalCode: {
			type: "string",
			minLength: 1,
			maxLength: 15,
			description: "The postal code of the address."
		},
		region: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The region of the address."
		},
		state: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The state of the address."
		}
	},
	required: [
		"city",
		"countryCode",
		"street"
	]
}, Ia = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	properties: {
		name: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The name of the pickup location."
		},
		code: {
			type: "string",
			minLength: 1,
			maxLength: 64,
			description: "The location code of the pickup location."
		},
		type: {
			type: "string",
			enum: [
				"CLICK_COLLECT",
				"PARCEL_LOCKER",
				"PARCEL_POINT",
				"POST_OFFICE",
				"POST_POINT"
			],
			description: "The bpost pickup location type."
		}
	},
	required: ["name"],
	additionalProperties: !1
}, La = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Determine rates",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		required: ["rates"],
		additionalProperties: !1,
		properties: { rates: {
			type: "array",
			minItems: 1,
			items: {
				type: "object",
				required: [
					"carrier_id",
					"package_type",
					"recipient"
				],
				additionalProperties: !1,
				properties: {
					shop_id: {
						type: "integer",
						description: "The ID of the shop for which the rates are requested."
					},
					contract_id: {
						type: "integer",
						description: "The ID of the contract for which the rates are requested."
					},
					recipient: {
						type: "object",
						description: "Recipient data.",
						additionalProperties: !1,
						required: ["cc"],
						properties: {
							cc: {
								description: "Alpha-2 Country code of the recipient.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the recipient.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								default: !0,
								description: "Whether this is a business address."
							}
						}
					},
					sender: {
						type: "object",
						description: "Sender data.",
						additionalProperties: !1,
						properties: {
							cc: {
								description: "Alpha-2 Country code of the sender.",
								type: "string",
								minLength: 2,
								maxLength: 2,
								pattern: "^[A-Z]{2}$"
							},
							postal_code: {
								description: "Postal code of the sender.",
								type: "string",
								minLength: 1,
								maxLength: 15
							},
							is_business: {
								type: "boolean",
								default: !0,
								description: "Whether this is a business address."
							}
						}
					},
					pickup: { $ref: "#/components/schemas/shipment_defs_shipment_pickup" },
					carrier_id: { $ref: "#/components/schemas/_ref_capabilities_shared_carrier" },
					package_type: { $ref: "#/components/schemas/_ref_shipment_package_type" },
					physical_properties: {
						type: "object",
						description: "Physical properties of the package.",
						additionalProperties: !1,
						properties: {
							height: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The height value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The height of the package"
							},
							width: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The width value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The width of the package"
							},
							length: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The length value"
									},
									unit: {
										type: "string",
										enum: ["cm", "mm"],
										description: "The unit of measurement in SI units (e.g., mm, cm)"
									}
								},
								description: "The length of the package"
							},
							weight: {
								type: "object",
								required: ["value", "unit"],
								additionalProperties: !1,
								properties: {
									value: {
										type: "number",
										minimum: 0,
										description: "The weight value"
									},
									unit: {
										type: "string",
										enum: ["g", "kg"],
										description: "The unit of measurement in SI units (e.g., g, kg)"
									}
								},
								description: "The weight of the package"
							}
						}
					},
					options: {
						type: "object",
						additionalProperties: !1,
						description: "Shipment options object. Empty objects indicate the option is requested/enabled.",
						properties: {
							age_check: {
								type: "object",
								additionalProperties: !1,
								description: "Requires age verification option"
							},
							cash_on_delivery: {
								type: "object",
								required: ["due_amount"],
								properties: { due_amount: { $ref: "#/components/schemas/_ref_types_money" } },
								additionalProperties: !1,
								description: "Cash on delivery option"
							},
							collect: {
								type: "object",
								additionalProperties: !1,
								description: "Scheduled collection option"
							},
							cooled_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Cooled delivery option"
							},
							drop_off_at_postal_point: {
								type: "object",
								additionalProperties: !1,
								description: "Deliver at postal point option"
							},
							extra_assurance: {
								type: "object",
								additionalProperties: !1,
								description: "Additional insurance option"
							},
							hide_sender: {
								type: "object",
								additionalProperties: !1,
								description: "Hide sender option"
							},
							large_format: {
								type: "object",
								additionalProperties: !1,
								description: "Oversized package option"
							},
							only_recipient: {
								type: "object",
								additionalProperties: !1,
								description: "Recipient only delivery option"
							},
							priority_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Priority delivery option"
							},
							receipt_code: {
								type: "object",
								additionalProperties: !1,
								description: "Requires receipt code option"
							},
							return: {
								type: "object",
								additionalProperties: !1,
								description: "Return on first failed delivery option"
							},
							same_day_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Same day delivery option"
							},
							saturday_delivery: {
								type: "object",
								additionalProperties: !1,
								description: "Saturday delivery option"
							},
							signature: {
								type: "object",
								additionalProperties: !1,
								description: "Requires signature option"
							},
							tracked: {
								type: "object",
								additionalProperties: !1,
								description: "Tracking option"
							},
							insurance: {
								type: "object",
								required: ["insured_amount"],
								properties: { insured_amount: { $ref: "#/components/schemas/_ref_types_money" } },
								additionalProperties: !1,
								description: "Insurance option"
							}
						}
					},
					delivery_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					shipment_type: {
						type: "number",
						enum: [
							1,
							2,
							3,
							4,
							5,
							6,
							7,
							8
						]
					},
					direction: {
						type: "string",
						enum: ["INBOUND", "OUTBOUND"],
						description: "The shipment direction for which the rates are requested."
					},
					collo: {
						type: "integer",
						minimum: 1,
						description: "The number of collo for which the rates are requested."
					}
				}
			}
		} }
	} }
}, Ra = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "POST notification groups",
	type: "object",
	oneOf: [{
		type: "object",
		required: [
			"shopId",
			"packageType",
			"countryCode",
			"shipmentDirection"
		],
		properties: {
			shopId: { type: "integer" },
			packageType: {
				type: "string",
				enum: [
					"DIGITAL_STAMP",
					"ENVELOPE",
					"UNFRANKED",
					"MAILBOX",
					"PACKAGE",
					"PALLET",
					"SMALL_PACKAGE"
				]
			},
			countryCode: {
				type: "string",
				minLength: 2,
				maxLength: 2,
				pattern: "^[A-Z]{2}$",
				description: "ISO 3166-1 alpha-2 country code"
			},
			shipmentDirection: {
				type: "string",
				enum: ["OUTBOUND"]
			}
		},
		additionalProperties: !1
	}, {
		type: "object",
		required: ["shopId", "shipmentDirection"],
		properties: {
			shopId: { type: "integer" },
			packageType: { type: "null" },
			countryCode: {
				type: "string",
				minLength: 2,
				maxLength: 2,
				pattern: "^[A-Z]{2}$",
				description: "ISO 3166-1 alpha-2 country code"
			},
			shipmentDirection: {
				type: "string",
				enum: ["INBOUND"]
			}
		},
		additionalProperties: !1
	}]
}, za = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Webhook subscriptions V1.1",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { webhook_subscriptions: {
			type: "array",
			minItems: 1,
			items: { $ref: "#/components/schemas/_ref_webhook_webhook-v1.1" }
		} }
	} }
}, Ba = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["hook", "url"],
	additionalProperties: !1,
	properties: {
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" },
		payload: { type: ["string", "null"] }
	}
}, Va = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "Webhook subscriptions",
	type: "object",
	required: ["data"],
	additionalProperties: !1,
	properties: { data: {
		type: "object",
		additionalProperties: !1,
		properties: { webhook_subscriptions: {
			type: "array",
			minItems: 1,
			items: { $ref: "#/components/schemas/_ref_webhook_webhook-v1.0" }
		} }
	} }
}, Ha = {
	$schema: "http://json-schema.org/draft-04/schema#",
	type: "object",
	required: ["hook", "url"],
	additionalProperties: !1,
	properties: {
		account_id: { type: "integer" },
		shop_id: { type: "integer" },
		hook: { type: "string" },
		url: { type: "string" }
	}
}, Ua = {
	$schema: "http://json-schema.org/draft-04/schema#",
	title: "PUT notification templates",
	type: "object",
	required: ["body", "subject"],
	properties: {
		body: {
			type: "string",
			minLength: 1
		},
		subject: {
			type: "string",
			minLength: 1,
			maxLength: 255
		}
	},
	additionalProperties: !1
}, Wa = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var Ga = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let ee, te = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, d = 0, ne = u.signal ?? new AbortController().signal;
		for (; !ne.aborted;) {
			d++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			ee !== void 0 && a.set("Last-Event-ID", ee);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: ne
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let te = s.body.pipeThrough(new TextDecoderStream()).getReader(), d = "", re = () => {
					try {
						te.cancel();
					} catch {}
				};
				ne.addEventListener("abort", re);
				try {
					for (;;) {
						let { done: e, value: t } = await te.read();
						if (e) break;
						d += t, d = d.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = d.split("\n\n");
						d = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) ee = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: ee,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					ne.removeEventListener("abort", re), te.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && d >= o) break;
				await te(Math.min(c * 2 ** (d - 1), s ?? 3e4));
			}
		}
	}() };
}, Ka = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, qa = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, Ja = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, Ya = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(qa(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = Ka(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : Xa({
		allowReserved: e,
		name: n,
		value: t
	})).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, Xa = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, Za = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = Ja(r), s = Object.entries(i).map(([t, i]) => Xa({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, Qa = /\{[^{}]+\}/g, $a = ({ path: e, url: t }) => {
	let n = t, r = t.match(Qa);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, Ya({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, Za({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${Xa({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, eo = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = $a({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function to(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var no = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, ro = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = Ya({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = Za({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = Xa({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, io = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, ao = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, oo = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (ao(t, n.name)) continue;
		let e = await no(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, so = (e) => eo({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : ro(e.querySerializer),
	url: e.url
}), co = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = uo(e.headers, t.headers), n;
}, lo = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, uo = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? lo(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, fo = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, po = () => ({
	error: new fo(),
	request: new fo(),
	response: new fo()
}), mo = ro({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), ho = { "Content-Type": "application/json" }, go = (e = {}) => ({
	...Wa,
	headers: ho,
	parseAs: "auto",
	querySerializer: mo,
	...e
}), f = ((e = {}) => {
	let t = co(go(), e), n = () => ({ ...t }), r = (e) => (t = co(t, e), n()), i = po(), a = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: uo(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await oo({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: so(n)
		};
	}, o = async (e) => {
		let { opts: t, url: n } = await a(e), r = {
			redirect: "follow",
			...t,
			body: to(t)
		}, o = new Request(n, r);
		for (let e of i.request.fns) e && (o = await e(o, t));
		let s = t.fetch, c;
		try {
			c = await s(o);
		} catch (e) {
			let n = e;
			for (let r of i.error.fns) r && (n = await r(e, void 0, o, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: o,
				response: void 0
			};
		}
		for (let e of i.response.fns) e && (c = await e(c, o, t));
		let l = {
			request: o,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? io(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), ee;
		try {
			ee = JSON.parse(u);
		} catch {}
		let te = ee ?? u, d = te;
		for (let e of i.error.fns) e && (d = await e(te, c, o, t));
		if (d ||= {}, t.throwOnError) throw d;
		return t.responseStyle === "data" ? void 0 : {
			error: d,
			...l
		};
	}, s = (e) => (t) => o({
		...t,
		method: e
	}), c = (e) => async (t) => {
		let { opts: n, url: r } = await a(t);
		return Ga({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of i.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: to(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => so({
			...t,
			...e
		}),
		connect: s("CONNECT"),
		delete: s("DELETE"),
		get: s("GET"),
		getConfig: n,
		head: s("HEAD"),
		interceptors: i,
		options: s("OPTIONS"),
		patch: s("PATCH"),
		post: s("POST"),
		put: s("PUT"),
		request: o,
		setConfig: r,
		sse: {
			connect: c("CONNECT"),
			delete: c("DELETE"),
			get: c("GET"),
			head: c("HEAD"),
			options: c("OPTIONS"),
			patch: c("PATCH"),
			post: c("POST"),
			put: c("PUT"),
			trace: c("TRACE")
		},
		trace: s("TRACE")
	};
})(go({
	baseUrl: "https://api.myparcel.nl/",
	throwOnError: !0
})), _o = e.int().gte(400).lte(499).register(e.globalRegistry, { description: "The request contains bad syntax or cannot be fulfilled" }), vo = e.union([
	e.literal(3e3),
	e.literal(3001),
	e.literal(3002),
	e.literal(3003),
	e.literal(3004),
	e.literal(3005),
	e.literal(3006),
	e.literal(3007)
]).register(e.globalRegistry, { description: "Authentication and Authorization related error codes" }), yo = e.union([vo, e.int()]), bo = e.object({
	status: _o.optional(),
	code: yo.optional(),
	title: e.string().optional(),
	message: e.string().optional()
}), xo = e.object({
	message: e.string(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }),
	status_code: _o,
	errors: e.union([e.array(bo), e.record(e.string(), bo)])
}), So = e.literal(404).register(e.globalRegistry, { description: "Did not find the requested target resource." }), Co = xo.and(e.object({
	status_code: So.optional(),
	errors: e.array(e.object({
		status: So.optional(),
		code: e.int().optional()
	})).optional()
})), p = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }), wo = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), To = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Eo = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), Do = e.string().length(2).regex(/^[A-Za-z]{2}$/), Oo = e.union([e.unknown(), e.enum([""])]).nullable(), ko = e.object({
	person: e.string().optional(),
	company: e.string().nullish(),
	street: e.string().optional(),
	street_additional_info: e.string().nullish(),
	number: e.string().nullish(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	state: e.string().optional(),
	cc: Do,
	region: e.string().max(35).nullish(),
	area: e.string().optional(),
	phone: e.string().nullish(),
	email: e.union([e.unknown(), e.enum([""])]).nullish(),
	secondary_emails: e.array(Oo).nullish(),
	box_number: e.string().max(8).nullish(),
	eori_number: e.string().optional(),
	vat_number: e.string().optional(),
	invalid: e.boolean().optional()
}), Ao = ko.and(e.object({
	person: e.unknown().optional(),
	company: e.unknown().optional(),
	street: e.unknown().optional(),
	street_additional_info: e.unknown().optional(),
	number: e.unknown().optional(),
	number_suffix: e.unknown().optional(),
	postal_code: e.unknown().optional(),
	city: e.unknown().optional(),
	state: e.unknown().optional(),
	area: e.unknown().optional(),
	phone: e.unknown().optional()
})), jo = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(98),
	e.literal(99),
	e.literal(100),
	e.literal(101),
	e.literal(30),
	e.literal(31),
	e.literal(32),
	e.literal(33),
	e.literal(34),
	e.literal(35),
	e.literal(36),
	e.literal(37),
	e.literal(38)
]), Mo = e.object({
	currency: e.enum(["EUR"]),
	amount: e.int().gte(0)
}), No = e.object({ insurance: Mo.optional() }), Po = No.and(e.object({ insurance: e.object({ amount: e.unknown().optional() }).optional() })), m = e.union([e.literal(0), e.literal(1)]), h = e.object({
	currency: e.enum(["", "EUR"]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." }),
	amount: e.union([e.int().gte(0), e.string().regex(/\d*/)])
}).register(e.globalRegistry, { description: "Money amount with currency" }), Fo = e.object({
	age_check: m.optional(),
	cash_on_delivery: h.optional(),
	collect: m.optional(),
	cooled_delivery: m.optional(),
	drop_off_at_postal_point: m.optional(),
	extra_assurance: m.optional(),
	fresh_food: m.optional(),
	frozen: m.optional(),
	hide_sender: m.optional(),
	large_format: m.optional(),
	only_recipient: m.optional(),
	priority_delivery: m.optional(),
	receipt_code: m.optional(),
	return: m.optional(),
	same_day_delivery: m.optional(),
	saturday_delivery: m.optional(),
	signature: m.optional(),
	tracked: m.optional()
}), g = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]).register(e.globalRegistry, { description: "Package Type." }), Io = e.object({ package_type: g.optional() }), Lo = e.object({ delivery_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]).nullish() }), Ro = e.object({ delivery_date: e.string().regex(/([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})/).nullish() }), zo = e.object({ label_description: e.string().max(45).optional() }), _ = Po.and(Fo).and(Io).and(Lo).and(Ro).and(zo), Bo = e.union([e.enum([""]), e.unknown()]).nullable(), Vo = e.object({
	save_recipient_address: m.optional(),
	delivery_notification: m.optional(),
	delivery_notification_email: e.array(e.email()).optional(),
	disable_auto_detect_pickup: m.optional(),
	printer_identifier: e.string().optional(),
	tracktrace: e.object({
		bcc: m.optional(),
		bcc_email: Bo.optional(),
		carrier_email_basic_notification: m.optional(),
		delivery_notification: m.optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: m.optional(),
		email_on_handed_to_courier: m.optional(),
		from_address_company: e.string().optional(),
		from_address_email: e.email().optional(),
		printer_identifier: e.string().optional(),
		save_recipient_address: m.optional(),
		send_track_trace_emails: m.optional()
	}).optional()
}).nullable(), Ho = e.object({
	location_code: e.string().optional(),
	location_name: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().length(2).regex(/^[A-Z]{2}/).optional(),
	retail_network_id: e.string().optional()
}).nullable(), Uo = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5)
]), Wo = e.object({
	description: e.string().max(50),
	amount: e.int().gte(1).lte(99999),
	weight: e.int().gte(0).lte(999999999),
	item_value: h,
	classification: e.string(),
	country: e.union([e.unknown(), e.enum([""])]).optional()
}), v = e.object({
	contents: Uo,
	invoice: e.string().max(150).nullish(),
	eori_number: e.string().nullish(),
	vat_number: e.string().nullish(),
	vat_number_uk: e.string().nullish(),
	voec_number: e.string().nullish(),
	weight: e.int().gte(0).lte(999999999),
	items: e.array(Wo).min(1).max(100)
}), Go = e.int().gte(0).lte(999999999), Ko = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), qo = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Jo = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Yo = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Xo = Go, Zo = Ko, Qo = qo, $o = Jo, es = Yo, ts = e.object({
	weight: Go.optional(),
	height: Ko.optional(),
	width: qo.optional(),
	length: Jo.optional(),
	volume: Yo.optional(),
	carrier_weight: Xo.nullish(),
	carrier_height: Zo.nullish(),
	carrier_width: Qo.nullish(),
	carrier_length: $o.nullish(),
	carrier_volume: es.nullish()
}).nullable(), ns = e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).nullable(), rs = e.enum([
	"pending",
	"unpaid",
	"paid"
]).nullable(), is = Ho, as = e.enum([
	"Facebook",
	"Google",
	"Flespakket.nl",
	"Amazon",
	"Bol.com",
	"MyParcel.nl",
	"Wix",
	"Ecwid",
	"Exact Online DE",
	"Exact Online NL",
	"Etsy"
]), os = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), ss = e.enum([
	"pending",
	"unpaid",
	"paid"
]).nullable(), y = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19)
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), cs = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), ls = cs, us = e.string().max(255), ds = e.string().max(255).nullable(), fs = p.nullable(), ps = wo, ms = To, hs = Eo, gs = Ao, _s = ko, vs = jo, ys = _.and(e.unknown()), bs = Vo, xs = Ho, Ss = v.nullable(), Cs = ts, ws = ns, Ts = rs, Es = is, Ds = m, Os = h, ks = e.string().max(255), As = e.union([e.unknown(), e.enum(["Wereld"])]), js = as.nullable(), Ms = os.nullable(), Ns = ss, Ps = y, Fs = ls, Is = us.nullable(), Ls = ds, Rs = e.string().max(255), zs = e.string().max(255), Bs = e.union([e.string().regex(/\d+/), e.int()]), Vs = e.string().max(255), Hs = e.string().max(255), Us = e.string().max(255), Ws = e.string().regex(/^[A-Z][A-Z]$/), Gs = e.string().max(255), Ks = e.string().max(8).nullable(), qs = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).optional(),
	gender: e.string().max(3).nullish(),
	first_name: e.string().max(255).nullish(),
	last_name: e.string().max(255).nullable(),
	email: e.union([e.enum([""]), e.unknown()]).nullable(),
	phone: e.string().max(100).nullable(),
	company: e.string().max(255).nullable(),
	street: Rs,
	street_additional_info: zs.optional(),
	number: Bs,
	number_suffix: Vs.optional(),
	postal_code: Hs,
	city: Us,
	cc: Ws,
	region: Gs.optional(),
	box_number: Ks.optional()
}), Js = qs.nullable(), Ys = p.nullable(), Xs = e.string().max(255).nullable(), Zs = Xs, Qs = e.boolean().default(!1), $s = e.boolean().default(!1), ec = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullable(), tc = e.enum(["", "EUR"]), nc = tc.nullable(), rc = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(), ic = e.union([e.unknown(), e.enum([""])]).nullable(), ac = e.array(e.object({
	uri: e.union([e.enum([""]), e.unknown()]),
	barcode: e.string()
})), oc = ac, sc = e.string().nullable(), cc = e.uuid().max(36).nullable(), lc = e.int().nullable(), uc = e.string().nullable(), dc = e.record(e.string(), e.unknown()).nullable(), fc = e.string().nullable(), pc = e.object({
	quantity: lc.optional(),
	order_line_identifier: uc.optional(),
	order_line: dc.optional(),
	picklist_identifier: fc.optional(),
	order_identifier: e.string().nullish()
}).nullable(), mc = e.array(pc).nullable(), hc = e.string().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1]) ([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(e.globalRegistry, { description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), gc = hc, _c = gc, vc = hc, yc = vc, bc = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), xc = bc.nullable(), Sc = xc, Cc = bc.nullable(), wc = Cc, Tc = e.object({
	id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }),
	parent_id: p.nullable(),
	account_id: wo,
	shop_id: To,
	shipment_type: Eo,
	recipient: Ao,
	sender: ko,
	status: jo,
	options: _.and(e.unknown()),
	general_settings: Vo,
	pickup: Ho,
	customs_declaration: v.nullable(),
	physical_properties: ts,
	reference_identifier: ns,
	transaction_status: rs,
	drop_off_point: is,
	hidden: m,
	price: h,
	barcode: e.string().max(255),
	region: e.union([e.unknown(), e.enum(["Wereld"])]),
	external_provider: as.nullable(),
	external_provider_id: os.nullable(),
	payment_status: ss,
	carrier_id: y,
	platform_id: ls,
	origin: us.nullable(),
	user_agent: ds,
	secondary_shipments: e.array(e.object({
		id: p,
		parent_id: fs,
		account_id: ps,
		shop_id: ms,
		shipment_type: hs,
		recipient: gs,
		sender: _s,
		status: vs,
		options: ys,
		general_settings: bs,
		pickup: xs,
		customs_declaration: Ss,
		physical_properties: Cs,
		reference_identifier: ws,
		transaction_status: Ts,
		drop_off_point: Es,
		hidden: Ds,
		price: Os,
		barcode: ks,
		region: As,
		external_provider: js,
		external_provider_id: Ms,
		payment_status: Ns,
		carrier_id: Ps,
		platform_id: Fs,
		origin: Is,
		user_agent: Ls,
		secondary_shipments: e.array(e.unknown()).max(0).nullish(),
		collection_contact: Js,
		multi_collo_main_shipment_id: Ys,
		external_identifier: Zs,
		delayed: Qs,
		delivered: $s,
		amount: ec.optional(),
		currency: nc.optional(),
		contract_id: rc,
		link_consumer_portal: ic.optional(),
		partner_tracktraces: oc.optional(),
		pickup_request_number: sc.optional(),
		order_shipment_identifier: cc.optional(),
		shipped_items: mc.optional(),
		created: _c,
		modified: yc,
		created_by: Sc,
		modified_by: wc
	})),
	collection_contact: qs.nullable(),
	multi_collo_main_shipment_id: p.nullable(),
	external_identifier: Xs,
	delayed: e.boolean().default(!1),
	delivered: e.boolean().default(!1),
	amount: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullish(),
	currency: tc.nullish(),
	contract_id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(),
	link_consumer_portal: e.union([e.unknown(), e.enum([""])]).nullish(),
	partner_tracktraces: ac.optional(),
	pickup_request_number: e.string().nullish(),
	order_shipment_identifier: e.uuid().max(36).nullish(),
	shipped_items: e.array(pc).nullish(),
	created: gc,
	modified: vc,
	created_by: xc,
	modified_by: Cc
}), Ec = e.object({ data: e.object({ shipments: e.array(Tc).register(e.globalRegistry, { description: "A list of Shipment Resources." }) }) }), Dc = e.union([e.string(), e.unknown()]), Oc = e.object({ url: e.url().optional() }), kc = e.object({ data: e.union([
	e.object({ pdfs: Oc.optional() }),
	e.object({ csvs: Oc.optional() }),
	e.object({ zpls: Oc.optional() })
]) }), Ac = e.array(e.object({
	shipment_id: p,
	price: h,
	price_after_vat: h
})), jc = e.object({ data: e.object({ shipments: e.object({
	unpaid_shipments: Ac,
	blocked_shipments: Ac
}) }) }), Mc = e.object({
	amount: e.int().nullable(),
	currency: e.enum(["", "EUR"]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." })
}).register(e.globalRegistry, { description: "Price amount in a specific currency" }), Nc = e.object({
	id: e.string(),
	hash: e.string(),
	type: e.int(),
	notification_hash: e.string(),
	original_notification_hash: e.string(),
	paid: e.union([e.literal(0), e.literal(1)]),
	price: Mc,
	payment_url: e.url().nullable(),
	invoices: e.object({
		id: e.int(),
		number: e.string(),
		status: e.int()
	})
}), Pc = e.object({ data: e.object({ payment_instructions: e.array(Nc) }) }), Fc = e.literal(400).register(e.globalRegistry, { description: "The server will not process the request due to a client error." }), Ic = xo.and(e.object({
	status_code: Fc.optional(),
	errors: e.array(e.object({
		status: Fc.optional(),
		code: e.int().optional()
	})).optional()
})), Lc = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3)
]), b = e.object({
	date: hc,
	timezone: e.string(),
	timezone_type: Lc
}), Rc = e.enum([
	"morning",
	"standard",
	"evening",
	"same_day",
	"express",
	"early_morning"
]), zc = e.enum([
	"package",
	"mailbox",
	"unfranked",
	"digital_stamp",
	"pallet",
	"small_package",
	"envelope"
]).register(e.globalRegistry, { description: "Package Type." }), Bc = e.object({
	type: e.enum(["start", "end"]),
	date_time: b
}), Vc = e.object({
	type: Rc.nullable(),
	package_type: zc,
	delivery_time_frames: e.array(Bc),
	shipment_options: e.array(e.object({
		name: e.string(),
		schema: e.object({
			type: e.enum(["boolean"]),
			enum: e.array(e.boolean())
		})
	})),
	price: Mc.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), Hc = e.object({
	date: b,
	possibilities: e.array(Vc)
}), Uc = e.object({ data: e.object({ deliveries: e.array(Hc) }) }), Wc = e.iso.date().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])/).register(e.globalRegistry, { description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n" }), Gc = e.iso.time().regex(/([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(e.globalRegistry, { description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), Kc = e.object({
	start: Gc,
	end: Gc,
	price: Mc,
	price_comment: e.string(),
	comment: e.string(),
	type: e.int(),
	collect_date: b.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), qc = e.object({
	date: Wc,
	time: e.array(Kc)
}), Jc = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), Yc = e.object({
	start: Gc.nullish(),
	type: Jc.optional(),
	price: Mc.optional()
}), x = e.array(e.string()).register(e.globalRegistry, { description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n" }), Xc = e.object({
	monday: x,
	tuesday: x,
	wednesday: x,
	thursday: x,
	friday: x,
	saturday: x,
	sunday: x
}), Zc = e.union([e.number().gte(-90).lte(90), e.string().regex(/^[-+]?(90|[0-8]?\d)(\.\d+)?$/)]), Qc = e.union([e.number().gte(-180).lte(180), e.string().regex(/^[-+]?(180|(0?\d{0,2}|1[0-7]\d)(\.\d+)?)$/)]), $c = e.object({
	date: Wc.nullish(),
	time: e.array(Yc).optional(),
	location: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().optional(),
	start_time: Gc.nullish(),
	price: e.int().optional(),
	price_comment: e.enum(["retail", "retailexpress"]).optional(),
	comment: e.string().optional(),
	phone_number: e.string().optional(),
	opening_hours: Xc.optional(),
	distance: e.string().optional(),
	latitude: Zc.optional(),
	longitude: Qc.optional(),
	location_code: e.string().optional(),
	retail_network_id: e.string().nullish(),
	holiday: e.object({
		from: e.string().nullish(),
		to: e.string().nullish()
	}).optional()
}), el = e.int().gte(500).lte(599).register(e.globalRegistry, { description: "The server failed to fulfill an apparently valid request" }), tl = e.union([_o, el]), nl = e.object({
	status: tl.optional(),
	code: yo,
	title: e.string().optional(),
	message: e.string()
}), rl = e.object({
	data: e.object({
		delivery: e.array(qc),
		pickup: e.array($c),
		message: e.string().optional()
	}),
	errors: e.array(e.union([nl, e.object({
		code: e.int(),
		message: e.string(),
		human: e.string().optional()
	})])).optional()
}), il = e.literal(406).register(e.globalRegistry, { description: "The target resource doesn't have an acceptable representation for the user agent." }), al = xo.and(e.object({
	status_code: il.optional(),
	errors: e.array(e.object({
		status: il.optional(),
		code: e.int().optional()
	})).optional()
})), ol = e.object({ link: e.url() }).register(e.globalRegistry, { description: "DownloadUrl Object Definition" }), sl = e.object({ data: e.object({ download_url: ol }) }), cl = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), ll = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]), ul = e.array(e.union([cl, ll])).nullable(), dl = e.object({
	monday: e.number().nullish(),
	tuesday: e.number().nullish(),
	wednesday: e.number().nullish(),
	thursday: e.number().nullish(),
	friday: e.number().nullish(),
	saturday: e.number().nullish(),
	sunday: e.number().nullish()
}), fl = e.enum(["retail", "locker"]), pl = e.object({
	start: b.nullable(),
	end: b.nullable()
}), S = e.array(pl), ml = e.object({
	monday: S.optional(),
	tuesday: S.optional(),
	wednesday: S.optional(),
	thursday: S.optional(),
	friday: S.optional(),
	saturday: S.optional(),
	sunday: S.optional()
}).nullable(), hl = e.object({
	location_code: e.string().optional(),
	location_name: e.string().nullish(),
	cc: e.string().optional(),
	state: e.string().nullish(),
	city: e.string().optional(),
	postal_code: e.string().optional(),
	street: e.string().optional(),
	number: e.union([e.string(), e.int()]).nullish(),
	number_suffix: e.string().nullish(),
	phone: e.string().nullish(),
	reference: e.string().nullish(),
	longitude: Qc.nullish(),
	latitude: Zc.nullish(),
	available_days: ul.optional(),
	cut_off_time: e.string().nullish(),
	carrier_id: y.optional(),
	distance: e.number().nullish(),
	occupancy: dl.nullish(),
	occupancy_today: e.number().nullish(),
	default_drop_off_point: e.boolean().nullish(),
	type: fl.nullish(),
	opening_hours: ml.optional()
}), gl = e.object({ data: e.object({ drop_off_points: e.array(hl) }) }), _l = e.literal(415).register(e.globalRegistry, { description: "Content is in a format not supported by this method on the target resource." }), vl = xo.and(e.object({
	status_code: _l.optional(),
	errors: e.array(e.object({
		status: _l.optional(),
		code: e.literal(3100).optional()
	})).optional()
})), yl = e.literal(401).register(e.globalRegistry, { description: "The request lacks valid authentication credentials for the target resource." }), bl = xo.and(e.object({
	status_code: yl.optional(),
	errors: e.array(e.object({
		status: yl.optional(),
		code: e.int().optional()
	})).optional()
})), xl = e.object({
	cc: e.string(),
	city: e.string(),
	street: e.string(),
	postal_code: e.string(),
	number: e.string(),
	number_suffix: e.string().nullish()
}), Sl = e.array(e.object({
	delivery_type_id: e.int(),
	delivery_type_name: e.string(),
	price: e.int(),
	moment: e.object({ start: b.nullish() })
})), C = e.object({
	start: b.nullable(),
	end: b.nullable()
}), Cl = e.object({
	monday: e.array(C),
	tuesday: e.array(C),
	wednesday: e.array(C),
	thursday: e.array(C),
	friday: e.array(C),
	saturday: e.array(C),
	sunday: e.array(C)
}), wl = e.object({
	location_name: e.string(),
	retail_network_id: e.string().nullable(),
	distance: e.string(),
	latitude: e.string(),
	longitude: e.string(),
	location_code: e.string(),
	phone_number: e.string().nullable(),
	type: fl.nullable(),
	opening_hours: Cl
}), Tl = e.object({
	address: xl,
	possibilities: Sl,
	location: wl
}), El = e.object({ data: e.object({ pickup_locations: e.array(Tl) }) }), Dl = e.object({ data: e.object({
	shipments: e.array(Tc).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	pdf: e.object({ url: e.string().regex(/^\/pdfs\/.*/) }).optional(),
	zpl: e.object({ url: e.string().regex(/^\/zpls\/.*/) }).optional()
}) }), Ol = e.object({ data: e.object({ ids: e.array(e.object({
	id: p,
	reference_identifier: ns
})).register(e.globalRegistry, { description: "A list of Shipment IDs." }) }) }), kl = e.array(e.object({
	id: p,
	reference_identifier: ns
})).register(e.globalRegistry, { description: "A list of Shipment IDs." }), Al = e.object({ data: e.union([e.object({
	ids: kl,
	pdf: e.object({ url: e.string().regex(/^\/pdfs\/.*/) })
}), e.object({
	ids: kl,
	zpl: e.object({ url: e.string().regex(/^\/zpls\/.*/) })
})]) }), jl = e.object({
	status: el.optional(),
	code: e.int().optional(),
	title: e.string().optional(),
	message: e.string().optional()
}), Ml = e.object({
	message: e.string().register(e.globalRegistry, { description: "A human-readable description of the error." }).optional(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }).optional(),
	status_code: el.optional(),
	errors: e.array(jl).optional()
}), Nl = e.object({ data: e.object({
	shipments: e.array(Tc).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	results: e.int().register(e.globalRegistry, { description: "The number of results." })
}) }), Pl = e.object({
	uri: e.url(),
	barcode: e.string()
}), Fl = e.object({
	name: e.string(),
	cc: e.string().nullable(),
	city: e.string().nullable(),
	postal_code: e.string().nullable(),
	street: e.string().nullable(),
	number: e.string().nullable(),
	number_suffix: e.string().nullable(),
	longitude: e.number().nullable(),
	latitude: e.number().nullable()
}), Il = e.enum([
	"registered",
	"handed_to_carrier",
	"sorting",
	"distribution",
	"delivered"
]).nullable(), Ll = e.object({
	code: e.string(),
	status: jo,
	main: Il,
	description: e.string(),
	time: hc,
	delayed: e.boolean(),
	location: Fl
}), Rl = e.array(Ll), zl = e.enum(["estimated", "expected"]).nullable(), Bl = e.object({
	start: b.nullable(),
	end: b.nullable()
}).nullable(), Vl = e.union([e.string(), e.object({
	content: e.string(),
	content_type: e.string()
})]).nullable(), Hl = e.object({
	shipment_id: p,
	carrier: y,
	code: e.string(),
	description: e.string(),
	time: hc,
	link_consumer_portal: e.url().nullable(),
	link_tracktrace: e.url().nullable(),
	partner_tracktraces: e.array(Pl),
	recipient: Ao,
	sender: ko,
	options: _,
	pickup: Ho,
	delayed: e.boolean(),
	location: Fl,
	status: e.object({
		current: jo,
		main: Il,
		final: e.boolean()
	}),
	history: Rl,
	delivery_moment_type: zl.optional(),
	delivery_moment: Bl.optional(),
	signature: Vl.optional(),
	returnable: e.boolean().optional()
}).register(e.globalRegistry, { description: "A Track & Trace resource." }), Ul = e.object({ data: e.object({ tracktraces: e.array(Hl).register(e.globalRegistry, { description: "A list of Track & Trace Resources." }) }) }), Wl = e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTE_ITALIANE",
	"POSTNL",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD"
]).register(e.globalRegistry, { description: "Carrier string definition for capabilities endpoints (v2)" }), Gl = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.enum(["MAIN", "CUSTOM"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v2)" }), Kl = e.enum([
	"PACKAGE",
	"MAILBOX",
	"UNFRANKED",
	"DIGITAL_STAMP",
	"PALLET",
	"SMALL_PACKAGE",
	"ENVELOPE"
]).register(e.globalRegistry, { description: "Package Type." }), w = e.object({
	isSelectedByDefault: e.boolean(),
	isRequired: e.boolean()
}), ql = e.object({
	additionalInsurance: w.optional(),
	cooledDelivery: w.optional(),
	customLabelText: w.optional(),
	deliverAtPostalPoint: w.optional(),
	deliveryDate: w.optional(),
	freshFood: w.optional(),
	frozen: w.optional(),
	hideSender: w.optional(),
	noTracking: w.optional(),
	oversizedPackage: w.optional(),
	priorityDelivery: w.optional(),
	printReturnLabelAtDropOff: w.optional(),
	recipientOnlyDelivery: w.optional(),
	requiresAgeVerification: w.optional(),
	requiresCashOnDelivery: w.optional(),
	requiresReceiptCode: w.optional(),
	requiresSignature: w.optional(),
	returnContributionFee: w.optional(),
	returnOnFirstFailedDelivery: w.optional(),
	sameDayDelivery: w.optional(),
	saturdayDelivery: w.optional(),
	scheduledCollection: w.optional(),
	tracked: w.optional()
}), T = w.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are excluded" })
})), Jl = e.object({ insuredAmount: e.object({
	default: h,
	min: h,
	max: h
}).optional() }), Yl = T.and(Jl), Xl = ql.and(e.object({
	additionalInsurance: T.optional(),
	cooledDelivery: T.optional(),
	customLabelText: T.optional(),
	deliverAtPostalPoint: T.optional(),
	deliveryDate: T.optional(),
	freshFood: T.optional(),
	frozen: T.optional(),
	hideSender: T.optional(),
	insurance: Yl.optional(),
	noTracking: T.optional(),
	oversizedPackage: T.optional(),
	priorityDelivery: T.optional(),
	printReturnLabelAtDropOff: T.optional(),
	recipientOnlyDelivery: T.optional(),
	requiresAgeVerification: T.optional(),
	requiresCashOnDelivery: T.optional(),
	requiresReceiptCode: T.optional(),
	requiresSignature: T.optional(),
	returnContributionFee: T.optional(),
	returnOnFirstFailedDelivery: T.optional(),
	sameDayDelivery: T.optional(),
	saturdayDelivery: T.optional(),
	scheduledCollection: T.optional(),
	tracked: T.optional()
})), Zl = e.object({
	value: e.number().register(e.globalRegistry, { description: "The numeric value" }),
	unit: e.enum([
		"g",
		"kg",
		"cm",
		"mm",
		"mm3",
		"cm3",
		"dm3",
		"m3"
	]).register(e.globalRegistry, { description: "The unit of measurement in SI units" })
}), E = e.object({
	min: Zl,
	max: Zl,
	calculation: e.string()
}), Ql = e.object({
	weight: E.optional(),
	width: E.optional(),
	length: E.optional(),
	height: E.optional(),
	girth: E.optional(),
	volumetric_weight: E.optional(),
	volume: E.optional(),
	length_width_height_sum: E.optional()
}), $l = e.enum([
	"MORNING_DELIVERY",
	"STANDARD_DELIVERY",
	"EVENING_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"EXPRESS_DELIVERY",
	"EARLY_MORNING_DELIVERY"
]), eu = e.enum(["B2B", "B2C"]), tu = e.object({ max: e.int() }), nu = e.object({
	carrier: Wl,
	contract: Gl.optional(),
	packageTypes: e.array(Kl),
	options: Xl,
	physicalProperties: Ql,
	deliveryTypes: e.array($l),
	transactionTypes: e.array(eu),
	collo: tu
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), ru = e.object({ results: e.array(nu).register(e.globalRegistry, { description: "A list of V2 Capabilities for a given Shipment configuration." }) }), iu = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19)
]).register(e.globalRegistry, { description: "Carrier ID definition for capabilities endpoints (v1)" }), au = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.enum(["main", "custom"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v1)" }), D = e.object({
	is_selected_by_default: e.boolean(),
	is_required: e.boolean()
}), ou = e.object({
	age_check: D.optional(),
	cash_on_delivery: D.optional(),
	collect: D.optional(),
	contribution: D.optional(),
	cooled_delivery: D.optional(),
	delivery_date: D.optional(),
	drop_off_at_postal_point: D.optional(),
	extra_assurance: D.optional(),
	fresh_food: D.optional(),
	frozen: D.optional(),
	hide_sender: D.optional(),
	label_description: D.optional(),
	large_format: D.optional(),
	no_tracking: D.optional(),
	only_recipient: D.optional(),
	printerless_return: D.optional(),
	priority_delivery: D.optional(),
	receipt_code: D.optional(),
	return: D.optional(),
	same_day_delivery: D.optional(),
	saturday_delivery: D.optional(),
	signature: D.optional(),
	tracked: D.optional()
}), O = D.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are excluded" })
})), su = e.object({ insured_amount: e.object({
	default: h,
	min: h,
	max: h
}).optional() }), cu = O.and(su), lu = ou.and(e.object({
	age_check: O.optional(),
	cash_on_delivery: O.optional(),
	collect: O.optional(),
	contribution: O.optional(),
	cooled_delivery: O.optional(),
	delivery_date: O.optional(),
	drop_off_at_postal_point: O.optional(),
	extra_assurance: O.optional(),
	fresh_food: O.optional(),
	frozen: O.optional(),
	hide_sender: O.optional(),
	insurance: cu.optional(),
	label_description: O.optional(),
	large_format: O.optional(),
	no_tracking: O.optional(),
	only_recipient: O.optional(),
	printerless_return: O.optional(),
	priority_delivery: O.optional(),
	receipt_code: O.optional(),
	return: O.optional(),
	same_day_delivery: O.optional(),
	saturday_delivery: O.optional(),
	signature: O.optional(),
	tracked: O.optional()
})), uu = e.object({
	carrier_id: iu,
	contract: au.optional(),
	package_types: e.array(g),
	options: lu,
	physical_properties: Ql,
	delivery_types: e.array(Jc),
	transaction_types: e.array(eu),
	collo: tu
}).register(e.globalRegistry, { description: "A V1 Capability response item for a given Shipment configuration." }), du = e.object({ data: e.object({ capabilities: e.array(uu).register(e.globalRegistry, { description: "A list of V1 Capabilities for a given Shipment configuration." }) }) }), k = w.and(e.object({})), fu = k.and(Jl), pu = ql.and(e.object({
	additionalInsurance: k.optional(),
	cooledDelivery: k.optional(),
	customLabelText: k.optional(),
	deliverAtPostalPoint: k.optional(),
	deliveryDate: k.optional(),
	hideSender: k.optional(),
	insurance: fu.optional(),
	noTracking: k.optional(),
	oversizedPackage: k.optional(),
	priorityDelivery: k.optional(),
	printReturnLabelAtDropOff: k.optional(),
	recipientOnlyDelivery: k.optional(),
	requiresAgeVerification: k.optional(),
	requiresCashOnDelivery: k.optional(),
	requiresReceiptCode: k.optional(),
	requiresSignature: k.optional(),
	returnContributionFee: k.optional(),
	returnOnFirstFailedDelivery: k.optional(),
	sameDayDelivery: k.optional(),
	saturdayDelivery: k.optional(),
	scheduledCollection: k.optional(),
	tracked: k.optional()
})), mu = e.object({
	carrier: Wl,
	packageTypes: e.array(Kl),
	options: pu,
	deliveryTypes: e.array($l),
	transactionTypes: e.array(eu),
	collo: tu
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), hu = e.object({ items: e.array(mu).register(e.globalRegistry, { description: "A superset of V2 Capabilities for the contracts within a user's account." }) }), A = D.and(e.object({})), gu = A.and(su), _u = ou.and(e.object({
	age_check: A.optional(),
	cash_on_delivery: A.optional(),
	collect: A.optional(),
	contribution: A.optional(),
	cooled_delivery: A.optional(),
	delivery_date: A.optional(),
	drop_off_at_postal_point: A.optional(),
	extra_assurance: A.optional(),
	hide_sender: A.optional(),
	insurance: gu.optional(),
	label_description: A.optional(),
	large_format: A.optional(),
	no_tracking: A.optional(),
	only_recipient: A.optional(),
	printerless_return: A.optional(),
	priority_delivery: A.optional(),
	receipt_code: A.optional(),
	return: A.optional(),
	same_day_delivery: A.optional(),
	saturday_delivery: A.optional(),
	signature: A.optional(),
	tracked: A.optional()
})), vu = e.object({
	carrier_id: iu,
	package_types: e.array(g),
	options: _u,
	delivery_types: e.array(Jc),
	transaction_types: e.array(eu),
	collo: tu
}).register(e.globalRegistry, { description: "A V2 Capability contract definitions response item for a given Shipment configuration." }), yu = e.object({ data: e.object({ capabilities: e.array(vu).register(e.globalRegistry, { description: "A superset of V1 Capabilities for the contracts within a user's account." }).optional() }) }), bu = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.enum(["MAIN", "CUSTOM"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), j = e.object({
	name: e.string(),
	key: e.string(),
	price: h,
	vat: h,
	priceWithVat: h
}).register(e.globalRegistry, { description: "A V2 Price object." }), xu = e.object({
	base: j,
	charges: e.array(j),
	discounts: e.array(j),
	options: e.array(j),
	other: e.array(j),
	total: j
}).register(e.globalRegistry, { description: "The V2 price composition object, containing the base, options, charges, discounts and total prices." }), Su = e.object({
	carrier: Wl,
	contract: bu.optional(),
	packageType: Kl,
	deliveryType: $l,
	priceComposition: xu
}).register(e.globalRegistry, { description: "A V2 Rate response item for a given Shipment configuration." }), Cu = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.enum(["main", "custom"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), M = e.object({
	name: e.string(),
	key: e.string(),
	price: h,
	vat: h,
	price_with_vat: h
}).register(e.globalRegistry, { description: "A V1 Price object." }), wu = e.object({
	base: M,
	charges: e.array(M),
	discounts: e.array(M),
	options: e.array(M),
	other: e.array(M),
	total: M
}).register(e.globalRegistry, { description: "The price composition object, containing the base, options, charges, discounts and total prices." }), Tu = e.object({
	carrier_id: iu,
	contract: Cu.optional(),
	package_type: g,
	delivery_type: Jc,
	price_composition: wu
}).register(e.globalRegistry, { description: "A V1 Rate response item for a given Shipment configuration." }), Eu = e.object({ data: e.object({ rates: e.array(Tu).register(e.globalRegistry, { description: "A list of V1 Rates for a given Shipment configuration." }) }) }), Du = e.object({
	id: e.int(),
	shopId: e.int(),
	packageType: e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]).nullable(),
	countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).nullable(),
	shipmentDirection: e.enum(["OUTBOUND", "INBOUND"]),
	fallback: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Group response item" }), Ou = e.object({ results: e.array(Du) }), ku = e.enum([
	"LABEL_DOWNLOAD",
	"FIRST_SCAN",
	"RETURN"
]).register(e.globalRegistry, { description: "The notification template type." }), Au = e.object({
	id: e.int(),
	notificationGroupId: e.int(),
	type: ku,
	subject: e.string(),
	body: e.string(),
	active: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Template response item" }), ju = e.object({ results: e.array(Au) }), Mu = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" }), Nu = e.object({ data: e.object({ webhook_subscriptions: e.array(Mu) }) }), Pu = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" }), Fu = e.object({ data: e.object({ webhook_subscriptions: e.array(Pu) }) }), Iu = e.object({ data: e.object({ ids: e.array(e.object({ id: e.int() })).register(e.globalRegistry, { description: "A list of created webhook subscription IDs." }) }) }), Lu = e.string().min(6).max(24).regex(/^[a-zA-Z0-9\-\s]+$/), Ru = e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19"
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), zu = e.enum([
	"postnl",
	"bpost",
	"cheapcargo",
	"dpd",
	"instabox",
	"dhl",
	"bol.com",
	"ups",
	"dhlforyou",
	"dhlparcelconnect",
	"dhleuroplus",
	"upsstandard",
	"upsexpresssaver",
	"gls",
	"brt",
	"trunkrs",
	"inpost",
	"posteitaliane",
	"spring"
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Bu = e.union([Ru, zu]).nullable(), Vu = e.iso.date().regex(/\d{4}-\d{2}-\d{2}/).nullable(), Hu = e.string().length(2).regex(/^[A-Za-z]{2}$/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }), N = Gc.nullable(), P = e.union([
	e.boolean(),
	e.int().gte(0).lte(1),
	e.union([e.unknown(), e.unknown()]),
	e.enum([
		"0",
		"1",
		"false",
		"true"
	])
]), Uu = e.union([
	e.literal(!1),
	e.literal(!0),
	e.literal(0),
	e.literal(1),
	e.literal("0"),
	e.literal("1"),
	e.literal("false"),
	e.literal("true"),
	e.literal("off"),
	e.literal("on"),
	e.literal("no"),
	e.literal("yes"),
	e.literal("")
]).nullable(), Wu = Wc.nullable(), Gu = Gc.nullable(), Ku = e.string().nullable(), qu = e.string().regex(/^([0-6](;[0-6])*)?$/).nullable(), Ju = e.enum([
	"1",
	"2",
	"3",
	"4",
	"6",
	"7",
	"8"
]), Yu = e.union([Ju, e.unknown()]), Xu = e.enum(["A4", "A6"]).register(e.globalRegistry, { description: "The size of a paper as specified in ISO216." }), Zu = Zc.nullable(), Qu = Qc.nullable(), $u = e.enum(["ASC", "DESC"]).register(e.globalRegistry, { description: "Specify whether the results should be sorted in ascending or descending order." }), ed = e.union([
	g,
	e.array(g),
	e.string().regex(/^[1-7](;[1-7]){0,5}$/)
]), td = e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "Request a specific page of the results, used for paginated results." }), nd = e.enum([
	"myparcel",
	"flespakket",
	"belgie",
	"delivery_dutch",
	"postnl_customer",
	"italy"
]), rd = e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6"
]), id = e.union([nd, rd]).nullable(), ad = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4)
]).register(e.globalRegistry, { description: "The position of the label on the paper." }), od = e.union([ad, e.string().regex(/^[1-4](;[1-4]){0,3}$/)]), sd = e.string().min(2).max(12).regex(/^[a-zA-Z0-9\-\s]{2,12}$/).nullable(), cd = e.coerce.bigint().gte(BigInt(1)).lte(BigInt(0x8000000000000000)), F = e.union([cd, e.string().regex(/^;*[1-9][0-9]{0,18}(;([1-9][0-9]{0,18}|[a-zA-Z]+)?)*$/)]), ld = e.union([
	Eo,
	e.array(Eo),
	e.string().regex(/^[1-8](;[1-8]){0,7}$/)
]), ud = e.int().gte(1).lte(2147483647), I = e.union([
	ud,
	e.array(ud),
	e.string().regex(/^[1-9][0-9]{0,9}(;[1-9][0-9]{0,9})*$/)
]), dd = e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "Specify the number of resources returned per page, used for paginated results." }), fd = e.enum([
	"amount",
	"created",
	"created_by",
	"currency",
	"drop_off_point",
	"hidden",
	"id",
	"mark_delivered",
	"modified",
	"modified_by",
	"order_shipment_identifier",
	"parent_id",
	"recipient",
	"reference_identifier",
	"sender",
	"shipment_type",
	"shop_id",
	"status",
	"transaction_status"
]), pd = e.union([
	jo,
	e.array(jo),
	e.string().regex(/^(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101)(;(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101))*$/)
]), md = e.string().regex(/^(?:;*(delivery_moment|returnable|signature)(?=;|$)(?!.*;\1(?:;|$)))+;*$/), L = e.array(e.union([e.email(), e.string().max(0)])).max(4), hd = e.object({
	cc: e.string().length(2),
	postal_code: e.string(),
	city: e.string(),
	street: e.string(),
	street_additional_info: e.string().nullish(),
	number: e.string().optional(),
	number_suffix: e.string().optional(),
	box_number: e.string().max(8).optional(),
	region: e.string().max(35).optional(),
	person: e.string(),
	company: e.string().optional(),
	phone: e.string().optional(),
	email: e.union([e.email(), e.string().max(0)]).nullish()
}), gd = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(8),
	e.literal(16)
]), R = e.object({
	postal_code: e.string().optional(),
	location_name: e.string().optional(),
	city: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	box_number: e.string().max(8).optional(),
	region: e.string().max(35).optional(),
	state: e.string().max(2).optional(),
	cc: e.string().length(2).regex(/^[A-Z]{2}/).optional(),
	location_code: e.string().optional(),
	location_type: gd.optional(),
	retail_network_id: e.string().optional()
}).nullable(), _d = e.object({ data: e.object({
	user_agent: e.string().max(255).optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		contract_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: e.object({
			cc: e.string().length(2),
			region: e.string().max(35).optional(),
			state: e.string().max(2).optional(),
			postal_code: e.string().max(10),
			city: e.string().min(1).max(35),
			street: e.string().min(1).max(40).regex(/\D+/),
			street_additional_info: e.string().max(50).optional(),
			number: e.string().max(8).optional(),
			number_suffix: e.string().max(6).optional(),
			box_number: e.string().max(8).optional(),
			area: e.string().max(35).optional(),
			person: e.string().min(1).max(50),
			company: e.string().max(50).optional(),
			email: e.union([e.email(), e.string().max(0)]).optional(),
			secondary_emails: L.optional(),
			phone: e.string().max(25).optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}).optional(),
		sender: hd.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: _.and(e.unknown()),
		customs_declaration: v.optional(),
		carrier: y,
		pickup: R.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		secondary_shipments: e.array(e.object({
			account_id: e.int().optional(),
			shop_id: e.int().optional(),
			reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
			recipient: e.object({
				cc: e.string().length(2).optional(),
				region: e.string().max(35).optional(),
				state: e.string().max(2).optional(),
				postal_code: e.string().max(10).optional(),
				city: e.string().min(1).max(35).optional(),
				street: e.string().min(1).max(40).optional(),
				street_additional_info: e.string().max(50).optional(),
				number: e.string().max(8).optional(),
				number_suffix: e.string().max(6).optional(),
				box_number: e.string().max(8).optional(),
				area: e.string().max(35).optional(),
				person: e.string().min(1).max(50).optional(),
				company: e.string().max(50).optional(),
				email: e.union([e.email(), e.string().max(0)]).optional(),
				secondary_emails: L.optional(),
				phone: e.string().max(25).optional(),
				eori_number: e.string().nullish(),
				vat_number: e.string().nullish()
			}).optional(),
			recipients: e.array(e.number()).min(1).optional(),
			physical_properties: e.object({
				weight: e.int().gte(0).lte(999999999),
				height: e.int().optional(),
				width: e.int().optional(),
				length: e.int().optional(),
				volume: e.int().optional()
			}).optional(),
			options: _.optional(),
			customs_declaration: v.optional(),
			carrier: y.optional(),
			pickup: R.optional(),
			drop_off_point: e.object({
				postal_code: e.string(),
				location_name: e.string(),
				city: e.string(),
				street: e.string(),
				number: e.string(),
				number_suffix: e.string().optional(),
				box_number: e.string().optional(),
				region: e.string().optional(),
				state: e.string().optional(),
				cc: e.string().optional(),
				location_code: e.string(),
				retail_network_id: e.string().optional()
			}).nullish(),
			note: e.string().optional(),
			status: e.union([
				e.literal(1),
				e.literal(2),
				e.literal(3),
				e.literal(4),
				e.literal(5),
				e.literal(6),
				e.literal(7),
				e.literal(8)
			]).optional(),
			delivered: e.literal(0).optional(),
			general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
			hidden: e.union([e.literal(0), e.literal(1)]).optional(),
			shipped_items: e.array(e.object({
				order_line_identifier: e.string(),
				quantity: e.int().gte(1)
			})).min(0).optional()
		})).min(1).optional(),
		collection_contact: e.object({
			cc: e.string().length(2),
			city: e.string().min(1).max(255),
			company: e.string(),
			email: e.email(),
			first_name: e.string().optional(),
			gender: e.enum(["mr", "mrs"]).optional(),
			last_name: e.string(),
			number: e.union([e.string().min(1), e.int()]),
			number_suffix: e.string().nullish(),
			phone: e.string().min(8),
			postal_code: e.string().min(1),
			street: e.string().min(1),
			street_additional_info: e.string().nullish()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	})).min(1).max(100)
}) }), vd = e.object({ data: e.object({
	user_agent: e.string().max(255).optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: e.object({
			cc: e.string().length(2),
			region: e.string().max(35).optional(),
			state: e.string().max(2).optional(),
			postal_code: e.string().max(10).optional(),
			city: e.string().min(1).max(35),
			street: e.string().min(1).max(40).regex(/\D+/),
			street_additional_info: e.string().max(50).optional(),
			number: e.string().max(8).optional(),
			number_suffix: e.string().max(6).optional(),
			box_number: e.string().max(8).optional(),
			area: e.string().max(35).optional(),
			person: e.string().min(1).max(50),
			company: e.string().max(50).optional(),
			email: e.union([e.email(), e.string().max(0)]).optional(),
			secondary_emails: L.optional(),
			phone: e.string().max(25).optional()
		}),
		sender: hd.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: _.and(e.unknown()),
		customs_declaration: v.optional(),
		carrier: y,
		pickup: R.optional(),
		"multi-colli": e.object({ amount: e.int() }).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional()
	})).min(1).max(100)
}) }), yd = e.object({ package_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(6)
]).optional() }), bd = e.literal(1).register(e.globalRegistry, { description: "Regular package." }), xd = e.literal(2).register(e.globalRegistry, { description: "Shipment that fits through a mailbox slot." }), Sd = e.literal(6), Cd = e.object({
	age_check: m.optional(),
	cooled_delivery: m.optional(),
	drop_off_at_postal_point: m.optional(),
	extra_assurance: m.optional(),
	hide_sender: m.optional(),
	large_format: m.optional(),
	only_recipient: m.optional(),
	receipt_code: m.optional(),
	return: m.optional(),
	same_day_delivery: m.optional(),
	saturday_delivery: m.optional(),
	signature: m.optional()
}), wd = e.object({ options: yd.and(Po).and(Cd).and(zo).and(e.object({
	contribution: h.and(e.object({ amount: e.unknown().optional() })).optional(),
	printerless_return: m.optional()
})).optional() }), Td = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(14),
	e.literal(15),
	e.literal(18)
]), Ed = e.object({ data: e.object({ return_shipments: e.array(wd.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	parent: e.int(),
	reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: Td,
	email: e.string(),
	name: e.string(),
	sender: e.object({
		cc: e.string().length(2),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().max(8).optional(),
		region: e.string().max(35).optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string().max(0)]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: v.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).min(1).optional() }) }), Dd = e.object({ data: e.object({ return_shipments: e.array(wd.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	carrier: Td,
	email: e.string().optional(),
	name: e.string().optional(),
	cc: e.string().optional(),
	sender: e.object({
		cc: e.string().length(2),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().max(8).optional(),
		region: e.string().max(35).optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string().max(0)]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: v.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).min(1).optional() }) }), Od = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: y,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string().length(2),
		region: e.string().max(32).optional(),
		state: e.string().max(2).optional(),
		postal_code: e.string().max(10).optional(),
		city: e.string().max(35),
		street: e.string().max(40),
		street_additional_info: e.string().max(50).optional(),
		number: e.string().max(8).nullish(),
		number_suffix: e.string().max(6).nullish(),
		box_number: e.string().max(8).optional(),
		person: e.string().max(50),
		company: e.string().max(50).optional(),
		email: e.union([e.email(), e.string().max(0)]).optional(),
		secondary_emails: L.optional(),
		phone: e.string().max(25).optional(),
		eori_number: e.string().nullish(),
		vat_number: e.string().nullish()
	}).optional(),
	sender: hd.optional(),
	options: _.and(e.unknown()),
	customs_declaration: v.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: R.optional(),
	drop_off_point: e.object({
		postal_code: e.string(),
		location_name: e.string(),
		city: e.string(),
		street: e.string(),
		number: e.string(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		state: e.string().optional(),
		cc: e.string().optional(),
		location_code: e.string(),
		retail_network_id: e.string().optional()
	}).nullish(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	multi_collo_main_shipment_id: e.int().nullish(),
	secondary_shipments: e.array(e.object({
		id: e.int().optional(),
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: e.object({
			cc: e.string().length(2).optional(),
			region: e.string().max(35).optional(),
			state: e.string().max(2).optional(),
			postal_code: e.string().max(10).optional(),
			city: e.string().min(1).max(35).optional(),
			street: e.string().min(1).max(40).optional(),
			street_additional_info: e.string().max(50).optional(),
			number: e.string().max(8).nullish(),
			number_suffix: e.string().max(6).nullish(),
			box_number: e.string().max(8).optional(),
			area: e.string().max(35).optional(),
			person: e.string().min(1).max(50).optional(),
			company: e.string().max(50).optional(),
			email: e.union([e.email(), e.string().max(0)]).optional(),
			secondary_emails: L.optional(),
			phone: e.string().max(25).optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}).optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: _.optional(),
		customs_declaration: v.optional(),
		carrier: y.optional(),
		pickup: R.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.union([e.literal(0), e.literal(1)]).optional(),
		general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
		multi_collo_main_shipment_id: e.int().nullish(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	})).min(1).optional(),
	collection_contact: e.object({
		cc: e.string().length(2),
		city: e.string().min(1).max(255),
		company: e.string().nullish(),
		email: e.email().optional(),
		first_name: e.string().optional(),
		gender: e.enum(["mr", "mrs"]).optional(),
		last_name: e.string().optional(),
		number: e.union([e.string().min(1), e.int()]),
		number_suffix: e.string().nullish(),
		phone: e.string().min(8),
		postal_code: e.string().min(1),
		street: e.string().min(1),
		street_additional_info: e.string().nullish()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional(),
	shipped_items: e.array(e.object({
		order_line_identifier: e.string(),
		quantity: e.int().gte(1)
	})).min(0).optional()
})).min(1).max(100).optional() }) }), kd = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: y,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string().length(2),
		region: e.string().max(32).optional(),
		state: e.string().max(2).optional(),
		postal_code: e.string().max(10).optional(),
		city: e.string().max(35),
		street: e.string().max(40),
		street_additional_info: e.string().max(50).optional(),
		number: e.string().max(8).nullish(),
		number_suffix: e.string().max(6).nullish(),
		box_number: e.string().max(8).optional(),
		person: e.string().max(50),
		company: e.string().max(50).optional(),
		email: e.union([e.email(), e.string().max(0)]).optional(),
		secondary_emails: L.optional(),
		phone: e.string().max(25).optional()
	}).optional(),
	sender: hd.optional(),
	options: _.and(e.unknown()),
	customs_declaration: v.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: R.optional(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional()
})).min(1).max(100).optional() }) }), Ad = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier: Wl.optional(),
	packageType: Kl.optional(),
	physicalProperties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Insurance option" }).optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "No tracking option (inverse of tracked)" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		printReturnLabelAtDropOff: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Print return label at drop off package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.enum([
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location: e.object({ type: e.enum(["RETAIL", "LOCKER"]).register(e.globalRegistry, { description: "Type of pickup location. RETAIL for shops/postal points, LOCKER for automated parcel lockers." }).optional() }).register(e.globalRegistry, { description: "Pickup location details." }).optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
}), jd = e.object({ data: e.object({ capabilities: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier_id: iu.optional(),
	package_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6)
	]).optional(),
	physical_properties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		cooled_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cooled delivery option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		printerless_return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Printerless return delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Tracking option" }).optional(),
		insurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Insurance option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location_type: e.enum(["retail", "locker"]).register(e.globalRegistry, { description: "Type of pickup location. retail for shops/postal points, locker for automated parcel lockers." }).optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
})) }) }), Md = e.object({ carrier: e.enum([
	"BRT",
	"DHL_EUROPLUS",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"DHL_FOR_YOU",
	"INPOST",
	"POSTNL"
]).optional() }), Nd = e.object({ data: e.object({ carrier_id: e.union([
	e.literal(1),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(15),
	e.literal(17)
]).optional() }).optional() }), Pd = e.object({
	city: e.string().min(1).max(100).register(e.globalRegistry, { description: "The city of the address." }),
	countryCode: e.string().length(2).regex(/[A-Z]{2}/).register(e.globalRegistry, { description: "The country code (ISO 3166-1 alpha-2) of the address." }),
	street: e.string().min(1).max(100).register(e.globalRegistry, { description: "The street of the address." }),
	additionalInformation: e.string().min(1).max(100).register(e.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The box number of the address. Only applicable for `countryCode`=`BE`." }).optional(),
	houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: e.string().min(1).max(100).register(e.globalRegistry, { description: "The region of the address." }).optional(),
	state: e.string().min(1).max(100).register(e.globalRegistry, { description: "The state of the address." }).optional()
}), Fd = e.object({
	name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the pickup location." }),
	code: e.string().min(1).max(64).register(e.globalRegistry, { description: "The location code of the pickup location." }).optional(),
	type: e.enum([
		"CLICK_COLLECT",
		"PARCEL_LOCKER",
		"PARCEL_POINT",
		"POST_OFFICE",
		"POST_POINT"
	]).register(e.globalRegistry, { description: "The bpost pickup location type." }).optional()
}), Id = e.object({
	address: Pd.optional(),
	location: Fd.optional(),
	retailNetworkId: e.enum(["PNPNL-01", "PNPBE-01"]).register(e.globalRegistry, { description: "PostNL Retail network ID." }).optional()
}).register(e.globalRegistry, { description: "Pickup location data." }), Ld = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: Id.optional(),
	carrier: Wl,
	packageType: Kl,
	physicalProperties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: e.object({ insuredAmount: h }).register(e.globalRegistry, { description: "Insurance option" }).optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "No tracking option (inverse of tracked)" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.object({ dueAmount: h }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.enum([
		"EARLY_MORNING_DELIVERY",
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
}), Rd = e.object({ data: e.object({ rates: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: Ho.optional(),
	carrier_id: iu,
	package_type: g,
	physical_properties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.object({ due_amount: h }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		cooled_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cooled delivery option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Tracking option" }).optional(),
		insurance: e.object({ insured_amount: h }).register(e.globalRegistry, { description: "Insurance option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
})).min(1) }) }), zd = e.union([e.object({
	shopId: e.int(),
	packageType: e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]),
	countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }),
	shipmentDirection: e.enum(["OUTBOUND"])
}), e.object({
	shopId: e.int(),
	packageType: e.null().optional(),
	countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }).optional(),
	shipmentDirection: e.enum(["INBOUND"])
})]), Bd = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}), Vd = e.object({ data: e.object({ webhook_subscriptions: e.array(Bd).min(1).optional() }) }), Hd = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string()
}), Ud = e.object({ data: e.object({ webhook_subscriptions: e.array(Hd).min(1).optional() }) }), Wd = e.object({
	body: e.string().min(1),
	subject: e.string().min(1).max(255)
}), Gd = e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }), Kd = Lu, qd = Bu, Jd = Ru, Yd = e.string().nullable(), Xd = e.string().nullable(), Zd = Vu, Qd = Hu, $d = e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }), ef = N, tf = N, nf = P.nullable(), rf = Uu, af = Wu, of = Gu, sf = Ku, cf = e.int().gte(-1).lte(14).nullable(), lf = e.int().gte(0).nullable(), uf = qu, df = e.int().gte(0).lte(14).nullable(), ff = e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }), pf = Yu, mf = P.nullable(), hf = e.string().nullable(), gf = e.boolean(), _f = Xu, vf = Uu, yf = e.string().register(e.globalRegistry, { description: "Filter by webhook event type." }), bf = e.boolean(), xf = Zu, Sf = e.int().nullable(), Cf = e.boolean(), wf = e.string().nullable(), Tf = Qu, Ef = N, Df = N, Of = P.nullable(), kf = e.int().register(e.globalRegistry, { description: "The ID of the notification group." }), Af = e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }), jf = e.int().register(e.globalRegistry, { description: "The ID of the notification template." }), Mf = e.string().nullable(), Nf = $u, Pf = ed, Ff = td, If = id, Lf = od, Rf = sd, zf = e.string().nullable(), Bf = e.string().nullable(), Vf = e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }), Hf = e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }), Uf = F, Wf = ld, Gf = I, Kf = I, qf = dd, Jf = fd, Yf = e.enum(["asc", "desc"]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }), Xf = pd, Zf = e.string().nullable(), Qf = Lu, $f = md, ep = rs, tp = F, np = _d, rp = Od, ip = Ad, ap = Md, op = Ld, sp = zd, cp = Vd, lp = Wd, up = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional()
}), dp = e.object({
	title: e.string().optional(),
	status: e.string()
}).register(e.globalRegistry, { description: "Status is OK" }), fp = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: sd.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: id.optional(),
		shop_id: I.optional(),
		carrier: Bu.optional(),
		delivery_date: Wu.optional(),
		delivery_time: Gu.optional(),
		cutoff_time: N.optional(),
		dropoff_days: qu.optional(),
		monday_delivery: P.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: Yu.optional(),
		exclude_parcel_lockers: P.nullish(),
		latitude: Zu.optional(),
		longitude: Qu.optional()
	}).optional()
}), pp = Uc, mp = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		postal_code: sd.optional(),
		number: e.string().nullish(),
		distance: e.int().gte(0).nullish(),
		cc: e.string().nullish(),
		limit: e.int().nullish(),
		carrier_id: Ru.optional(),
		shop_id: I.optional(),
		reference: e.string().nullish(),
		location_name: e.string().nullish(),
		external_identifier: e.string().nullish(),
		city: e.string().nullish(),
		cut_off_time: N.optional(),
		min_cut_off_time: N.optional(),
		max_cut_off_time: N.optional(),
		latitude: Zu.optional(),
		longitude: Qu.optional(),
		exclude_parcel_lockers: P.nullish()
	}).optional()
}), hp = gl, gp = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: sd.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: id.optional(),
		shop_id: I.optional(),
		carrier: Bu.optional(),
		delivery_date: Wu.optional(),
		delivery_time: Gu.optional(),
		cutoff_time: N.optional(),
		dropoff_days: qu.optional(),
		monday_delivery: P.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: Yu.optional(),
		exclude_parcel_lockers: P.nullish(),
		latitude: Zu.optional(),
		longitude: Qu.optional()
	}).optional()
}), _p = El, vp = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional()
}), yp = sl, bp = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: Lu.optional(),
		carrier_id: Ru.optional(),
		created: e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }).optional(),
		delayed: P.nullish(),
		delivered: Uu.optional(),
		dropoff_today: e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }).optional(),
		filter_hidden_shops: e.boolean().optional(),
		hidden: Uu.optional(),
		link_consumer_portal: e.boolean().optional(),
		order: $u.optional(),
		package_type: ed.optional(),
		page: td.optional(),
		q: e.string().nullish(),
		reference_identifier: e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }).optional(),
		region: e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }).optional(),
		shipment_type: ld.optional(),
		shop_id: I.optional(),
		size: dd.optional(),
		sort: fd.optional(),
		status: pd.optional(),
		transaction_status: rs.optional()
	}).optional()
}), xp = Nl, Sp = e.object({
	body: np,
	path: e.never().optional(),
	query: e.object({
		format: Xu.optional(),
		positions: od.optional(),
		collect_date: Vu.optional(),
		delivery_options_identifier: Ku.optional()
	}).optional()
}), Cp = Dl, wp = e.object({
	body: rp,
	path: e.never().optional(),
	query: e.never().optional()
}), Tp = e.union([Ec, e.void().register(e.globalRegistry, { description: "Shipment update was successful." })]), Ep = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.never().optional()
}), Dp = e.void().register(e.globalRegistry, { description: "Shipment deletion was successful." }), Op = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.object({ link_consumer_portal: e.boolean().optional() }).optional()
}), kp = Nl, Ap = e.object({
	body: ip,
	path: e.never().optional(),
	query: e.never().optional()
}), jp = ru, Mp = e.object({
	body: ap,
	path: e.never().optional(),
	query: e.never().optional()
}), Np = hu, Pp = e.object({
	body: op,
	path: e.never().optional(),
	query: e.never().optional()
}), Fp = e.union([Su, e.void().register(e.globalRegistry, { description: "This response is given when the request is successful and the response is empty." })]), Ip = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.object({
		format: Xu.optional(),
		positions: od.optional(),
		collect_date: Vu.optional(),
		delivery_options_identifier: Ku.optional()
	}).optional()
}), Lp = e.union([e.void().register(e.globalRegistry, { description: "Direct Printing Response" }), kc]), Rp = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: Lu.optional(),
		country_code: Hu.optional(),
		external_identifier: Lu.optional(),
		extra_info: md.optional(),
		postal_code: sd.optional(),
		sort: e.enum(["asc", "desc"]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional()
	}).optional()
}), zp = Ul, Bp = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.object({
		sort: e.enum(["asc", "desc"]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional(),
		extra_info: md.optional()
	}).optional()
}), Vp = Ul, Hp = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ shopId: I.optional() }).optional()
}), Up = Ou, Wp = e.object({
	body: sp,
	path: e.never().optional(),
	query: e.never().optional()
}), Gp = Ou, Kp = e.object({
	body: e.never().optional(),
	path: e.object({ ids: e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }) }),
	query: e.never().optional()
}), qp = e.void().register(e.globalRegistry, { description: "Notification group deletion was successful." }), Jp = e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional()
}), Yp = ju, Xp = e.object({
	body: lp,
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional()
}), Zp = e.void().register(e.globalRegistry, { description: "Notification template update was successful." }), Qp = e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional()
}), $p = e.void().register(e.globalRegistry, { description: "Disabling notification templates was successful." }), em = e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional()
}), tm = e.void().register(e.globalRegistry, { description: "Enabling notification templates was successful." }), nm = e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional()
}), rm = e.void().register(e.globalRegistry, { description: "Disabling notification template was successful." }), im = e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional()
}), am = e.void().register(e.globalRegistry, { description: "Enabling notification template was successful." }), om = e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional()
}), sm = e.void().register(e.globalRegistry, { description: "Test notification was successfully send." }), cm = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ hook: e.string().register(e.globalRegistry, { description: "Filter by webhook event type." }).optional() }).optional()
}), lm = Nu, um = e.object({
	body: cp,
	path: e.never().optional(),
	query: e.never().optional()
}), dm = Iu, fm = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.never().optional()
}), pm = e.void().register(e.globalRegistry, { description: "Webhook subscription deletion was successful." }), mm = e.object({
	body: e.never().optional(),
	path: e.object({ ids: F }),
	query: e.never().optional()
}), hm = Nu, gm = e.int().gte(400).lte(499).register(e.globalRegistry, { description: "The request contains bad syntax or cannot be fulfilled" }), _m = e.union([
	e.literal(3e3),
	e.literal(3001),
	e.literal(3002),
	e.literal(3003),
	e.literal(3004),
	e.literal(3005),
	e.literal(3006),
	e.literal(3007)
]).register(e.globalRegistry, { description: "Authentication and Authorization related error codes" }), vm = e.union([_m, e.int()]), ym = e.object({
	status: gm.optional(),
	code: vm.optional(),
	title: e.string().optional(),
	message: e.string().optional()
}), bm = e.object({
	message: e.string(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }),
	status_code: gm,
	errors: e.union([e.array(ym), e.record(e.string(), ym)])
}), xm = e.literal(404).register(e.globalRegistry, { description: "Did not find the requested target resource." });
bm.and(e.object({
	status_code: xm.optional(),
	errors: e.array(e.object({
		status: xm.optional(),
		code: e.int().optional()
	})).optional()
}));
var z = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }), Sm = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Cm = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), wm = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), Tm = e.string(), Em = e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullable(), Dm = e.object({
	person: e.string().optional(),
	company: e.string().nullish(),
	street: e.string().optional(),
	street_additional_info: e.string().nullish(),
	number: e.string().nullish(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	state: e.string().optional(),
	cc: Tm,
	region: e.string().nullish(),
	area: e.string().optional(),
	phone: e.string().nullish(),
	email: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullish(),
	secondary_emails: e.array(Em).nullish(),
	box_number: e.string().nullish(),
	eori_number: e.string().optional(),
	vat_number: e.string().optional(),
	invalid: e.boolean().optional()
}), Om = Dm.and(e.object({
	person: e.unknown().optional(),
	company: e.unknown().optional(),
	street: e.unknown().optional(),
	street_additional_info: e.unknown().optional(),
	number: e.unknown().optional(),
	number_suffix: e.unknown().optional(),
	postal_code: e.unknown().optional(),
	city: e.unknown().optional(),
	state: e.unknown().optional(),
	area: e.unknown().optional(),
	phone: e.unknown().optional()
})), km = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(98),
	e.literal(99),
	e.literal(100),
	e.literal(101),
	e.literal(30),
	e.literal(31),
	e.literal(32),
	e.literal(33),
	e.literal(34),
	e.literal(35),
	e.literal(36),
	e.literal(37),
	e.literal(38)
]), Am = e.object({
	currency: e.union([e.enum(["EUR"]), e.string()]),
	amount: e.int().gte(0)
}), jm = e.object({ insurance: Am.optional() }).and(e.object({ insurance: e.object({ amount: e.unknown().optional() }).optional() })), B = e.union([e.literal(0), e.literal(1)]), V = e.object({
	currency: e.union([e.enum(["", "EUR"]), e.string()]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." }),
	amount: e.union([e.int().gte(0), e.string()])
}).register(e.globalRegistry, { description: "Money amount with currency" }), Mm = e.object({
	age_check: B.optional(),
	cash_on_delivery: V.optional(),
	collect: B.optional(),
	cooled_delivery: B.optional(),
	drop_off_at_postal_point: B.optional(),
	extra_assurance: B.optional(),
	fresh_food: B.optional(),
	frozen: B.optional(),
	hide_sender: B.optional(),
	large_format: B.optional(),
	only_recipient: B.optional(),
	priority_delivery: B.optional(),
	receipt_code: B.optional(),
	return: B.optional(),
	same_day_delivery: B.optional(),
	saturday_delivery: B.optional(),
	signature: B.optional(),
	tracked: B.optional()
}), Nm = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]).register(e.globalRegistry, { description: "Package Type." }), Pm = e.object({ package_type: Nm.optional() }), Fm = e.object({ delivery_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]).nullish() }), Im = e.object({ delivery_date: e.string().nullish() }), Lm = e.object({ label_description: e.string().optional() }), H = jm.and(Mm).and(Pm).and(Fm).and(Im).and(Lm), Rm = e.union([e.union([e.enum([""]), e.string()]), e.unknown()]).nullable(), zm = e.object({
	save_recipient_address: B.optional(),
	delivery_notification: B.optional(),
	delivery_notification_email: e.array(e.email()).optional(),
	disable_auto_detect_pickup: B.optional(),
	printer_identifier: e.string().optional(),
	tracktrace: e.object({
		bcc: B.optional(),
		bcc_email: Rm.optional(),
		carrier_email_basic_notification: B.optional(),
		delivery_notification: B.optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: B.optional(),
		email_on_handed_to_courier: B.optional(),
		from_address_company: e.string().optional(),
		from_address_email: e.email().optional(),
		printer_identifier: e.string().optional(),
		save_recipient_address: B.optional(),
		send_track_trace_emails: B.optional()
	}).optional()
}).nullable(), Bm = e.object({
	location_code: e.string().optional(),
	location_name: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().optional(),
	retail_network_id: e.string().optional()
}).nullable(), Vm = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5)
]), Hm = e.object({
	description: e.string(),
	amount: e.int().gte(1).lte(99999),
	weight: e.int().gte(0).lte(999999999),
	item_value: V,
	classification: e.string(),
	country: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).optional()
}), U = e.object({
	contents: Vm,
	invoice: e.string().nullish(),
	eori_number: e.string().nullish(),
	vat_number: e.string().nullish(),
	vat_number_uk: e.string().nullish(),
	voec_number: e.string().nullish(),
	weight: e.int().gte(0).lte(999999999),
	items: e.array(Hm)
}), Um = e.int().gte(0).lte(999999999), Wm = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Gm = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Km = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), qm = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Jm = Um, Ym = Wm, Xm = Gm, Zm = Km, Qm = qm, $m = e.object({
	weight: Um.optional(),
	height: Wm.optional(),
	width: Gm.optional(),
	length: Km.optional(),
	volume: qm.optional(),
	carrier_weight: Jm.nullish(),
	carrier_height: Ym.nullish(),
	carrier_width: Xm.nullish(),
	carrier_length: Zm.nullish(),
	carrier_volume: Qm.nullish()
}).nullable(), eh = e.union([e.int(), e.string()]).nullable(), th = e.union([e.enum([
	"pending",
	"unpaid",
	"paid"
]), e.string()]).nullable(), nh = Bm, rh = e.union([e.enum([
	"Facebook",
	"Google",
	"Flespakket.nl",
	"Amazon",
	"Bol.com",
	"MyParcel.nl",
	"Wix",
	"Ecwid",
	"Exact Online DE",
	"Exact Online NL",
	"Etsy"
]), e.string()]), ih = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), ah = e.union([e.enum([
	"pending",
	"unpaid",
	"paid"
]), e.string()]).nullable(), W = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19)
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), oh = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), sh = e.string(), ch = e.string().nullable(), lh = z.nullable(), uh = Sm, dh = Cm, fh = wm, ph = Om, mh = Dm, hh = km, gh = H.and(e.unknown()), _h = zm, vh = Bm, yh = U.nullable(), bh = $m, xh = eh, Sh = th, Ch = nh, wh = B, Th = V, Eh = e.string(), Dh = e.union([e.unknown(), e.union([e.enum(["Wereld"]), e.string()])]), Oh = rh.nullable(), kh = ih.nullable(), Ah = ah, jh = W, Mh = oh, Nh = sh.nullable(), Ph = ch, Fh = e.string(), Ih = e.string(), Lh = e.union([e.string(), e.int()]), Rh = e.string(), zh = e.string(), Bh = e.string(), Vh = e.string(), Hh = e.string(), Uh = e.string().nullable(), Wh = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).optional(),
	gender: e.string().nullish(),
	first_name: e.string().nullish(),
	last_name: e.string().nullable(),
	email: e.union([e.union([e.enum([""]), e.string()]), e.unknown()]).nullable(),
	phone: e.string().nullable(),
	company: e.string().nullable(),
	street: Fh,
	street_additional_info: Ih.optional(),
	number: Lh,
	number_suffix: Rh.optional(),
	postal_code: zh,
	city: Bh,
	cc: Vh,
	region: Hh.optional(),
	box_number: Uh.optional()
}), Gh = Wh.nullable(), Kh = z.nullable(), qh = e.string().nullable(), Jh = qh, Yh = e.boolean().default(!1), Xh = e.boolean().default(!1), Zh = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullable(), Qh = e.union([e.enum(["", "EUR"]), e.string()]), $h = Qh.nullable(), eg = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(), tg = e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullable(), ng = e.array(e.object({
	uri: e.union([e.union([e.enum([""]), e.string()]), e.unknown()]),
	barcode: e.string()
})), rg = ng, ig = e.string().nullable(), ag = e.uuid().max(36).nullable(), og = e.int().nullable(), sg = e.string().nullable(), cg = e.record(e.string(), e.unknown()).nullable(), lg = e.string().nullable(), ug = e.object({
	quantity: og.optional(),
	order_line_identifier: sg.optional(),
	order_line: cg.optional(),
	picklist_identifier: lg.optional(),
	order_identifier: e.string().nullish()
}).nullable(), dg = e.array(ug).nullable(), fg = e.string().register(e.globalRegistry, { description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), pg = fg, mg = pg, hg = fg, gg = hg, _g = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), vg = _g.nullable(), yg = vg, bg = _g.nullable(), xg = bg, Sg = e.object({
	id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }),
	parent_id: z.nullable(),
	account_id: Sm,
	shop_id: Cm,
	shipment_type: wm,
	recipient: Om,
	sender: Dm,
	status: km,
	options: H.and(e.unknown()),
	general_settings: zm,
	pickup: Bm,
	customs_declaration: U.nullable(),
	physical_properties: $m,
	reference_identifier: eh,
	transaction_status: th,
	drop_off_point: nh,
	hidden: B,
	price: V,
	barcode: e.string(),
	region: e.union([e.unknown(), e.union([e.enum(["Wereld"]), e.string()])]),
	external_provider: rh.nullable(),
	external_provider_id: ih.nullable(),
	payment_status: ah,
	carrier_id: W,
	platform_id: oh,
	origin: sh.nullable(),
	user_agent: ch,
	secondary_shipments: e.array(e.object({
		id: z,
		parent_id: lh,
		account_id: uh,
		shop_id: dh,
		shipment_type: fh,
		recipient: ph,
		sender: mh,
		status: hh,
		options: gh,
		general_settings: _h,
		pickup: vh,
		customs_declaration: yh,
		physical_properties: bh,
		reference_identifier: xh,
		transaction_status: Sh,
		drop_off_point: Ch,
		hidden: wh,
		price: Th,
		barcode: Eh,
		region: Dh,
		external_provider: Oh,
		external_provider_id: kh,
		payment_status: Ah,
		carrier_id: jh,
		platform_id: Mh,
		origin: Nh,
		user_agent: Ph,
		secondary_shipments: e.array(e.unknown()).max(0).nullish(),
		collection_contact: Gh,
		multi_collo_main_shipment_id: Kh,
		external_identifier: Jh,
		delayed: Yh,
		delivered: Xh,
		amount: Zh.optional(),
		currency: $h.optional(),
		contract_id: eg,
		link_consumer_portal: tg.optional(),
		partner_tracktraces: rg.optional(),
		pickup_request_number: ig.optional(),
		order_shipment_identifier: ag.optional(),
		shipped_items: dg.optional(),
		created: mg,
		modified: gg,
		created_by: yg,
		modified_by: xg
	})),
	collection_contact: Wh.nullable(),
	multi_collo_main_shipment_id: z.nullable(),
	external_identifier: qh,
	delayed: e.boolean().default(!1),
	delivered: e.boolean().default(!1),
	amount: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullish(),
	currency: Qh.nullish(),
	contract_id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(),
	link_consumer_portal: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullish(),
	partner_tracktraces: ng.optional(),
	pickup_request_number: e.string().nullish(),
	order_shipment_identifier: e.uuid().max(36).nullish(),
	shipped_items: e.array(ug).nullish(),
	created: pg,
	modified: hg,
	created_by: vg,
	modified_by: bg
}), Cg = e.object({ data: e.object({ shipments: e.array(Sg).register(e.globalRegistry, { description: "A list of Shipment Resources." }) }) });
e.union([e.string(), e.unknown()]);
var wg = e.object({ url: e.url().optional() }), Tg = e.object({ data: e.union([
	e.object({ pdfs: wg.optional() }),
	e.object({ csvs: wg.optional() }),
	e.object({ zpls: wg.optional() })
]) }), Eg = e.array(e.object({
	shipment_id: z,
	price: V,
	price_after_vat: V
}));
e.object({ data: e.object({ shipments: e.object({
	unpaid_shipments: Eg,
	blocked_shipments: Eg
}) }) });
var Dg = e.object({
	amount: e.int().nullable(),
	currency: e.union([e.enum(["", "EUR"]), e.string()]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." })
}).register(e.globalRegistry, { description: "Price amount in a specific currency" }), Og = e.object({
	id: e.string(),
	hash: e.string(),
	type: e.int(),
	notification_hash: e.string(),
	original_notification_hash: e.string(),
	paid: e.union([e.literal(0), e.literal(1)]),
	price: Dg,
	payment_url: e.url().nullable(),
	invoices: e.object({
		id: e.int(),
		number: e.string(),
		status: e.int()
	})
});
e.object({ data: e.object({ payment_instructions: e.array(Og) }) });
var kg = e.literal(400).register(e.globalRegistry, { description: "The server will not process the request due to a client error." });
bm.and(e.object({
	status_code: kg.optional(),
	errors: e.array(e.object({
		status: kg.optional(),
		code: e.int().optional()
	})).optional()
}));
var Ag = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3)
]), G = e.object({
	date: fg,
	timezone: e.string(),
	timezone_type: Ag
}), jg = e.union([e.enum([
	"morning",
	"standard",
	"evening",
	"same_day",
	"express",
	"early_morning"
]), e.string()]), Mg = e.union([e.enum([
	"package",
	"mailbox",
	"unfranked",
	"digital_stamp",
	"pallet",
	"small_package",
	"envelope"
]), e.string()]).register(e.globalRegistry, { description: "Package Type." }), Ng = e.object({
	type: e.union([e.enum(["start", "end"]), e.string()]),
	date_time: G
}), Pg = e.object({
	type: jg.nullable(),
	package_type: Mg,
	delivery_time_frames: e.array(Ng),
	shipment_options: e.array(e.object({
		name: e.string(),
		schema: e.object({
			type: e.union([e.enum(["boolean"]), e.string()]),
			enum: e.array(e.boolean())
		})
	})),
	price: Dg.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), Fg = e.object({
	date: G,
	possibilities: e.array(Pg)
}), Ig = e.object({ data: e.object({ deliveries: e.array(Fg) }) }), Lg = e.iso.date().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])/).register(e.globalRegistry, { description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n" }), Rg = e.iso.time().regex(/([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(e.globalRegistry, { description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), zg = e.object({
	start: Rg,
	end: Rg,
	price: Dg,
	price_comment: e.string(),
	comment: e.string(),
	type: e.int(),
	collect_date: G.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), Bg = e.object({
	date: Lg,
	time: e.array(zg)
}), Vg = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), Hg = e.object({
	start: Rg.nullish(),
	type: Vg.optional(),
	price: Dg.optional()
}), Ug = e.array(e.string()).register(e.globalRegistry, { description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n" }), Wg = e.object({
	monday: Ug,
	tuesday: Ug,
	wednesday: Ug,
	thursday: Ug,
	friday: Ug,
	saturday: Ug,
	sunday: Ug
}), Gg = e.union([e.number().gte(-90).lte(90), e.string()]), Kg = e.union([e.number().gte(-180).lte(180), e.string()]), qg = e.object({
	date: Lg.nullish(),
	time: e.array(Hg).optional(),
	location: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().optional(),
	start_time: Rg.nullish(),
	price: e.int().optional(),
	price_comment: e.union([e.enum(["retail", "retailexpress"]), e.string()]).optional(),
	comment: e.string().optional(),
	phone_number: e.string().optional(),
	opening_hours: Wg.optional(),
	distance: e.string().optional(),
	latitude: Gg.optional(),
	longitude: Kg.optional(),
	location_code: e.string().optional(),
	retail_network_id: e.string().nullish(),
	holiday: e.object({
		from: e.string().nullish(),
		to: e.string().nullish()
	}).optional()
}), Jg = e.int().gte(500).lte(599).register(e.globalRegistry, { description: "The server failed to fulfill an apparently valid request" }), Yg = e.union([gm, Jg]), Xg = e.object({
	status: Yg.optional(),
	code: vm,
	title: e.string().optional(),
	message: e.string()
});
e.object({
	data: e.object({
		delivery: e.array(Bg),
		pickup: e.array(qg),
		message: e.string().optional()
	}),
	errors: e.array(e.union([Xg, e.object({
		code: e.int(),
		message: e.string(),
		human: e.string().optional()
	})])).optional()
});
var Zg = e.literal(406).register(e.globalRegistry, { description: "The target resource doesn't have an acceptable representation for the user agent." });
bm.and(e.object({
	status_code: Zg.optional(),
	errors: e.array(e.object({
		status: Zg.optional(),
		code: e.int().optional()
	})).optional()
}));
var Qg = e.object({ link: e.url() }).register(e.globalRegistry, { description: "DownloadUrl Object Definition" }), $g = e.object({ data: e.object({ download_url: Qg }) }), e_ = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), t_ = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]), n_ = e.array(e.union([e_, t_])).nullable(), r_ = e.object({
	monday: e.number().nullish(),
	tuesday: e.number().nullish(),
	wednesday: e.number().nullish(),
	thursday: e.number().nullish(),
	friday: e.number().nullish(),
	saturday: e.number().nullish(),
	sunday: e.number().nullish()
}), i_ = e.union([e.enum(["retail", "locker"]), e.string()]), a_ = e.object({
	start: G.nullable(),
	end: G.nullable()
}), o_ = e.array(a_), s_ = e.object({
	monday: o_.optional(),
	tuesday: o_.optional(),
	wednesday: o_.optional(),
	thursday: o_.optional(),
	friday: o_.optional(),
	saturday: o_.optional(),
	sunday: o_.optional()
}).nullable(), c_ = e.object({
	location_code: e.string().optional(),
	location_name: e.string().nullish(),
	cc: e.string().optional(),
	state: e.string().nullish(),
	city: e.string().optional(),
	postal_code: e.string().optional(),
	street: e.string().optional(),
	number: e.union([e.string(), e.int()]).nullish(),
	number_suffix: e.string().nullish(),
	phone: e.string().nullish(),
	reference: e.string().nullish(),
	longitude: Kg.nullish(),
	latitude: Gg.nullish(),
	available_days: n_.optional(),
	cut_off_time: e.string().nullish(),
	carrier_id: W.optional(),
	distance: e.number().nullish(),
	occupancy: r_.nullish(),
	occupancy_today: e.number().nullish(),
	default_drop_off_point: e.boolean().nullish(),
	type: i_.nullish(),
	opening_hours: s_.optional()
}), l_ = e.object({ data: e.object({ drop_off_points: e.array(c_) }) }), u_ = e.literal(415).register(e.globalRegistry, { description: "Content is in a format not supported by this method on the target resource." });
bm.and(e.object({
	status_code: u_.optional(),
	errors: e.array(e.object({
		status: u_.optional(),
		code: e.literal(3100).optional()
	})).optional()
}));
var d_ = e.literal(401).register(e.globalRegistry, { description: "The request lacks valid authentication credentials for the target resource." });
bm.and(e.object({
	status_code: d_.optional(),
	errors: e.array(e.object({
		status: d_.optional(),
		code: e.int().optional()
	})).optional()
}));
var f_ = e.object({
	cc: e.string(),
	city: e.string(),
	street: e.string(),
	postal_code: e.string(),
	number: e.string(),
	number_suffix: e.string().nullish()
}), p_ = e.array(e.object({
	delivery_type_id: e.int(),
	delivery_type_name: e.string(),
	price: e.int(),
	moment: e.object({ start: G.nullish() })
})), m_ = e.object({
	start: G.nullable(),
	end: G.nullable()
}), h_ = e.object({
	monday: e.array(m_),
	tuesday: e.array(m_),
	wednesday: e.array(m_),
	thursday: e.array(m_),
	friday: e.array(m_),
	saturday: e.array(m_),
	sunday: e.array(m_)
}), g_ = e.object({
	location_name: e.string(),
	retail_network_id: e.string().nullable(),
	distance: e.string(),
	latitude: e.string(),
	longitude: e.string(),
	location_code: e.string(),
	phone_number: e.string().nullable(),
	type: i_.nullable(),
	opening_hours: h_
}), __ = e.object({
	address: f_,
	possibilities: p_,
	location: g_
}), v_ = e.object({ data: e.object({ pickup_locations: e.array(__) }) }), y_ = e.object({ data: e.object({
	shipments: e.array(Sg).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	pdf: e.object({ url: e.string() }).optional(),
	zpl: e.object({ url: e.string() }).optional()
}) });
e.object({ data: e.object({ ids: e.array(e.object({
	id: z,
	reference_identifier: eh
})).register(e.globalRegistry, { description: "A list of Shipment IDs." }) }) });
var b_ = e.array(e.object({
	id: z,
	reference_identifier: eh
})).register(e.globalRegistry, { description: "A list of Shipment IDs." });
e.object({ data: e.union([e.object({
	ids: b_,
	pdf: e.object({ url: e.string() })
}), e.object({
	ids: b_,
	zpl: e.object({ url: e.string() })
})]) });
var x_ = e.object({
	status: Jg.optional(),
	code: e.int().optional(),
	title: e.string().optional(),
	message: e.string().optional()
});
e.object({
	message: e.string().register(e.globalRegistry, { description: "A human-readable description of the error." }).optional(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }).optional(),
	status_code: Jg.optional(),
	errors: e.array(x_).optional()
});
var S_ = e.object({ data: e.object({
	shipments: e.array(Sg).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	results: e.int().register(e.globalRegistry, { description: "The number of results." })
}) }), C_ = e.object({
	uri: e.url(),
	barcode: e.string()
}), w_ = e.object({
	name: e.string(),
	cc: e.string().nullable(),
	city: e.string().nullable(),
	postal_code: e.string().nullable(),
	street: e.string().nullable(),
	number: e.string().nullable(),
	number_suffix: e.string().nullable(),
	longitude: e.number().nullable(),
	latitude: e.number().nullable()
}), T_ = e.union([e.enum([
	"registered",
	"handed_to_carrier",
	"sorting",
	"distribution",
	"delivered"
]), e.string()]).nullable(), E_ = e.object({
	code: e.string(),
	status: km,
	main: T_,
	description: e.string(),
	time: fg,
	delayed: e.boolean(),
	location: w_
}), D_ = e.array(E_), O_ = e.union([e.enum(["estimated", "expected"]), e.string()]).nullable(), k_ = e.object({
	start: G.nullable(),
	end: G.nullable()
}).nullable(), A_ = e.union([e.string(), e.object({
	content: e.string(),
	content_type: e.string()
})]).nullable(), j_ = e.object({
	shipment_id: z,
	carrier: W,
	code: e.string(),
	description: e.string(),
	time: fg,
	link_consumer_portal: e.url().nullable(),
	link_tracktrace: e.url().nullable(),
	partner_tracktraces: e.array(C_),
	recipient: Om,
	sender: Dm,
	options: H,
	pickup: Bm,
	delayed: e.boolean(),
	location: w_,
	status: e.object({
		current: km,
		main: T_,
		final: e.boolean()
	}),
	history: D_,
	delivery_moment_type: O_.optional(),
	delivery_moment: k_.optional(),
	signature: A_.optional(),
	returnable: e.boolean().optional()
}).register(e.globalRegistry, { description: "A Track & Trace resource." }), M_ = e.object({ data: e.object({ tracktraces: e.array(j_).register(e.globalRegistry, { description: "A list of Track & Trace Resources." }) }) }), N_ = e.union([e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTE_ITALIANE",
	"POSTNL",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD"
]), e.string()]).register(e.globalRegistry, { description: "Carrier string definition for capabilities endpoints (v2)" }), P_ = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.union([e.enum(["MAIN", "CUSTOM"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v2)" }), F_ = e.union([e.enum([
	"PACKAGE",
	"MAILBOX",
	"UNFRANKED",
	"DIGITAL_STAMP",
	"PALLET",
	"SMALL_PACKAGE",
	"ENVELOPE"
]), e.string()]).register(e.globalRegistry, { description: "Package Type." }), K = e.object({
	isSelectedByDefault: e.boolean(),
	isRequired: e.boolean()
}), I_ = e.object({
	additionalInsurance: K.optional(),
	cooledDelivery: K.optional(),
	customLabelText: K.optional(),
	deliverAtPostalPoint: K.optional(),
	deliveryDate: K.optional(),
	freshFood: K.optional(),
	frozen: K.optional(),
	hideSender: K.optional(),
	noTracking: K.optional(),
	oversizedPackage: K.optional(),
	priorityDelivery: K.optional(),
	printReturnLabelAtDropOff: K.optional(),
	recipientOnlyDelivery: K.optional(),
	requiresAgeVerification: K.optional(),
	requiresCashOnDelivery: K.optional(),
	requiresReceiptCode: K.optional(),
	requiresSignature: K.optional(),
	returnContributionFee: K.optional(),
	returnOnFirstFailedDelivery: K.optional(),
	sameDayDelivery: K.optional(),
	saturdayDelivery: K.optional(),
	scheduledCollection: K.optional(),
	tracked: K.optional()
}), q = K.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are excluded" })
})), L_ = e.object({ insuredAmount: e.object({
	default: V,
	min: V,
	max: V
}).optional() }), R_ = q.and(L_), z_ = I_.and(e.object({
	additionalInsurance: q.optional(),
	cooledDelivery: q.optional(),
	customLabelText: q.optional(),
	deliverAtPostalPoint: q.optional(),
	deliveryDate: q.optional(),
	freshFood: q.optional(),
	frozen: q.optional(),
	hideSender: q.optional(),
	insurance: R_.optional(),
	noTracking: q.optional(),
	oversizedPackage: q.optional(),
	priorityDelivery: q.optional(),
	printReturnLabelAtDropOff: q.optional(),
	recipientOnlyDelivery: q.optional(),
	requiresAgeVerification: q.optional(),
	requiresCashOnDelivery: q.optional(),
	requiresReceiptCode: q.optional(),
	requiresSignature: q.optional(),
	returnContributionFee: q.optional(),
	returnOnFirstFailedDelivery: q.optional(),
	sameDayDelivery: q.optional(),
	saturdayDelivery: q.optional(),
	scheduledCollection: q.optional(),
	tracked: q.optional()
})), B_ = e.object({
	value: e.number().register(e.globalRegistry, { description: "The numeric value" }),
	unit: e.union([e.enum([
		"g",
		"kg",
		"cm",
		"mm",
		"mm3",
		"cm3",
		"dm3",
		"m3"
	]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units" })
}), J = e.object({
	min: B_,
	max: B_,
	calculation: e.string()
}), V_ = e.object({
	weight: J.optional(),
	width: J.optional(),
	length: J.optional(),
	height: J.optional(),
	girth: J.optional(),
	volumetric_weight: J.optional(),
	volume: J.optional(),
	length_width_height_sum: J.optional()
}), H_ = e.union([e.enum([
	"MORNING_DELIVERY",
	"STANDARD_DELIVERY",
	"EVENING_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"EXPRESS_DELIVERY",
	"EARLY_MORNING_DELIVERY"
]), e.string()]), U_ = e.union([e.enum(["B2B", "B2C"]), e.string()]), W_ = e.object({ max: e.int() }), G_ = e.object({
	carrier: N_,
	contract: P_.optional(),
	packageTypes: e.array(F_),
	options: z_,
	physicalProperties: V_,
	deliveryTypes: e.array(H_),
	transactionTypes: e.array(U_),
	collo: W_
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), K_ = e.object({ results: e.array(G_).register(e.globalRegistry, { description: "A list of V2 Capabilities for a given Shipment configuration." }) }), q_ = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19)
]).register(e.globalRegistry, { description: "Carrier ID definition for capabilities endpoints (v1)" }), J_ = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.union([e.enum(["main", "custom"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v1)" }), Y = e.object({
	is_selected_by_default: e.boolean(),
	is_required: e.boolean()
}), Y_ = e.object({
	age_check: Y.optional(),
	cash_on_delivery: Y.optional(),
	collect: Y.optional(),
	contribution: Y.optional(),
	cooled_delivery: Y.optional(),
	delivery_date: Y.optional(),
	drop_off_at_postal_point: Y.optional(),
	extra_assurance: Y.optional(),
	fresh_food: Y.optional(),
	frozen: Y.optional(),
	hide_sender: Y.optional(),
	label_description: Y.optional(),
	large_format: Y.optional(),
	no_tracking: Y.optional(),
	only_recipient: Y.optional(),
	printerless_return: Y.optional(),
	priority_delivery: Y.optional(),
	receipt_code: Y.optional(),
	return: Y.optional(),
	same_day_delivery: Y.optional(),
	saturday_delivery: Y.optional(),
	signature: Y.optional(),
	tracked: Y.optional()
}), X = Y.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are excluded" })
})), X_ = e.object({ insured_amount: e.object({
	default: V,
	min: V,
	max: V
}).optional() }), Z_ = X.and(X_), Q_ = Y_.and(e.object({
	age_check: X.optional(),
	cash_on_delivery: X.optional(),
	collect: X.optional(),
	contribution: X.optional(),
	cooled_delivery: X.optional(),
	delivery_date: X.optional(),
	drop_off_at_postal_point: X.optional(),
	extra_assurance: X.optional(),
	fresh_food: X.optional(),
	frozen: X.optional(),
	hide_sender: X.optional(),
	insurance: Z_.optional(),
	label_description: X.optional(),
	large_format: X.optional(),
	no_tracking: X.optional(),
	only_recipient: X.optional(),
	printerless_return: X.optional(),
	priority_delivery: X.optional(),
	receipt_code: X.optional(),
	return: X.optional(),
	same_day_delivery: X.optional(),
	saturday_delivery: X.optional(),
	signature: X.optional(),
	tracked: X.optional()
})), $_ = e.object({
	carrier_id: q_,
	contract: J_.optional(),
	package_types: e.array(Nm),
	options: Q_,
	physical_properties: V_,
	delivery_types: e.array(Vg),
	transaction_types: e.array(U_),
	collo: W_
}).register(e.globalRegistry, { description: "A V1 Capability response item for a given Shipment configuration." });
e.object({ data: e.object({ capabilities: e.array($_).register(e.globalRegistry, { description: "A list of V1 Capabilities for a given Shipment configuration." }) }) });
var Z = K.and(e.object({})), ev = Z.and(L_), tv = I_.and(e.object({
	additionalInsurance: Z.optional(),
	cooledDelivery: Z.optional(),
	customLabelText: Z.optional(),
	deliverAtPostalPoint: Z.optional(),
	deliveryDate: Z.optional(),
	hideSender: Z.optional(),
	insurance: ev.optional(),
	noTracking: Z.optional(),
	oversizedPackage: Z.optional(),
	priorityDelivery: Z.optional(),
	printReturnLabelAtDropOff: Z.optional(),
	recipientOnlyDelivery: Z.optional(),
	requiresAgeVerification: Z.optional(),
	requiresCashOnDelivery: Z.optional(),
	requiresReceiptCode: Z.optional(),
	requiresSignature: Z.optional(),
	returnContributionFee: Z.optional(),
	returnOnFirstFailedDelivery: Z.optional(),
	sameDayDelivery: Z.optional(),
	saturdayDelivery: Z.optional(),
	scheduledCollection: Z.optional(),
	tracked: Z.optional()
})), nv = e.object({
	carrier: N_,
	packageTypes: e.array(F_),
	options: tv,
	deliveryTypes: e.array(H_),
	transactionTypes: e.array(U_),
	collo: W_
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), rv = e.object({ items: e.array(nv).register(e.globalRegistry, { description: "A superset of V2 Capabilities for the contracts within a user's account." }) }), Q = Y.and(e.object({})), iv = Q.and(X_), av = Y_.and(e.object({
	age_check: Q.optional(),
	cash_on_delivery: Q.optional(),
	collect: Q.optional(),
	contribution: Q.optional(),
	cooled_delivery: Q.optional(),
	delivery_date: Q.optional(),
	drop_off_at_postal_point: Q.optional(),
	extra_assurance: Q.optional(),
	hide_sender: Q.optional(),
	insurance: iv.optional(),
	label_description: Q.optional(),
	large_format: Q.optional(),
	no_tracking: Q.optional(),
	only_recipient: Q.optional(),
	printerless_return: Q.optional(),
	priority_delivery: Q.optional(),
	receipt_code: Q.optional(),
	return: Q.optional(),
	same_day_delivery: Q.optional(),
	saturday_delivery: Q.optional(),
	signature: Q.optional(),
	tracked: Q.optional()
})), ov = e.object({
	carrier_id: q_,
	package_types: e.array(Nm),
	options: av,
	delivery_types: e.array(Vg),
	transaction_types: e.array(U_),
	collo: W_
}).register(e.globalRegistry, { description: "A V2 Capability contract definitions response item for a given Shipment configuration." });
e.object({ data: e.object({ capabilities: e.array(ov).register(e.globalRegistry, { description: "A superset of V1 Capabilities for the contracts within a user's account." }).optional() }) });
var sv = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.union([e.enum(["MAIN", "CUSTOM"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), cv = e.object({
	name: e.string(),
	key: e.string(),
	price: V,
	vat: V,
	priceWithVat: V
}).register(e.globalRegistry, { description: "A V2 Price object." }), lv = e.object({
	base: cv,
	charges: e.array(cv),
	discounts: e.array(cv),
	options: e.array(cv),
	other: e.array(cv),
	total: cv
}).register(e.globalRegistry, { description: "The V2 price composition object, containing the base, options, charges, discounts and total prices." }), uv = e.object({
	carrier: N_,
	contract: sv.optional(),
	packageType: F_,
	deliveryType: H_,
	priceComposition: lv
}).register(e.globalRegistry, { description: "A V2 Rate response item for a given Shipment configuration." }), dv = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.union([e.enum(["main", "custom"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), fv = e.object({
	name: e.string(),
	key: e.string(),
	price: V,
	vat: V,
	price_with_vat: V
}).register(e.globalRegistry, { description: "A V1 Price object." }), pv = e.object({
	base: fv,
	charges: e.array(fv),
	discounts: e.array(fv),
	options: e.array(fv),
	other: e.array(fv),
	total: fv
}).register(e.globalRegistry, { description: "The price composition object, containing the base, options, charges, discounts and total prices." }), mv = e.object({
	carrier_id: q_,
	contract: dv.optional(),
	package_type: Nm,
	delivery_type: Vg,
	price_composition: pv
}).register(e.globalRegistry, { description: "A V1 Rate response item for a given Shipment configuration." });
e.object({ data: e.object({ rates: e.array(mv).register(e.globalRegistry, { description: "A list of V1 Rates for a given Shipment configuration." }) }) });
var hv = e.object({
	id: e.int(),
	shopId: e.int(),
	packageType: e.union([e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]), e.string()]).nullable(),
	countryCode: e.string().nullable(),
	shipmentDirection: e.union([e.enum(["OUTBOUND", "INBOUND"]), e.string()]),
	fallback: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Group response item" }), gv = e.object({ results: e.array(hv) }), _v = e.union([e.enum([
	"LABEL_DOWNLOAD",
	"FIRST_SCAN",
	"RETURN"
]), e.string()]).register(e.globalRegistry, { description: "The notification template type." }), vv = e.object({
	id: e.int(),
	notificationGroupId: e.int(),
	type: _v,
	subject: e.string(),
	body: e.string(),
	active: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Template response item" }), yv = e.object({ results: e.array(vv) }), bv = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" }), xv = e.object({ data: e.object({ webhook_subscriptions: e.array(bv) }) }), Sv = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" });
e.object({ data: e.object({ webhook_subscriptions: e.array(Sv) }) });
var Cv = e.object({ data: e.object({ ids: e.array(e.object({ id: e.int() })).register(e.globalRegistry, { description: "A list of created webhook subscription IDs." }) }) }), wv = e.string(), Tv = e.union([e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19"
]), e.string()]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Ev = e.union([e.enum([
	"postnl",
	"bpost",
	"cheapcargo",
	"dpd",
	"instabox",
	"dhl",
	"bol.com",
	"ups",
	"dhlforyou",
	"dhlparcelconnect",
	"dhleuroplus",
	"upsstandard",
	"upsexpresssaver",
	"gls",
	"brt",
	"trunkrs",
	"inpost",
	"posteitaliane",
	"spring"
]), e.string()]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Dv = e.union([Tv, Ev]).nullable(), Ov = e.iso.date().regex(/\d{4}-\d{2}-\d{2}/).nullable(), kv = e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }), Av = Rg.nullable(), $ = e.union([
	e.boolean(),
	e.int().gte(0).lte(1),
	e.union([e.unknown(), e.unknown()]),
	e.union([e.enum([
		"0",
		"1",
		"false",
		"true"
	]), e.string()])
]), jv = e.union([
	e.literal(!1),
	e.literal(!0),
	e.literal(0),
	e.literal(1),
	e.literal("0"),
	e.literal("1"),
	e.literal("false"),
	e.literal("true"),
	e.literal("off"),
	e.literal("on"),
	e.literal("no"),
	e.literal("yes"),
	e.literal("")
]).nullable(), Mv = Lg.nullable(), Nv = Rg.nullable(), Pv = e.string().nullable(), Fv = e.string().nullable(), Iv = e.union([e.enum([
	"1",
	"2",
	"3",
	"4",
	"6",
	"7",
	"8"
]), e.string()]), Lv = e.union([Iv, e.unknown()]), Rv = e.union([e.enum(["A4", "A6"]), e.string()]).register(e.globalRegistry, { description: "The size of a paper as specified in ISO216." }), zv = Gg.nullable(), Bv = Kg.nullable(), Vv = e.union([e.enum(["ASC", "DESC"]), e.string()]).register(e.globalRegistry, { description: "Specify whether the results should be sorted in ascending or descending order." }), Hv = e.union([
	Nm,
	e.array(Nm),
	e.string()
]), Uv = e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "Request a specific page of the results, used for paginated results." }), Wv = e.union([e.enum([
	"myparcel",
	"flespakket",
	"belgie",
	"delivery_dutch",
	"postnl_customer",
	"italy"
]), e.string()]), Gv = e.union([e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6"
]), e.string()]), Kv = e.union([Wv, Gv]).nullable(), qv = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4)
]).register(e.globalRegistry, { description: "The position of the label on the paper." }), Jv = e.union([qv, e.string()]), Yv = e.string().nullable(), Xv = e.coerce.bigint().gte(BigInt(1)).lte(BigInt(0x8000000000000000)), Zv = e.union([Xv, e.string()]), Qv = e.union([
	wm,
	e.array(wm),
	e.string()
]), $v = e.int().gte(1).lte(2147483647), ey = e.union([
	$v,
	e.array($v),
	e.string()
]), ty = e.int().gte(1).lte(1e4).register(e.globalRegistry, { description: "Specify the number of resources returned per page, used for paginated results." }), ny = e.union([e.enum([
	"amount",
	"created",
	"created_by",
	"currency",
	"drop_off_point",
	"hidden",
	"id",
	"mark_delivered",
	"modified",
	"modified_by",
	"order_shipment_identifier",
	"parent_id",
	"recipient",
	"reference_identifier",
	"sender",
	"shipment_type",
	"shop_id",
	"status",
	"transaction_status"
]), e.string()]), ry = e.union([
	km,
	e.array(km),
	e.string()
]), iy = e.string(), ay = e.array(e.union([e.email(), e.string()])), oy = e.object({
	cc: e.string(),
	postal_code: e.string(),
	city: e.string(),
	street: e.string(),
	street_additional_info: e.string().nullish(),
	number: e.string().optional(),
	number_suffix: e.string().optional(),
	box_number: e.string().optional(),
	region: e.string().optional(),
	person: e.string(),
	company: e.string().optional(),
	phone: e.string().optional(),
	email: e.union([e.email(), e.string()]).nullish()
}), sy = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(8),
	e.literal(16)
]), cy = e.object({
	postal_code: e.string().optional(),
	location_name: e.string().optional(),
	city: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	box_number: e.string().optional(),
	region: e.string().optional(),
	state: e.string().optional(),
	cc: e.string().optional(),
	location_code: e.string().optional(),
	location_type: sy.optional(),
	retail_network_id: e.string().optional()
}).nullable(), ly = e.object({ data: e.object({
	user_agent: e.string().optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		contract_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string()]).optional(),
		recipient: e.object({
			cc: e.string(),
			region: e.string().optional(),
			state: e.string().optional(),
			postal_code: e.string(),
			city: e.string(),
			street: e.string(),
			street_additional_info: e.string().optional(),
			number: e.string().optional(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			area: e.string().optional(),
			person: e.string(),
			company: e.string().optional(),
			email: e.union([e.email(), e.string()]).optional(),
			secondary_emails: ay.optional(),
			phone: e.string().optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}).optional(),
		sender: oy.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: H.and(e.unknown()),
		customs_declaration: U.optional(),
		carrier: W,
		pickup: cy.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		secondary_shipments: e.array(e.object({
			account_id: e.int().optional(),
			shop_id: e.int().optional(),
			reference_identifier: e.union([e.int(), e.string()]).optional(),
			recipient: e.object({
				cc: e.string().optional(),
				region: e.string().optional(),
				state: e.string().optional(),
				postal_code: e.string().optional(),
				city: e.string().optional(),
				street: e.string().optional(),
				street_additional_info: e.string().optional(),
				number: e.string().optional(),
				number_suffix: e.string().optional(),
				box_number: e.string().optional(),
				area: e.string().optional(),
				person: e.string().optional(),
				company: e.string().optional(),
				email: e.union([e.email(), e.string()]).optional(),
				secondary_emails: ay.optional(),
				phone: e.string().optional(),
				eori_number: e.string().nullish(),
				vat_number: e.string().nullish()
			}).optional(),
			recipients: e.array(e.number()).min(1).optional(),
			physical_properties: e.object({
				weight: e.int().gte(0).lte(999999999),
				height: e.int().optional(),
				width: e.int().optional(),
				length: e.int().optional(),
				volume: e.int().optional()
			}).optional(),
			options: H.optional(),
			customs_declaration: U.optional(),
			carrier: W.optional(),
			pickup: cy.optional(),
			drop_off_point: e.object({
				postal_code: e.string(),
				location_name: e.string(),
				city: e.string(),
				street: e.string(),
				number: e.string(),
				number_suffix: e.string().optional(),
				box_number: e.string().optional(),
				region: e.string().optional(),
				state: e.string().optional(),
				cc: e.string().optional(),
				location_code: e.string(),
				retail_network_id: e.string().optional()
			}).nullish(),
			note: e.string().optional(),
			status: e.union([
				e.literal(1),
				e.literal(2),
				e.literal(3),
				e.literal(4),
				e.literal(5),
				e.literal(6),
				e.literal(7),
				e.literal(8)
			]).optional(),
			delivered: e.literal(0).optional(),
			general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
			hidden: e.union([e.literal(0), e.literal(1)]).optional(),
			shipped_items: e.array(e.object({
				order_line_identifier: e.string(),
				quantity: e.int().gte(1)
			})).min(0).optional()
		})).min(1).optional(),
		collection_contact: e.object({
			cc: e.string(),
			city: e.string(),
			company: e.string(),
			email: e.email(),
			first_name: e.string().optional(),
			gender: e.union([e.enum(["mr", "mrs"]), e.string()]).optional(),
			last_name: e.string(),
			number: e.union([e.string(), e.int()]),
			number_suffix: e.string().nullish(),
			phone: e.string(),
			postal_code: e.string(),
			street: e.string(),
			street_additional_info: e.string().nullish()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	}))
}) });
e.object({ data: e.object({
	user_agent: e.string().optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string()]).optional(),
		recipient: e.object({
			cc: e.string(),
			region: e.string().optional(),
			state: e.string().optional(),
			postal_code: e.string().optional(),
			city: e.string(),
			street: e.string(),
			street_additional_info: e.string().optional(),
			number: e.string().optional(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			area: e.string().optional(),
			person: e.string(),
			company: e.string().optional(),
			email: e.union([e.email(), e.string()]).optional(),
			secondary_emails: ay.optional(),
			phone: e.string().optional()
		}),
		sender: oy.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: H.and(e.unknown()),
		customs_declaration: U.optional(),
		carrier: W,
		pickup: cy.optional(),
		"multi-colli": e.object({ amount: e.int() }).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional()
	}))
}) });
var uy = e.object({ package_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(6)
]).optional() });
e.literal(1).register(e.globalRegistry, { description: "Regular package." }), e.literal(2).register(e.globalRegistry, { description: "Shipment that fits through a mailbox slot." }), e.literal(6);
var dy = e.object({
	age_check: B.optional(),
	cooled_delivery: B.optional(),
	drop_off_at_postal_point: B.optional(),
	extra_assurance: B.optional(),
	hide_sender: B.optional(),
	large_format: B.optional(),
	only_recipient: B.optional(),
	receipt_code: B.optional(),
	return: B.optional(),
	same_day_delivery: B.optional(),
	saturday_delivery: B.optional(),
	signature: B.optional()
}), fy = e.object({ options: uy.and(jm).and(dy).and(Lm).and(e.object({
	contribution: V.and(e.object({ amount: e.unknown().optional() })).optional(),
	printerless_return: B.optional()
})).optional() }), py = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(14),
	e.literal(15),
	e.literal(18)
]);
e.object({ data: e.object({ return_shipments: e.array(fy.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	parent: e.int(),
	reference_identifier: e.union([e.int(), e.string()]).optional(),
	carrier: py,
	email: e.string(),
	name: e.string(),
	sender: e.object({
		cc: e.string(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: U.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).optional() }) }), e.object({ data: e.object({ return_shipments: e.array(fy.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	carrier: py,
	email: e.string().optional(),
	name: e.string().optional(),
	cc: e.string().optional(),
	sender: e.object({
		cc: e.string(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: U.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).optional() }) });
var my = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string()]).optional(),
	carrier: W,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string(),
		region: e.string().optional(),
		state: e.string().optional(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().nullish(),
		number_suffix: e.string().nullish(),
		box_number: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).optional(),
		secondary_emails: ay.optional(),
		phone: e.string().optional(),
		eori_number: e.string().nullish(),
		vat_number: e.string().nullish()
	}).optional(),
	sender: oy.optional(),
	options: H.and(e.unknown()),
	customs_declaration: U.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: cy.optional(),
	drop_off_point: e.object({
		postal_code: e.string(),
		location_name: e.string(),
		city: e.string(),
		street: e.string(),
		number: e.string(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		state: e.string().optional(),
		cc: e.string().optional(),
		location_code: e.string(),
		retail_network_id: e.string().optional()
	}).nullish(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	multi_collo_main_shipment_id: e.int().nullish(),
	secondary_shipments: e.array(e.object({
		id: e.int().optional(),
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string()]).optional(),
		recipient: e.object({
			cc: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			postal_code: e.string().optional(),
			city: e.string().optional(),
			street: e.string().optional(),
			street_additional_info: e.string().optional(),
			number: e.string().nullish(),
			number_suffix: e.string().nullish(),
			box_number: e.string().optional(),
			area: e.string().optional(),
			person: e.string().optional(),
			company: e.string().optional(),
			email: e.union([e.email(), e.string()]).optional(),
			secondary_emails: ay.optional(),
			phone: e.string().optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}).optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: H.optional(),
		customs_declaration: U.optional(),
		carrier: W.optional(),
		pickup: cy.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.union([e.literal(0), e.literal(1)]).optional(),
		general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
		multi_collo_main_shipment_id: e.int().nullish(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	})).min(1).optional(),
	collection_contact: e.object({
		cc: e.string(),
		city: e.string(),
		company: e.string().nullish(),
		email: e.email().optional(),
		first_name: e.string().optional(),
		gender: e.union([e.enum(["mr", "mrs"]), e.string()]).optional(),
		last_name: e.string().optional(),
		number: e.union([e.string(), e.int()]),
		number_suffix: e.string().nullish(),
		phone: e.string(),
		postal_code: e.string(),
		street: e.string(),
		street_additional_info: e.string().nullish()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional(),
	shipped_items: e.array(e.object({
		order_line_identifier: e.string(),
		quantity: e.int().gte(1)
	})).min(0).optional()
})).optional() }) });
e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string()]).optional(),
	carrier: W,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string(),
		region: e.string().optional(),
		state: e.string().optional(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().nullish(),
		number_suffix: e.string().nullish(),
		box_number: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).optional(),
		secondary_emails: ay.optional(),
		phone: e.string().optional()
	}).optional(),
	sender: oy.optional(),
	options: H.and(e.unknown()),
	customs_declaration: U.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: cy.optional(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional()
})).optional() }) });
var hy = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier: N_.optional(),
	packageType: F_.optional(),
	physicalProperties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Insurance option" }).optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "No tracking option (inverse of tracked)" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		printReturnLabelAtDropOff: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Print return label at drop off package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.union([e.enum([
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]), e.string()]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location: e.object({ type: e.union([e.enum(["RETAIL", "LOCKER"]), e.string()]).register(e.globalRegistry, { description: "Type of pickup location. RETAIL for shops/postal points, LOCKER for automated parcel lockers." }).optional() }).register(e.globalRegistry, { description: "Pickup location details." }).optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
});
e.object({ data: e.object({ capabilities: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier_id: q_.optional(),
	package_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6)
	]).optional(),
	physical_properties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		cooled_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cooled delivery option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		printerless_return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Printerless return delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Tracking option" }).optional(),
		insurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Insurance option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location_type: e.union([e.enum(["retail", "locker"]), e.string()]).register(e.globalRegistry, { description: "Type of pickup location. retail for shops/postal points, locker for automated parcel lockers." }).optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
})) }) });
var gy = e.object({ carrier: e.union([e.enum([
	"BRT",
	"DHL_EUROPLUS",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"DHL_FOR_YOU",
	"INPOST",
	"POSTNL"
]), e.string()]).optional() });
e.object({ data: e.object({ carrier_id: e.union([
	e.literal(1),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(15),
	e.literal(17)
]).optional() }).optional() });
var _y = e.object({
	city: e.string().register(e.globalRegistry, { description: "The city of the address." }),
	countryCode: e.string().register(e.globalRegistry, { description: "The country code (ISO 3166-1 alpha-2) of the address." }),
	street: e.string().register(e.globalRegistry, { description: "The street of the address." }),
	additionalInformation: e.string().register(e.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: e.string().register(e.globalRegistry, { description: "The box number of the address. Only applicable for `countryCode`=`BE`." }).optional(),
	houseNumber: e.string().register(e.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: e.string().register(e.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: e.string().register(e.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: e.string().register(e.globalRegistry, { description: "The region of the address." }).optional(),
	state: e.string().register(e.globalRegistry, { description: "The state of the address." }).optional()
}), vy = e.object({
	name: e.string().register(e.globalRegistry, { description: "The name of the pickup location." }),
	code: e.string().register(e.globalRegistry, { description: "The location code of the pickup location." }).optional(),
	type: e.union([e.enum([
		"CLICK_COLLECT",
		"PARCEL_LOCKER",
		"PARCEL_POINT",
		"POST_OFFICE",
		"POST_POINT"
	]), e.string()]).register(e.globalRegistry, { description: "The bpost pickup location type." }).optional()
}), yy = e.object({
	address: _y.optional(),
	location: vy.optional(),
	retailNetworkId: e.union([e.enum(["PNPNL-01", "PNPBE-01"]), e.string()]).register(e.globalRegistry, { description: "PostNL Retail network ID." }).optional()
}).register(e.globalRegistry, { description: "Pickup location data." }), by = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: yy.optional(),
	carrier: N_,
	packageType: F_,
	physicalProperties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: e.object({ insuredAmount: V }).register(e.globalRegistry, { description: "Insurance option" }).optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "No tracking option (inverse of tracked)" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.object({ dueAmount: V }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.union([e.enum([
		"EARLY_MORNING_DELIVERY",
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]), e.string()]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
});
e.object({ data: e.object({ rates: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional().default(!0)
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: Bm.optional(),
	carrier_id: q_,
	package_type: Nm,
	physical_properties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.object({ due_amount: V }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		cooled_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cooled delivery option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Tracking option" }).optional(),
		insurance: e.object({ insured_amount: V }).register(e.globalRegistry, { description: "Insurance option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
})) }) });
var xy = e.union([e.object({
	shopId: e.int(),
	packageType: e.union([e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]), e.string()]),
	countryCode: e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }),
	shipmentDirection: e.union([e.enum(["OUTBOUND"]), e.string()])
}), e.object({
	shopId: e.int(),
	packageType: e.null().optional(),
	countryCode: e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }).optional(),
	shipmentDirection: e.union([e.enum(["INBOUND"]), e.string()])
})]), Sy = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}), Cy = e.object({ data: e.object({ webhook_subscriptions: e.array(Sy).optional() }) }), wy = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string()
});
e.object({ data: e.object({ webhook_subscriptions: e.array(wy).optional() }) });
var Ty = e.object({
	body: e.string(),
	subject: e.string()
});
e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }), e.string().nullable(), e.string().nullable(), e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }), $.nullable(), e.int().gte(-1).lte(14).nullable(), e.int().gte(0).nullable(), e.int().gte(0).lte(14).nullable(), e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }), $.nullable(), e.string().nullable(), e.boolean(), e.string().register(e.globalRegistry, { description: "Filter by webhook event type." }), e.boolean(), e.int().nullable(), e.boolean(), e.string().nullable(), $.nullable(), e.int().register(e.globalRegistry, { description: "The ID of the notification group." }), e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }), e.int().register(e.globalRegistry, { description: "The ID of the notification template." }), e.string().nullable(), e.string().nullable(), e.string().nullable(), e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }), e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }), e.union([e.enum(["asc", "desc"]), e.string()]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }), e.string().nullable();
var Ey = ly, Dy = my, Oy = hy, ky = gy, Ay = by, jy = xy, My = Cy, Ny = Ty;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional()
});
var Py = e.object({
	title: e.string().optional(),
	status: e.string()
}).register(e.globalRegistry, { description: "Status is OK" });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: Yv.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: Kv.optional(),
		shop_id: ey.optional(),
		carrier: Dv.optional(),
		delivery_date: Mv.optional(),
		delivery_time: Nv.optional(),
		cutoff_time: Av.optional(),
		dropoff_days: Fv.optional(),
		monday_delivery: $.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: Lv.optional(),
		exclude_parcel_lockers: $.nullish(),
		latitude: zv.optional(),
		longitude: Bv.optional()
	}).optional()
});
var Fy = Ig;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		postal_code: Yv.optional(),
		number: e.string().nullish(),
		distance: e.int().gte(0).nullish(),
		cc: e.string().nullish(),
		limit: e.int().nullish(),
		carrier_id: Tv.optional(),
		shop_id: ey.optional(),
		reference: e.string().nullish(),
		location_name: e.string().nullish(),
		external_identifier: e.string().nullish(),
		city: e.string().nullish(),
		cut_off_time: Av.optional(),
		min_cut_off_time: Av.optional(),
		max_cut_off_time: Av.optional(),
		latitude: zv.optional(),
		longitude: Bv.optional(),
		exclude_parcel_lockers: $.nullish()
	}).optional()
});
var Iy = l_;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: Yv.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: Kv.optional(),
		shop_id: ey.optional(),
		carrier: Dv.optional(),
		delivery_date: Mv.optional(),
		delivery_time: Nv.optional(),
		cutoff_time: Av.optional(),
		dropoff_days: Fv.optional(),
		monday_delivery: $.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: Lv.optional(),
		exclude_parcel_lockers: $.nullish(),
		latitude: zv.optional(),
		longitude: Bv.optional()
	}).optional()
});
var Ly = v_;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional()
});
var Ry = $g;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: wv.optional(),
		carrier_id: Tv.optional(),
		created: e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }).optional(),
		delayed: $.nullish(),
		delivered: jv.optional(),
		dropoff_today: e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }).optional(),
		filter_hidden_shops: e.boolean().optional(),
		hidden: jv.optional(),
		link_consumer_portal: e.boolean().optional(),
		order: Vv.optional(),
		package_type: Hv.optional(),
		page: Uv.optional(),
		q: e.string().nullish(),
		reference_identifier: e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }).optional(),
		region: e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }).optional(),
		shipment_type: Qv.optional(),
		shop_id: ey.optional(),
		size: ty.optional(),
		sort: ny.optional(),
		status: ry.optional(),
		transaction_status: th.optional()
	}).optional()
});
var zy = S_;
e.object({
	body: Ey,
	path: e.never().optional(),
	query: e.object({
		format: Rv.optional(),
		positions: Jv.optional(),
		collect_date: Ov.optional(),
		delivery_options_identifier: Pv.optional()
	}).optional()
});
var By = y_;
e.object({
	body: Dy,
	path: e.never().optional(),
	query: e.never().optional()
});
var Vy = e.union([Cg, e.void().register(e.globalRegistry, { description: "Shipment update was successful." })]);
e.object({
	body: e.never().optional(),
	path: e.object({ ids: Zv }),
	query: e.never().optional()
});
var Hy = e.void().register(e.globalRegistry, { description: "Shipment deletion was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ ids: Zv }),
	query: e.object({ link_consumer_portal: e.boolean().optional() }).optional()
});
var Uy = S_;
e.object({
	body: Oy,
	path: e.never().optional(),
	query: e.never().optional()
});
var Wy = K_;
e.object({
	body: ky,
	path: e.never().optional(),
	query: e.never().optional()
});
var Gy = rv;
e.object({
	body: Ay,
	path: e.never().optional(),
	query: e.never().optional()
});
var Ky = e.union([uv, e.void().register(e.globalRegistry, { description: "This response is given when the request is successful and the response is empty." })]);
e.object({
	body: e.never().optional(),
	path: e.object({ ids: Zv }),
	query: e.object({
		format: Rv.optional(),
		positions: Jv.optional(),
		collect_date: Ov.optional(),
		delivery_options_identifier: Pv.optional()
	}).optional()
});
var qy = e.union([e.void().register(e.globalRegistry, { description: "Direct Printing Response" }), Tg]);
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: wv.optional(),
		country_code: kv.optional(),
		external_identifier: wv.optional(),
		extra_info: iy.optional(),
		postal_code: Yv.optional(),
		sort: e.union([e.enum(["asc", "desc"]), e.string()]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional()
	}).optional()
});
var Jy = M_;
e.object({
	body: e.never().optional(),
	path: e.object({ ids: Zv }),
	query: e.object({
		sort: e.union([e.enum(["asc", "desc"]), e.string()]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional(),
		extra_info: iy.optional()
	}).optional()
});
var Yy = M_;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ shopId: ey.optional() }).optional()
});
var Xy = gv;
e.object({
	body: jy,
	path: e.never().optional(),
	query: e.never().optional()
});
var Zy = gv;
e.object({
	body: e.never().optional(),
	path: e.object({ ids: e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }) }),
	query: e.never().optional()
});
var Qy = e.void().register(e.globalRegistry, { description: "Notification group deletion was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional()
});
var $y = yv;
e.object({
	body: Ny,
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional()
});
var eb = e.void().register(e.globalRegistry, { description: "Notification template update was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional()
});
var tb = e.void().register(e.globalRegistry, { description: "Disabling notification templates was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional()
});
var nb = e.void().register(e.globalRegistry, { description: "Enabling notification templates was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional()
});
var rb = e.void().register(e.globalRegistry, { description: "Disabling notification template was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional()
});
var ib = e.void().register(e.globalRegistry, { description: "Enabling notification template was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional()
});
var ab = e.void().register(e.globalRegistry, { description: "Test notification was successfully send." });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ hook: e.string().register(e.globalRegistry, { description: "Filter by webhook event type." }).optional() }).optional()
});
var ob = xv;
e.object({
	body: My,
	path: e.never().optional(),
	query: e.never().optional()
});
var sb = Cv;
e.object({
	body: e.never().optional(),
	path: e.object({ ids: Zv }),
	query: e.never().optional()
});
var cb = e.void().register(e.globalRegistry, { description: "Webhook subscription deletion was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ ids: Zv }),
	query: e.never().optional()
});
var lb = xv, ub = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await up.parseAsync(e),
	responseValidator: async (e) => await Py.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/",
	...e
}), db = (e) => (e?.client ?? f).get({
	requestValidator: async (e) => await fp.parseAsync(e),
	responseValidator: async (e) => await Fy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/delivery_options",
	...e
}), fb = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await mp.parseAsync(e),
	responseValidator: async (e) => await Iy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/drop_off_points",
	...e
}), pb = (e) => (e?.client ?? f).get({
	requestValidator: async (e) => await gp.parseAsync(e),
	responseValidator: async (e) => await Ly.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/pickup_locations",
	...e
}), mb = (e) => (e.client ?? f).post({
	requestValidator: async (e) => await vp.parseAsync(e),
	responseValidator: async (e) => await Ry.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/return_shipments",
	...e
}), hb = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await bp.parseAsync(e),
	responseValidator: async (e) => await zy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments",
	...e
}), gb = (e) => (e.client ?? f).post({
	requestValidator: async (e) => await Sp.parseAsync(e),
	responseValidator: async (e) => await By.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments",
	...e,
	headers: {
		"Content-Type": "application/vnd.shipment+json;version=1.1",
		...e.headers
	}
}), _b = (e) => (e.client ?? f).put({
	requestValidator: async (e) => await wp.parseAsync(e),
	responseValidator: async (e) => await Vy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments",
	...e,
	headers: {
		"Content-Type": "application/vnd.shipment+json;version=1.1",
		...e.headers
	}
}), vb = (e) => (e.client ?? f).delete({
	requestValidator: async (e) => await Ep.parseAsync(e),
	responseValidator: async (e) => await Hy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/{ids}",
	...e
}), yb = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await Op.parseAsync(e),
	responseValidator: async (e) => await Uy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/{ids}",
	...e
}), bb = (e) => (e.client ?? f).post({
	requestValidator: async (e) => await Ap.parseAsync(e),
	responseValidator: async (e) => await Wy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/capabilities",
	...e,
	headers: {
		"Content-Type": "application/json;charset=utf-8;version=2.0",
		...e.headers
	}
}), xb = (e) => (e.client ?? f).post({
	requestValidator: async (e) => await Mp.parseAsync(e),
	responseValidator: async (e) => await Gy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/capabilities/contract-definitions",
	...e,
	headers: {
		"Content-Type": "application/json;charset=utf-8;version=2.0",
		...e.headers
	}
}), Sb = (e) => (e.client ?? f).post({
	requestValidator: async (e) => await Pp.parseAsync(e),
	responseValidator: async (e) => await Ky.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/rates",
	...e,
	headers: {
		"Content-Type": "application/json;charset=utf-8;version=2.0",
		...e.headers
	}
}), Cb = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await Ip.parseAsync(e),
	responseValidator: async (e) => await qy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipment_labels/{ids}",
	...e
}), wb = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await Rp.parseAsync(e),
	responseValidator: async (e) => await Jy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/tracktraces",
	...e
}), Tb = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await Bp.parseAsync(e),
	responseValidator: async (e) => await Yy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/tracktraces/{ids}",
	...e
}), Eb = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await Hp.parseAsync(e),
	responseValidator: async (e) => await Xy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups",
	...e
}), Db = (e) => (e.client ?? f).post({
	requestValidator: async (e) => await Wp.parseAsync(e),
	responseValidator: async (e) => await Zy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ob = (e) => (e.client ?? f).delete({
	requestValidator: async (e) => await Kp.parseAsync(e),
	responseValidator: async (e) => await Qy.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{ids}",
	...e
}), kb = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await Jp.parseAsync(e),
	responseValidator: async (e) => await $y.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates",
	...e
}), Ab = (e) => (e.client ?? f).put({
	requestValidator: async (e) => await Xp.parseAsync(e),
	responseValidator: async (e) => await eb.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), jb = (e) => (e.client ?? f).put({
	requestValidator: async (e) => await Qp.parseAsync(e),
	responseValidator: async (e) => await tb.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/disable",
	...e
}), Mb = (e) => (e.client ?? f).put({
	requestValidator: async (e) => await em.parseAsync(e),
	responseValidator: async (e) => await nb.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/enable",
	...e
}), Nb = (e) => (e.client ?? f).put({
	requestValidator: async (e) => await nm.parseAsync(e),
	responseValidator: async (e) => await rb.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}/disable",
	...e
}), Pb = (e) => (e.client ?? f).put({
	requestValidator: async (e) => await im.parseAsync(e),
	responseValidator: async (e) => await ib.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}/enable",
	...e
}), Fb = (e) => (e.client ?? f).post({
	requestValidator: async (e) => await om.parseAsync(e),
	responseValidator: async (e) => await ab.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}/test",
	...e
}), Ib = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await cm.parseAsync(e),
	responseValidator: async (e) => await ob.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/webhook_subscriptions",
	...e
}), Lb = (e) => (e.client ?? f).post({
	requestValidator: async (e) => await um.parseAsync(e),
	responseValidator: async (e) => await sb.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/webhook_subscriptions",
	...e,
	headers: {
		"Content-Type": "application/json;charset=utf-8;version=1.1",
		...e.headers
	}
}), Rb = (e) => (e.client ?? f).delete({
	requestValidator: async (e) => await fm.parseAsync(e),
	responseValidator: async (e) => await cb.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}],
	url: "/webhook_subscriptions/{ids}",
	...e
}), zb = (e) => (e.client ?? f).get({
	requestValidator: async (e) => await mm.parseAsync(e),
	responseValidator: async (e) => await lb.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/webhook_subscriptions/{ids}",
	...e
}), Bb = {
	ACCESS_DENIED: 3e3,
	PERMISSION_DENIED: 3001,
	SESSION_TOKEN_NOT_FOUND: 3002,
	LAST_LOGIN_ATTEMPT_FAILED: 3003,
	MAX_LOGIN_ATTEMPTS_REACHED: 3004,
	SESSION_TOKEN_INVALIDATED: 3005,
	INVALID_JWT_TOKEN: 3006,
	USER_NOT_FOUND_IN_AUTHCONTEXT: 3007
}, Vb = { 404: 404 }, Hb = {
	STANDARD: 1,
	RETURN: 2,
	MULTI_COLLO: 3,
	LABEL_PACKAGE: 4,
	RETURN_ERS: 5,
	RETURN_SPECIAL: 6,
	EXPRESS: 7,
	FULFILMENT: 8
}, Ub = {
	PENDING_CONCEPT: 1,
	PENDING_REGISTERED: 2,
	ENROUTE_HANDED_TO_CARRIER: 3,
	ENROUTE_SORTING: 4,
	ENROUTE_DISTRIBUTION: 5,
	DELIVERED_AT_CUSTOMS: 6,
	DELIVERED: 7,
	IN_PICKUP_LOCATION: 8,
	PICKED_UP: 9,
	RETURN_SHIPMENT_DELIVERED: 10,
	RETURN_SHIPMENT_IN_PICKUP_LOCATION: 11,
	PRINTED_UNPAID_LABEL: 12,
	CREDIT: 13,
	PRINTED_STAMP: 14,
	PRINTED_EXTERNAL_SHIPMENT: 15,
	EXPIRED: 16,
	CANCELLED: 17,
	PRINTED_UNTRACKED_SHIPMENT: 18,
	DELIVERED_AT_AGREED_LOCATION: 19,
	INACTIVE: 98,
	DELETED: 99,
	CREDIT_REJECTED: 100,
	CREDIT_APPROVED: 101,
	LEGACY_PENDING_CONCEPT: 30,
	LEGACY_PENDING_REGISTERED: 31,
	LEGACY_ENROUTE_HANDED_TO_CARRIER: 32,
	LEGACY_ENROUTE_SORTING: 33,
	LEGACY_ENROUTE_DISTRIBUTION: 34,
	LEGACY_DELIVERED_AT_CUSTOMS: 35,
	LEGACY_DELIVERED: 36,
	LEGACY_IN_PICKUP_LOCATION: 37,
	LEGACY_PICKED_UP: 38
}, Wb = {
	FALSE: 0,
	TRUE: 1
}, Gb = {
	PACKAGE: 1,
	MAILBOX: 2,
	UNFRANKED: 3,
	DIGITAL_STAMP: 4,
	PALLET: 5,
	SMALL_PACKAGE: 6,
	ENVELOPE: 7
}, Kb = {
	COMMERCIAL_GOODS: 1,
	COMMERCIAL_SAMPLE: 2,
	DOCUMENTS: 3,
	GIFT: 4,
	RETURNED_GOODS: 5
}, qb = {
	NULL: null,
	PENDING: "pending",
	UNPAID: "unpaid",
	PAID: "paid"
}, Jb = {
	FACEBOOK: "Facebook",
	GOOGLE: "Google",
	FLESPAKKET_NL: "Flespakket.nl",
	AMAZON: "Amazon",
	BOL_COM: "Bol.com",
	MY_PARCEL_NL: "MyParcel.nl",
	WIX: "Wix",
	ECWID: "Ecwid",
	EXACT_ONLINE_DE: "Exact Online DE",
	EXACT_ONLINE_NL: "Exact Online NL",
	ETSY: "Etsy"
}, Yb = {
	NULL: null,
	PENDING: "pending",
	UNPAID: "unpaid",
	PAID: "paid"
}, Xb = {
	POSTNL: 1,
	BPOST: 2,
	CHEAP_CARGO: 3,
	DPD: 4,
	INSTABOX: 5,
	DHL_CHEAP_CARGO: 6,
	BOL: 7,
	UPS: 8,
	DHL_FOR_YOU: 9,
	DHL_PARCEL_CONNECT: 10,
	DHL_EUROPLUS: 11,
	UPS_STANDARD: 12,
	UPS_EXPRESS_SAVER: 13,
	GLS: 14,
	BRT: 15,
	TRUNKRS: 16,
	INPOST: 17,
	POSTE_ITALIANE: 18,
	SPRING: 19
}, Zb = {
	MYPARCEL: 1,
	FLESPAKKET: 2,
	BELGIE: 3,
	DELIVERY_DUTCH: 4,
	POSTNL_CUSTOMER: 5,
	ITALY: 6
}, Qb = {
	"": "",
	EUR: "EUR"
}, $b = { 400: 400 }, ex = {
	NONE: 0,
	OFFSET: 1,
	ABBREVIATION: 2,
	IDENTIFIER: 3
}, tx = {
	MORNING: "morning",
	STANDARD: "standard",
	EVENING: "evening",
	SAME_DAY: "same_day",
	EXPRESS: "express",
	EARLY_MORNING: "early_morning"
}, nx = {
	PACKAGE: "package",
	MAILBOX: "mailbox",
	UNFRANKED: "unfranked",
	DIGITAL_STAMP: "digital_stamp",
	PALLET: "pallet",
	SMALL_PACKAGE: "small_package",
	ENVELOPE: "envelope"
}, rx = {
	MORNING: 1,
	STANDARD: 2,
	EVENING: 3,
	PICKUP: 4,
	SAME_DAY: 6,
	EXPRESS: 7,
	EARLY_MORNING: 8
}, ix = { 406: 406 }, ax = {
	SUNDAY: 0,
	MONDAY: 1,
	TUESDAY: 2,
	WEDNESDAY: 3,
	THURSDAY: 4,
	FRIDAY: 5,
	SATURDAY: 6
}, ox = {
	MONDAY: 1,
	TUESDAY: 2,
	WEDNESDAY: 3,
	THURSDAY: 4,
	FRIDAY: 5,
	SATURDAY: 6,
	SUNDAY: 7
}, sx = {
	RETAIL: "retail",
	LOCKER: "locker"
}, cx = { 415: 415 }, lx = { 401: 401 }, ux = {
	REGISTERED: "registered",
	HANDED_TO_CARRIER: "handed_to_carrier",
	SORTING: "sorting",
	DISTRIBUTION: "distribution",
	DELIVERED: "delivered",
	NULL: null
}, dx = {
	ESTIMATED: "estimated",
	EXPECTED: "expected",
	NULL: null
}, fx = {
	BPOST: "BPOST",
	BRT: "BRT",
	CHEAP_CARGO: "CHEAP_CARGO",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DPD: "DPD",
	GLS: "GLS",
	INPOST: "INPOST",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	POSTNL: "POSTNL",
	SPRING: "SPRING",
	TRUNKRS: "TRUNKRS",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	UPS_STANDARD: "UPS_STANDARD"
}, px = {
	PACKAGE: "PACKAGE",
	MAILBOX: "MAILBOX",
	UNFRANKED: "UNFRANKED",
	DIGITAL_STAMP: "DIGITAL_STAMP",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	ENVELOPE: "ENVELOPE"
}, mx = {
	MORNING: "MORNING_DELIVERY",
	STANDARD: "STANDARD_DELIVERY",
	EVENING: "EVENING_DELIVERY",
	PICKUP: "PICKUP_DELIVERY",
	SAME_DAY: "SAME_DAY_DELIVERY",
	EXPRESS: "EXPRESS_DELIVERY",
	EARLY_MORNING: "EARLY_MORNING_DELIVERY"
}, hx = {
	B2B: "B2B",
	B2C: "B2C"
}, gx = {
	POSTNL: 1,
	BPOST: 2,
	CHEAP_CARGO: 3,
	DPD: 4,
	DHL_FOR_YOU: 9,
	DHL_PARCEL_CONNECT: 10,
	DHL_EUROPLUS: 11,
	UPS_STANDARD: 12,
	UPS_EXPRESS_SAVER: 13,
	GLS: 14,
	BRT: 15,
	TRUNKRS: 16,
	INPOST: 17,
	POSTE_ITALIANE: 18,
	SPRING: 19
}, _x = {
	LABEL_DOWNLOAD: "LABEL_DOWNLOAD",
	FIRST_SCAN: "FIRST_SCAN",
	RETURN: "RETURN"
}, vx = {
	POSTNL: "1",
	BPOST: "2",
	CHEAP_CARGO: "3",
	DPD: "4",
	INSTABOX: "5",
	DHL_CHEAP_CARGO: "6",
	BOL: "7",
	UPS: "8",
	DHL_FOR_YOU: "9",
	DHL_PARCEL_CONNECT: "10",
	DHL_EUROPLUS: "11",
	UPS_STANDARD: "12",
	UPS_EXPRESS_SAVER: "13",
	GLS: "14",
	BRT: "15",
	TRUNKRS: "16",
	INPOST: "17",
	POSTE_ITALIANE: "18",
	SPRING: "19"
}, yx = {
	POSTNL: "postnl",
	BPOST: "bpost",
	CHEAP_CARGO: "cheapcargo",
	DPD: "dpd",
	INSTABOX: "instabox",
	DHL_CHEAP_CARGO: "dhl",
	BOL: "bol.com",
	UPS: "ups",
	DHL_FOR_YOU: "dhlforyou",
	DHL_PARCEL_CONNECT: "dhlparcelconnect",
	DHL_EUROPLUS: "dhleuroplus",
	UPS_STANDARD: "upsstandard",
	UPS_EXPRESS_SAVER: "upsexpresssaver",
	GLS: "gls",
	BRT: "brt",
	TRUNKRS: "trunkrs",
	INPOST: "inpost",
	POSTE_ITALIANE: "posteitaliane",
	SPRING: "spring"
}, bx = {
	FALSE: !1,
	TRUE: !0,
	0: 0,
	1: 1,
	2: "0",
	12: "1",
	FALSE2: "false",
	TRUE2: "true",
	OFF: "off",
	ON: "on",
	NO: "no",
	YES: "yes",
	"": "",
	NULL: null
}, xx = {
	MORNING: "1",
	STANDARD: "2",
	EVENING: "3",
	PICKUP: "4",
	SAME_DAY: "6",
	EXPRESS: "7",
	EARLY_MORNING: "8"
}, Sx = {
	A4: "A4",
	A6: "A6"
}, Cx = {
	ASC: "ASC",
	DESC: "DESC"
}, wx = {
	MYPARCEL: "myparcel",
	FLESPAKKET: "flespakket",
	BELGIE: "belgie",
	DELIVERY_DUTCH: "delivery_dutch",
	POSTNL_CUSTOMER: "postnl_customer",
	ITALY: "italy"
}, Tx = {
	MYPARCEL: "1",
	FLESPAKKET: "2",
	BELGIE: "3",
	DELIVERY_DUTCH: "4",
	POSTNL_CUSTOMER: "5",
	ITALY: "6"
}, Ex = {
	TOP_LEFT_QUADRANT: 1,
	TOP_RIGHT_QUADRANT: 2,
	BOTTOM_LEFT_QUADRANT: 3,
	BOTTOM_RIGHT_QUADRANT: 4
}, Dx = {
	AMOUNT: "amount",
	CREATED: "created",
	CREATED_BY: "created_by",
	CURRENCY: "currency",
	DROP_OFF_POINT: "drop_off_point",
	HIDDEN: "hidden",
	ID: "id",
	MARK_DELIVERED: "mark_delivered",
	MODIFIED: "modified",
	MODIFIED_BY: "modified_by",
	ORDER_SHIPMENT_IDENTIFIER: "order_shipment_identifier",
	PARENT_ID: "parent_id",
	RECIPIENT: "recipient",
	REFERENCE_IDENTIFIER: "reference_identifier",
	SENDER: "sender",
	SHIPMENT_TYPE: "shipment_type",
	SHOP_ID: "shop_id",
	STATUS: "status",
	TRANSACTION_STATUS: "transaction_status"
}, Ox = {
	UNKNOWN: 0,
	POST_OFFICE: 1,
	POST_POINT: 2,
	PARCEL_LOCKER: 4,
	CLICK_COLLECT: 8,
	PARCEL_POINT: 16
}, kx = { 1: 1 }, Ax = { 2: 2 }, jx = { 6: 6 }, Mx = {
	1: 1,
	2: 2,
	4: 4,
	9: 9,
	10: 10,
	11: 11,
	14: 14,
	15: 15,
	18: 18
}, Nx = {
	ASC: "asc",
	DESC: "desc"
}, Px = "https://api.myparcel.nl", Fx = "https://api.acceptance.myparcel.nl";
//#endregion
export { Rb as $, M as $a, Dd as $c, dn as $d, hn as $f, Sp as $i, si as $l, Bi as $m, xo as $n, om as $o, Xt as $p, kp as $r, wc as $s, Md as $t, me as $u, Xb as A, O as Aa, Uf as Ac, Ha as Ad, s as Af, Wn as Ah, Mf as Ai, Nl as Al, Qe as Am, yl as An, Id as Ao, br as Ap, tm as Ar, Qo as As, Ks as At, Ci as Au, Jb as B, D as Ba, Ju as Bc, Tt as Bd, sa as Bf, c as Bh, ip as Bi, Qf as Bl, Gt as Bm, Uu as Bn, Do as Bo, Te as Bp, fp as Br, nc as Bs, nd as Bt, ga as Bu, Gb as C, _u as Ca, ko as Cc, Mn as Cd, gr as Cf, _n as Ch, kf as Ci, Sl as Cl, nt as Cm, Cc as Cn, Kl as Co, wn as Cp, nm as Cr, ac as Cs, Lb as Ct, Fr as Cu, px as D, tu as Da, Hl as Dc, ue as Dd, r as Df, Zn as Dh, Ou as Di, Ol as Dl, Ze as Dm, vo as Dn, Go as Do, jn as Dp, df as Dr, $o as Ds, wo as Dt, Rr as Du, jx as E, nu as Ea, jo as Ec, pe as Ed, o as Ef, Kn as Eh, Wd as Ei, Ec as El, lt as Em, yo as En, Yo as Eo, An as Ep, uf as Er, Zo as Es, Fb as Et, ei as Eu, hx as F, E as Fa, Vu as Fc, kt as Fd, ia as Ff, lr as Fh, lc as Fi, qf as Fl, ot as Fm, tl as Fn, wd as Fo, Re as Fp, mf as Fr, Ps as Fs, Hs as Ft, yi as Fu, yx as G, Jl as Ga, sd as Gc, Qi as Gd, Xi as Gf, vr as Gh, jp as Gi, Vd as Gl, Ai as Gm, $u as Gn, Mo as Go, Ne as Gp, dp as Gr, Zs as Gs, id as Gt, Ia as Gu, Yb as H, ou as Ha, od as Hc, xt as Hd, Ki as Hf, mr as Hh, Mp as Hi, Gd as Hl, yr as Hm, I as Hn, $l as Ho, Pe as Hp, mp as Hr, Qs as Hs, To as Ht, we as Hu, sx as I, iu as Ia, N as Ic, Dt as Id, ra as If, ar as Ih, Pf as Ii, Jf as Il, vt as Im, cd as In, rs as Io, Ge as Ip, hf as Ir, Js as Is, Gs as It, mi as Iu, Dx as J, Au as Ja, pd as Jc, rn as Jd, cn as Jf, ki as Jh, Gp as Ji, Nu as Jl, Ni as Jm, qu as Jn, Hd as Jo, Ft as Jp, Jp as Jr, bs as Js, Nc as Jt, le as Ju, xx as K, ku as Ka, ld as Kc, Ue as Kd, ca as Kf, Va as Kh, sp as Ki, Iu as Kl, Mi as Km, td as Kn, eu as Ko, xe as Kp, Hp as Kr, js as Ks, Kd as Kt, ge as Ku, Kb as L, Wl as La, Wu as Lc, Et as Ld, Li as Lf, sr as Lh, Ff as Li, Yf as Ll, ne as Lm, F as Ln, Eo as Lo, Ke as Lp, $f as Lr, rc as Ls, Rs as Lt, gi as Lu, rx as M, lu as Ma, Ru as Mc, ee as Md, tr as Mf, ir as Mh, dc as Mi, Wf as Ml, Wt as Mm, il as Mn, ns as Mo, Yn as Mp, am as Mr, ps as Ms, Us as Mt, fi as Mu, mx as N, Xl as Na, Bu as Nc, bt as Nd, zn as Nf, or as Nh, uc as Ni, Gf as Nl, Ye as Nm, _l as Nn, hd as No, l as Np, nl as Nr, ec as Ns, Bs as Nt, vi as Nu, qb as O, cu as Oa, Vl as Oc, Ur as Od, gn as Of, $n as Oh, ju as Oi, kl as Ol, at as Om, _o as On, qo as Oo, ze as Op, ff as Or, es as Os, qs as Ot, wi as Ou, Wb as P, Ql as Pa, zu as Pc, be as Pd, Rn as Pf, cr as Ph, fc as Pi, Kf as Pl, $e as Pm, el as Pn, _ as Po, Mt as Pp, pf as Pr, ks as Ps, Vs as Pt, pi as Pu, vb as Q, xu as Qa, _d as Qc, pn as Qd, n as Qf, Ei as Qh, np as Qi, ro as Ql, Vi as Qm, Ml as Qn, Hf as Qo, Rt as Qp, Op as Qr, yc as Qs, Nd as Qt, wa as Qu, dx as R, au as Ra, Ku as Rc, Ct as Rd, Fi as Rf, ur as Rh, If as Ri, Xf as Rl, re as Rm, P as Rn, y as Ro, Vt as Rp, gf as Rr, _c as Rs, zs as Rt, di as Ru, Ex as S, k as Sa, Ao as Sc, ie as Sd, on as Sf, Tn as Sh, Of as Si, Tl as Sl, it as Sm, vc as Sn, Sd as So, Sn as Sp, $p as Sr, ds as Ss, mb as St, Zr as Su, Ax as T, uu as Ta, pc as Tc, fe as Td, a as Tf, Gn as Th, zd as Ti, Dl as Tl, gt as Tm, bo as Tn, Jo as To, Pn as Tp, lf as Tr, ts as Ts, _b as Tt, Pr as Tu, Ub as U, ql as Ua, ed as Uc, St as Ud, qi as Uf, pr as Uh, Np as Ui, tp as Ul, Dr as Um, Zu as Un, m as Uo, Fe as Up, hp as Ur, $s as Us, bc as Ut, ye as Uu, ux as V, w as Va, Yu as Vc, Ot as Vd, oa as Vf, fr as Vh, ap as Vi, ep as Vl, oe as Vm, ud as Vn, Jc as Vo, Me as Vp, pp as Vr, Ss as Vs, ls as Vt, Se as Vu, vx as W, su as Wa, Xu as Wc, We as Wd, Ji as Wf, _r as Wh, Ap as Wi, Ud as Wl, xr as Wm, Qu as Wn, h as Wo, je as Wp, up as Wr, Es as Ws, rd as Wt, ta as Wu, Nx as X, bu as Xa, Ed as Xc, Zi as Xd, Hn as Xf, Ti as Xh, Pp as Xi, Mu as Xl, Ii as Xm, Oc as Xn, Bf as Xo, ht as Xp, gp as Xr, p as Xs, jd as Xt, ve as Xu, nx as Y, Cu as Ya, md as Yc, $i as Yd, ln as Yf, Di as Yh, op as Yi, Pu as Yl, Pi as Ym, kc as Yn, Bd as Yo, ut as Yp, Yp as Yr, Ds as Ys, Ac as Yt, ce as Yu, Ob as Z, wu as Za, vd as Zc, Lt as Zd, hr as Zf, Oi as Zh, Fp as Zi, f as Zl, zi as Zm, sl as Zn, Vf as Zo, yt as Zp, _p as Zr, ic as Zs, Ad as Zt, de as Zu, Cx as _, vu as _a, mc as _c, ya as _d, kn as _f, En as _h, Cf as _i, Pc as _l, Ut as _m, Mc as _n, Io as _o, wr as _p, af as _r, dl as _s, bb as _t, Br as _u, Tx as a, dm as aa, oc as ac, Mr as ad, Or as af, na as ah, Vp as ai, Vc as al, st as am, Jd as an, v as ao, Ra as ap, Qd as ar, Bl as as, fb as at, ci as au, _x as b, fu as ba, Ts as bc, He as bd, nn as bf, On as bh, Df as bi, wl as bl, Bt as bm, gc as bn, bd as bo, Er as bp, cf as br, is as bs, Sb as bt, Jr as bu, ox as c, Zp as ca, xs as cc, Ae as cd, Dn as cf, ua as ch, mm as ci, rl as cl, pt as cm, Zd as cn, ad as co, Si as cp, tf as cr, Bc as cs, kb as ct, kr as cu, $b as d, Tp as da, Os as dc, ha as dd, qn as df, _a as dh, lm as di, hl as dl, u as dm, b as dn, Ro as do, Yt as dp, qp as dr, $c as ds, yb as dt, Lr as du, Cp as ea, Ys as ec, ba as ed, Aa as ef, Wi as eh, bp as ei, kd as el, tn as em, du as en, j as eo, er as ep, Ic as er, sm as es, jb as et, ni as eu, lx as f, rp as fa, gs as fc, Pa as fd, Un as ff, fa as fh, vf as fi, ul as fl, zt as fm, cl as fn, No as fo, Kt as fp, Ep as fr, Yc as fs, Cb as ft, Qr as fu, bx as g, Eu as ga, hs as gc, se as gd, mn as gf, un as gh, Sf as gi, gl, et as gm, Qc as gn, Cd as go, Xn as gp, rf as gr, Il as gs, zb as gt, zr as gu, cx as h, Ld as ha, _s as hc, ma as hd, In as hf, Da as hh, xf as hi, S as hl, At as hm, Zc as hn, Fo as ho, hi as hp, pm as hr, Pl as hs, Ib as ht, Nr as hu, wx as i, um as ia, fs as ic, Ca as id, Gr as if, Gi as ih, Bp as ii, Hc as il, Pt as im, qd as in, gd as io, Ln as ip, bl as ir, Uo as is, db as it, ii as iu, Mx as j, T as ja, Lu as jc, Ba as jd, Vn as jf, fn as jh, Nf as ji, Ul as jl, Xe as jm, So as jn, L as jo, Sr as jp, im as jr, Ho as js, Ws as jt, _i as ju, Hb as k, Yl as ka, Fl as kc, Vr as kd, rr as kf, Qn as kh, jf as ki, Al as kl, dt as km, Fc as kn, R as ko, Be as kp, em as kr, Xo as ks, Bo as kt, xi as ku, ex as l, lp as la, sc as lc, Ee as ld, Qt as lf, da as lh, hm as li, Uc as ll, tt as lm, Wc as ln, Fd as lo, Jt as lp, nf as lr, Xc as ls, pb as lt, Wr as lu, ix as m, Rd as ma, As as mc, Ie as md, Fn as mf, Oa as mh, bf as mi, pl as ml, an as mm, ll as mn, zo as mo, Na as mp, fm as mr, os as ms, Tb as mt, Yr as mu, Px as n, yp as na, cc as nc, xa as nd, Ma as nf, ea as nh, Lp as ni, jc as nl, rt as nm, yu as nn, Su as no, t as np, al as nr, Ll as ns, Mb as nt, ai as nu, Qb as o, Rf as oa, Ns as oc, De as od, oi as of, aa as oh, Rp as oi, Kc as ol, jt as om, Yd as on, Wo as oo, Ua as op, $d as or, zl as os, ub as ot, ri as ou, Vb as p, zf as pa, ws as pc, pa as pd, Jn as pf, Ea as ph, yf as pi, ml as pl, $t as pm, ol as pn, Po as po, La as pp, Dp as pr, as as ps, wb as pt, Ir as pu, Sx as q, Du as qa, fd as qc, te as qd, Hi as qf, za as qh, Wp as qi, Fu as ql, ji as qm, dd as qn, Zl as qo, Je as qp, Up as qr, Ms as qs, tc as qt, _e as qu, Zb as r, cp as ra, Is as rc, Sa as rd, ja as rf, Yi as rh, xp as ri, qc as rl, Nt as rm, hu as rn, Pd as ro, nr as rp, Co as rr, Rl as rs, Pb as rt, li as ru, ax as s, Xp as sa, Cs as sc, ke as sd, ti as sf, la as sh, zp as si, zc as sl, ft as sm, Xd as sn, Vo as so, bi as sp, ef as sr, Rc as ss, Eb as st, Kr as su, Fx as t, vp as ta, ys as tc, he as td, ka as tf, Ui as th, Ip as ti, Od as tl, It as tm, ru as tn, Tu as to, Bn as tp, vl as tr, fl as ts, Nb as tt, ui as tu, Bb as u, wp as ua, Fs as uc, Oe as ud, yn as uf, va as uh, cm as ui, Dc as ul, ct as um, hc as un, Lo as uo, qt as up, Kp as ur, x as us, hb as ut, $r as uu, gx as v, mu as va, ms as vc, Le as vd, bn as vf, vn as vh, wf as vi, El as vl, _t as vm, Gc as vn, yd as vo, Cr as vp, sf as vr, Tc as vs, xb as vt, qr as vu, kx as w, pu as wa, Oo as wc, Hr as wd, i as wf, sn as wh, Af as wi, C as wl, Ht as wm, jl as wn, Ko as wo, Nn as wp, rm as wr, ss as ws, Ab as wt, Xr as wu, Ox as x, A as xa, Ls as xc, Ta as xd, en as xf, Cn as xh, Ef as xi, Cl as xl, mt as xm, xc as xn, xd as xo, Tr as xp, Qp as xr, us as xs, gb as xt, jr as xu, fx as y, gu as ya, vs as yc, d as yd, Zt as yf, xn as yh, Tf as yi, xl as yl, qe as ym, Lc as yn, g as yo, Ce as yp, of as yr, Xs as ys, Db as yt, Ar as yu, tx as z, Gl as za, Gu as zc, wt as zd, Ri as zf, dr as zh, Lf as zi, Zf as zl, ae as zm, Hu as zn, Td as zo, Ve as zp, _f as zr, Sc as zs, cs as zt, Fa as zu };
